(function () {
  'use strict';

  angular
    .module('webapp', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ui.sortable',
        'ui.router',
        'ui.bootstrap',
        'toastr',
        'xeditable',
        'ui.tinymce',
        'ngFileUpload',
        'angularMoment',
        'ui.select',
        'nvd3',
        'fsm',
        'smoothScroll',
        'AngularPrint'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('LoginWithTokenController', LoginWithTokenController);

  /** @ngInject */
  function LoginWithTokenController($state, $stateParams, Principal, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.title = undefined;
    vm.error = undefined;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      if (Principal.isAuthenticated()) {
        alerts.info("Forgot Password Login", "Already logged in");
        $state.go("personal-dash");
      } else if ($stateParams.org && $stateParams.token) {
        vm.title = "Attempting login...";
        Principal.loginWithToken($stateParams.org, $stateParams.token).then(function(data) {
          vm.title = "Looks like it worked, logged in!!";
          alerts.info("Forgot Password Login", "Logged in");
          $state.go("user-settings");
        }, function(err){
          if (err.status == 401) {
            vm.title = "Failed to log in";
            vm.error = "Reset code has probably expired";
          } else {
            vm.title = "Error verifying token.";
            vm.error = err;
            alerts.error("Forgot Password Login", "Failed to log in", err);
          }

        });

      } else {
        alerts.error("Forgot Password Login", "Missing essential data (org and token required), please try again");
        $state.go("forgot-password");
      }
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------



  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, $state, $stateParams, Principal, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.subSubSubTitle = "I am a sub sub sub title";
    vm.fieldsNotReady = fieldsNotReady;
    vm.loginAction = loginAction;
    vm.loginError = "";
    vm.clicked = false;
    vm.organization_slug = "";
    vm.username = "";
    vm.password = "";
    vm.remember = false;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      if ($stateParams.org) {
        vm.organization_slug = $stateParams.org;
      }
      Principal.identity().then(function(id){
        if (id) {
          $state.go("personal-dash");
        }
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function fieldsNotReady() {
        return ! (vm.organization_slug && vm.username && vm.password);
    }

    function loginAction() {
      if (fieldsNotReady()) {
        console.log("Fields aren't ready... bye");
        return;
      }
      console.log("I am logging in: org=", vm.organization_slug, " username=", vm.username, " password=", vm.password);
      Principal.login(vm.organization_slug, vm.username, vm.password, vm.remember).then(function(data) {
        $state.go("personal-dash");
        alerts.info("Login", "Successfully logged in");
        return data;
      }, function(err){
        //alerts.error("Login", "Failed to login");
        if (err.status == 401) {
          vm.loginError = "Wrong username or password";
        } else {
          vm.loginError = err.data;
        }
        return err;
      });

    }


  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController($log, $state, $stateParams, Principal, Password, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.fieldsNotReady = fieldsNotReady;
    vm.forgotAction = forgotAction;
    vm.org = "";
    vm.email_sent = false;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      Principal.identity().then(function(id){
        if (id) {
          $state.go("personal-dash");
        }
      });
      if ($stateParams.org) {
        vm.org = $stateParams.org;
      }
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function fieldsNotReady() {
        return ! (vm.org && vm.email );
    }

    function forgotAction() {
      if (fieldsNotReady()) {
        console.log("Fields aren't ready... bye");
        return;
      }

      Password.sendPasswordReset(vm.org, vm.email, 'reset').then(function(data) {
        vm.email_sent = true;
        alerts.info("Password Reset Request", "Reset Request Sent");
        return data;
      }, function(err){
        alerts.error("Password Reset Request", "Failed to send Request", err);
        return err;
      });

    }


  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('OrganizationUploadsController', OrganizationUploadsController);

  /** @ngInject */
  function OrganizationUploadsController($http, $timeout, $rootScope, Upload, Principal) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.organization = undefined;
    vm.principal = Principal;
    vm.save = save;

    vm.uploadLogo = uploadLogo;
    vm.removeOrgLogo = removeOrgLogo;
    vm.orgLogoFile = new Blob([], {type:''});
    vm.orgLogo = '';


    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      $http.get("/api/organization").then(function(r){
        vm.organization = r.data.organization;
      }, function(e){
        console.log("Error getting organization");
      });
      vm.orgLogo = '/api/organization/image';
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function save() {
      //$http.put("/api/organization", vm.organization).then(function(r){
      //  console.log("Organization has been updated! r=", r);
      //}, function(e){
      //  console.log("Error writing organization, e=", e);
      //});
    }


    function removeOrgLogo() {
      vm.orgLogoFile = new Blob([], {type:'remove'});
      vm.orgLogo = null;
    }

    function uploadLogo(file) {
      vm.errorMsg = "";
      if (!file) { file = {}; }
      file.upload = Upload.upload({
        url: '/api/organization/image',
        data: {file: file}
      });

      file.upload.then(function (response) {
        $timeout(function () {
          file.result = response.data;
          $rootScope.$emit("logo-update");
        });
      }, function (response) {
        if (response.status > 0) {
          file.progress = undefined;
          vm.errorMsg = response.status + ': ' + response.data;
        }
      }, function (evt) {
        // Math.min is to fix IE which reports 200% sometimes
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('EditTenantsController', EditTenantsController);

  /** @ngInject */
  function EditTenantsController($log, $window, $http, $uibModal, statusFactory, tenantFactory, Principal, Password, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.subSubSubTitle = "";
    vm.tenants = undefined;
    vm.statuses = undefined;
    vm.selected_status = undefined;
    vm.organization = undefined;

    vm.currentAdmin = {username: undefined, email: undefined};
    vm.currentTenant = undefined;
    vm.selectTenant = selectTenant;
    vm.editorHeight = $window.innerHeight * .6;
    vm.isActive = isActive;
    vm.confirmRemove = confirmRemove;
    vm.cancelAction = cancelAction;
    vm.saveOrNewAction = saveOrNewAction;
    vm.saveOrNewString = saveOrNewString;
    vm.saveOrNewTitle = saveOrNewTitle;

    vm.canSaveOrNew = canSaveOrNew;
    vm.canCancel = canCancel;
    vm.canRemove = canRemove;
    vm.switchToThisTenant = switchToThisTenant;
    vm.isEditorVisible = isEditorVisible;
    vm.createTenant = createTenant;


    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      tenantFactory.get().then(function(tenants){
        vm.tenants = tenants;
      });
      statusFactory.get().then(function(statuses){
        vm.statuses = statuses;
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function selectTenant(tenant) {
      vm.currentTenant = angular.copy(tenant);  // this is from the admin tenants db
      $http.get("/api/tenant-organization/" + tenant.id).then(function(r){
        vm.currentCompany = r.data.organization;  // this is from the organization's specific namespace.organizations table
        vm.selected_status = {'value': vm.currentCompany.status};  // set the default
      }, function(e){
        console.log("Error getting organization");
      });
    }

    function confirmRemove() {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete Organization " + vm.currentCompany.name + "?";
          },
          msg: function() {
            return "Delete Organization " + vm.currentCompany.name + ", with domain " + vm.currentCompany.slug + "?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        removeAction();
      }, function (e) {
        alerts.error("Delete Tenant", "Failed to delete tenant", e);
        $log.debug("No delete for you!");
      });
    }

    function isActive(tenant) {
      return vm.currentTenant && tenant.id == vm.currentTenant.id;
    }

    function cancelAction() {
      vm.currentTenant = undefined;
      vm.currentCompany = undefined;
      vm.currentAdmin = {username: undefined, email: undefined};
    }

    function saveOrNewAction() {
      if (vm.currentTenant) {
        if (vm.currentTenant.id) {
          // before we save the obj, we have to patch in the status here
          var org = jQuery.extend(true, {}, vm.currentCompany,
            {slug: vm.currentTenant.organization_slug},
            {status: vm.selected_status.value} );  // copy the object, layer in our status from our silly dropdown box

          $http.put("/api/tenant-organization/" + vm.currentTenant.id, {tenant: vm.currentTenant, organization: org}).then(function(r){
            alerts.info("Organizations", "Successfully saved organization");
            //cancelAction();
            tenantFactory.refresh().then(function(tenants){
              vm.tenants = tenants;
            });
          }, function(e){
            alerts.error("Organizations", "Error saving organization", e);
            console.log("Error editing organization");
          });

        } else {  // THIS IS A NEW ORG
          var data = {
            name: vm.currentCompany.name,
            organization_slug: vm.currentTenant.organization_slug,
            status: vm.selected_status.value,
            admin_account: vm.currentAdmin
          };

          $http.post("/api/tenant-organization", data).then(function(r){
            alerts.info("Organizations", "Successfully created new organization and admin user");
            Password.sendPasswordReset(vm.currentTenant.organization_slug, vm.currentAdmin.email, 'welcome').then(function(data) {
              console.log("done sending password reset, data=", data);
              alerts.info("Organizations", "Successfully sent password reset to new user");
              tenantFactory.refresh().then(function(tenants){
                vm.tenants = tenants;
                cancelAction();
              });
            }, function(err){
              alerts.error("Organizations", "Error resetting new admin's password", err);
              console.error("Failed to send password reset: ", err);
            });

          }, function(e){
            alerts.error("Organizations", "Error creating organization", e);
            console.log("Error creating tenant");
          });
        }
      }
    }

    function isEditorVisible() {
      return vm.currentTenant;
    }

    function createTenant() {
      vm.currentTenant = {};
      vm.currentCompany = {};
      vm.currentAdmin = {username: undefined, email: undefined};
    }

    function canSaveOrNew() {
      return (vm.currentTenant && vm.currentTenant.id) ||
        (vm.currentCompany &&
        vm.currentCompany.name &&
        vm.currentTenant &&
        vm.currentTenant.organization_slug &&
        vm.currentAdmin &&
        vm.currentAdmin.email &&
        vm.currentAdmin.username) ;
    }

    function canCancel() {
      return vm.currentTenant;
      //return (vm.currentTenant && vm.currentTenant.id) ||
        //(vm.currentCompany && vm.currentCompany.name) ||
        //(vm.currentTenant && vm.currentTenant.organization_slug) ||
        //(vm.currentAdmin && (vm.currentAdmin.email || vm.currentAdmin.username ));
    }

    function canRemove() {
      return (vm.currentTenant && vm.currentTenant.id);
    }

    function saveOrNewString() {
      return (vm.currentTenant && vm.currentTenant.id) ? "Save" : "New";
    }

    function saveOrNewTitle() {
      return (vm.currentTenant && vm.currentTenant.id) ? "Modifying" : "Creating";
    }

    function removeAction() {
      $http.delete("/api/tenant-organization/" + vm.currentTenant.id).then(function(r){
        alerts.info("Organizations", "Successfully deleted organization");
        cancelAction();
        tenantFactory.refresh().then(function(tenants){
          vm.tenants = tenants;
        });
      }, function(e){
        alerts.error("Organizations", "Error deleting organization", e);
        console.log("Error deleting tenant");
      });
    }

    function switchToThisTenant() {
      Principal.switchTenant(vm.currentTenant.id).then(function(r) {
        $window.location.reload();
        console.log("Just switched to current tenant")
      }, function(e) {
        alerts.error("Organization Switch", "Failed to switch to a different organization", e);
        console.log("Failed to switch organization");
      });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('InstanceSettingsController', InstanceSettingsController);

  /** @ngInject */
  function InstanceSettingsController($http, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------
    vm.settings = undefined;
    vm.cancel = cancel;
    vm.save = save;

    vm.time_options = [
      {'value': 60 * 60,                'name': '1 hour'},
      {'value': 60 * 60 * 2,            'name': '2 hours'},
      {'value': 60 * 60 * 6,            'name': '6 hours'},
      {'value': 60 * 60 * 24,           'name': '1 day'},
      {'value': 60 * 60 * 24 * 7,       'name': '1 week'},
      {'value': 60 * 60 * 24 * 28,      'name': '1 month'},
      {'value': 60 * 60 * 24 * 28 * 6,  'name': '6 months'}
    ];

    vm.time_value_to_name_map = {};

    for (var i=0; i<vm.time_options.length; i++) {
      vm.time_value_to_name_map[vm.time_options['value']] = vm.time_options['name'];
    }

    function getTimeDescription(t) {
      var retval = vm.time_value_to_name_map[t];
      if (! retval) {
        return t + " seconds";
      }
      return retval;
    }

    vm.selected_forgot_password_life = vm.time_options[0];
    vm.selected_welcome_password_life = vm.time_options[0];

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function refresh() {
      $http.get("/api/instance-settings").then(function(r){

        vm.settings = r.data.settings;
        vm.selected_forgot_password_life = {'value': vm.settings.forgot_password_life, 'name': getTimeDescription(vm.settings.forgot_password_life)};
        vm.selected_welcome_password_life = {'value': vm.settings.welcome_password_life, 'name': getTimeDescription(vm.settings.welcome_password_life)};
      }, function(e){
        alerts.error("Instance Settings", "Failed to fetch org settings", e);
      });
    }

    function activate() {
      refresh();
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function cancel() {
      refresh();
    }

    function save() {
      vm.settings.forgot_password_life = vm.selected_forgot_password_life.value;
      vm.settings.welcome_password_life= vm.selected_welcome_password_life.value;
      $http.post('/api/instance-settings', vm.settings).then(function(r) {
        alerts.info("Instance Settings", "Successfully saved organization settings");
        refresh();
      }, function(e) {
        alerts.error("Instance Settings", "Error saving organization settings", e);
        refresh();
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('OrganizationDivisionsController', OrganizationDivisionsController);

  /** @ngInject */
  function OrganizationDivisionsController($http, $window, $uibModal, allDivisionFactory, statusFactory, Principal, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.principal = Principal;
    vm.divisions = undefined;
    vm.statuses = undefined;
    vm.isActive = isActive;
    vm.setActive = setActive;
    vm.currentDivision = undefined;
    vm.selected_status = undefined;
    vm.saveOrNewAction = saveOrNewAction;
    vm.confirmRemove = confirmRemove;
    vm.cancelAction = cancelAction;
    vm.saveOrNewTitle = saveOrNewTitle;
    vm.saveOrNewString = saveOrNewString;
    vm.isEditorVisible = isEditorVisible;
    vm.createDivision = createDivision;


    vm.editorHeight = $window.innerHeight * .6;


    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function refreshDivision() {
      vm.currentDivision = undefined;
      allDivisionFactory.refresh().then(function(divisions){
        vm.divisions = divisions;
      });
    }

    function activate() {
      allDivisionFactory.get().then(function(divisions) {
        vm.divisions = divisions;
      });
      statusFactory.get().then(function(statuses){
        vm.statuses = statuses;
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------
    function confirmRemove(o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal-select.html',
        controller: 'ConfirmModalSelectCtrl',
        resolve: {
          title: function() {
            return "Delete Division " + o.name + "?";
          },
          msg: function() {
            return "Delete Division " + o.name + "?";
          },
          items: function() {
            return allDivisionFactory.collection;
          },
          display_attribute: function() {
            return 'name';
          },
          select_message: function() {
            return "Select a superseding division to replace " + o.name;
          }

        }
      });
      modalInstance.result.then(function (selected_item) {
        removeAction(o, selected_item);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function isActive(division) {
      return vm.currentDivision && division.id == vm.currentDivision.id;
    }

    function setActive(division) {
      vm.currentDivision = division;
      vm.selected_status = {'value': vm.currentDivision.status};  // set the default
    }

    function cancelAction() {
      vm.currentDivision = undefined;
    }

    function isValidRecord(division) {
      if (!division.name){
        console.log("name missing")
        return false;
      }
      if (!division.status) {
        console.log("status missing")
        return false;
      }
      return true;
    }

    function removeAction(division, selectedSuccessor) {
      if (vm.currentDivision && vm.currentDivision.id) {
        $http.post('/api/admin-division/' + vm.currentDivision.id, {successor_id: selectedSuccessor.id}).then(function(r) {
          console.log("Successfully removed the division: ", r);
          alerts.info("Divisions", "Successfully deleted division");
          refreshDivision();
        }, function(e) {
          alerts.error("Divisions", "Error while deleting division", e);
          refreshDivision();
          console.log("Failed to remove the division: ", e);
        });
      }
    }

    function isEditorVisible() {
      return vm.currentDivision;
    }

    function createDivision() {
      vm.currentDivision = {};
    }

    function saveOrNewAction() {
      if (vm.currentDivision) {
        var division = jQuery.extend(true, {}, vm.currentDivision, {status: vm.selected_status ? vm.selected_status.value : null} );  // copy the object, layer in our status from our silly dropdown box
        if (isValidRecord(division)) {
          if (division.id) {
            console.log("I am updating a division: ", division);

            $http.put('/api/admin-division/' + division.id, division).then(function(r) {
              console.log("Successfully updated the division: ", r);
              alerts.info("Divisions", "Successfully saved division");

              //refreshDivision();
              allDivisionFactory.refresh().then(function(divisions){
                vm.divisions = divisions;
              });
            }, function(e) {
              alerts.error("Divisions", "Error saving division", e);

              console.log("Failed to update the division: ", e);
              refreshDivision();
            });

            //return;
          } else {
            console.log("I am creating a division: ", division);

            $http.post('/api/admin-division', division).then(function(r) {
              console.log("Successfully created the division: ", r);
              alerts.info("Divisions", "Successfully created division");

              refreshDivision();
            }, function(e) {
              alerts.error("Divisions", "Failed to create division", e);

              console.log("Failed to create the refreshDivision: ", e);
              refreshDivision();
            });

            //return;
          }
        }
      } else {
        console.log("Please select or create a division first");
      }
    }

    function saveOrNewString() {
      return (vm.currentDivision && vm.currentDivision.id) ? "Save" : "New";
    }

    function saveOrNewTitle() {
      return (vm.currentDivision && vm.currentDivision.id) ? "Modifying" : "Creating";
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('OrganizationEditorController', OrganizationEditorController);

  /** @ngInject */
  function OrganizationEditorController($log, $http, Principal, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.organization = undefined;
    vm.principal = Principal;
    vm.save = save;
    vm.cancel = cancel;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      $http.get("/api/organization").then(function(r){
        vm.organization = r.data.organization;
      }, function(e){
        console.log("Error getting organization");
      });

    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function save() {
      if (vm.organization.name) {
        $http.put("/api/organization", vm.organization).then(function(r){
          vm.organization = r.data.organization;  // now update our data from the db
          alerts.info("Edit Company", "Successfully Saved Company");

        }, function(e){
          alerts.error("Edit Company", "Error Saving Company", e);
          console.log("Error writing organization, e=", e);
        });
      }

    }

    function cancel() {
      activate();
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('webapp')
    .controller('OrganizationAccountsController', OrganizationAccountsController);

  /** @ngInject */
  function OrganizationAccountsController($filter, $q, $log, $http, $window, $uibModal, accountFactory, statusFactory, divisionFactory, Principal, Password, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.principal = Principal;
    vm.divisions = undefined;
    vm.statuses = undefined;
    vm.isActive = isActive;
    vm.setActive = setActive;
    vm.currentAccount = undefined;
    vm.selected_status = undefined;
    vm.selected_division = undefined;
    vm.selected_reports_to_account = undefined;
    vm.saveOrNewAction = saveOrNewAction;
    vm.resetEditorFields = resetEditorFields;
    //vm.removeAction = removeAction;
    vm.saveOrNewTitle = saveOrNewTitle;
    vm.saveOrNewString = saveOrNewString;
    vm.isAdminButtonText = isAdminButtonText;
    vm.sendPasswordReset = sendPasswordReset;
    vm.isEditorVisible = isEditorVisible;
    vm.createNewUser = createNewUser;
    vm.confirmRemove = confirmRemove;

    //vm.thetype = function() {
    //  return typeof vm.currentAccount.is_admin;
    //};

    vm.editorHeight = $window.innerHeight * .75;

    activate();

    //function recalculateCurrentAccount(shouldReSelect) {
    //
    //}

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function refreshAccount(shouldReSelectUser) {
      //vm.currentAccount = undefined;
      accountFactory.refresh().then(function (accounts) {
        vm.accounts = accounts;
        //recalculateCurrentAccount();
        if (shouldReSelectUser && vm.currentAccount) {
          console.log("Old=", vm.currentAccount);
          vm.currentAccount = $filter('filter')(vm.accounts, {id: vm.currentAccount.id}, true);
          console.log("New=", vm.currentAccount);
        } else {
          vm.currentAccount = undefined;
        }
      });
    }

    function refreshAll() {
      vm.currentAccount = undefined;
      $q.all([
        divisionFactory.refresh().then(function (divisions) {
          vm.divisions = divisions;
        }),
        statusFactory.refresh().then(function (statuses) {
          vm.statuses = statuses;
        }),
        accountFactory.refresh().then(function (accounts) {
          vm.accounts = accounts;
        })
      ]).then(function (v) {
        console.log("Done with ALL")
      });
    }

    function isEditorVisible() {
      return vm.currentAccount;
    }

    function activate() {
      $q.all([
        divisionFactory.get().then(function (divisions) {
          console.log("done with div");

          vm.divisions = divisions;
        }),
        statusFactory.get().then(function (statuses) {
          console.log("done with stat");

          vm.statuses = statuses;
        }),
        accountFactory.get().then(function (accounts) {
          console.log("done with account");
          vm.accounts = accounts;
        })
      ]).then(function (v) {
        console.log("Done with ALL")
        resetEditorFields(); // prime all the fields
      });


    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------
    function confirmRemove(o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal-select.html',
        controller: 'ConfirmModalSelectCtrl',
        resolve: {
          title: function() {
            return "Delete User " + o.name + "?";
          },
          msg: function() {
            return "Delete User " + o.name + "(" + o.username + ")?";
          },
          items: function() {
            var myitems = [];
            for (var i=0; i<accountFactory.collection.length; i++) {
              if (accountFactory.collection[i].id != o.id) {
                myitems.push(accountFactory.collection[i]);
              }
            }
            return myitems;
          },
          display_attribute: function() {
            return 'name';
          },
          select_message: function() {
            return "Select a user which will take ownership for " + o.name;
          }

        }
      });
      modalInstance.result.then(function (selected_item) {
        removeAction(o, selected_item);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function createNewUser() {
      vm.currentAccount = {};
    }

    function isActive(account) {
      return vm.currentAccount && account.id == vm.currentAccount.id;
    }

    function setActive(account) {
      vm.currentAccount = angular.copy(account);
      vm.selected_status = {'value': account.status};
      vm.selected_division = {'id': account.division_id};
      vm.selected_reports_to_account = {'id': account.reports_to_account_id};
    }

    function resetEditorFields() {
      console.log("I am reset editor fields")
      vm.currentAccount = undefined;
      vm.selected_status = {'value': 'active'};
      vm.selected_division = {'id': divisionFactory.collection && divisionFactory.collection.length > 0 ? divisionFactory.collection[0].id : undefined};
      vm.selected_reports_to_account = undefined;
    }

    function isValidRecord(account) {
      if (!account.name) {
        console.log("name missing")
        return false;
      }
      if (!account.email) {
        console.log("email missing")
        return false;

      }
      if (!account.username) {
        console.log("username missing")
        return false;

      }
      //if (!account.title) {
      //  console.log("title missing")
      //  return false;
      //
      //}
      //if (!account.phone){
      //  console.log("phone missing")
      //  return false;
      //
      //}
      if (typeof(account.is_admin) != "boolean") {
        account.is_admin = false;
        //console.log(typeof(account.is_admin));
        //console.log("is_admin missing, we see")
        //return false;

      }
      if (!account.status) {
        account.status = 'active';
        //console.log("status missing")
        //return false;
      }
      if (!account.division_id) {
        //console.log("YOU PROVIDED NO DIVISION!!!!")
        alerts.error("Users", "Please set the division");
        return false;
      }
      return true;
    }

    function removeAction(currentAccount, selectedSuccessor) {
      if (currentAccount && currentAccount.id) {
        console.log("Hi, the successor=", selectedSuccessor);
        $http.post('/api/admin-user/' + currentAccount.id, {successor_id: selectedSuccessor.id}).then(function (r) {
          console.log("Successfully removed the account: ", r, " transferred responsibilities to ", selectedSuccessor);
          alerts.info("Accounts", "Successfully Deleted User");
          //refreshAccount(false);
          refreshAll();
        }, function (e) {
          alerts.error("Accounts", "Error Saving Comment", e);
          refreshAccount(false);
          console.log("Failed to remove the account: ", e);
        });
      }
    }

    function saveOrNewAction() {
      // TODO: before we save the obj, we have to patch in the status here
      //o.status = vm.selected_status.value;

      if (vm.currentAccount) {
        var account = jQuery.extend(true, {}, vm.currentAccount, {
          status: vm.selected_status ? vm.selected_status.value : null,
          division_id: vm.selected_division ? vm.selected_division.id : null,
          reports_to_account_id: vm.selected_reports_to_account ? vm.selected_reports_to_account.id : null
        });
        console.log("account=", account);
        if (isValidRecord(account)) {
          if (account.id) {
            // update the account
            console.log("I am updating an account: ", account);

            $http.put('/api/admin-user/' + account.id, account).then(function (r) {
              console.log("Successfully updated the account: ", r);
              alerts.info("Users", "Successfully Saved User");

              refreshAccount(true);
            }, function (e) {
              alerts.error("Users", "Error Saving User", e);
              console.log("Failed to update the account: ", e);
              refreshAccount();
            });

            //return;
          } else {
            // create the new account
            console.log("I am creating an account: ", account);

            $http.post('/api/admin-user', account).then(function (r) {
              alerts.info("Users", "Successfully Created User");
              console.log("Successfully created the account: ", r);
              refreshAccount(false);
            }, function (e) {
              alerts.error("Users", "Error Creating User", e);
              console.log("Failed to create the account: ", e);
              refreshAccount(false);
            });

            //return;
          }
        }
      }

      //console.log("I failed to create, you aren't ready!, ", vm.currentAccount);

      // copy the object, layer in our status from our silly dropdown box
      //console.log("Wish I was saving the record... account=", account);
      // NOTE: this save is to an api that only an admin can hit, because we modify their sensitive info like
      // title, is_admin, division, status, reports_to_account_id and description
      //$http.
    }

    function saveOrNewString() {
      return (vm.currentAccount && vm.currentAccount.id) ? "Save" : "New";
    }

    function saveOrNewTitle() {
      return (vm.currentAccount && vm.currentAccount.id) ? "Modifying" : "Creating";
    }

    function isAdminButtonText() {
      if (vm.currentAccount) {
        if (vm.currentAccount.is_admin) {
          return "Remove Admin Rights";
        } else {
          return "Grant Admin Rights";
        }
      }
      return "No record selected";
    }

    function sendPasswordReset(style) {
      Password.sendPasswordReset(Principal.current_org, vm.currentAccount.email, style).then(function (data) {
        alerts.info("Users", "Successfully Sent Password Reset");
        console.log("done sending password reset, data=", data);
      }, function (err) {
        alerts.error("Users", "Error Sending Password Reset", e);
        console.error("Failed to send password reset: ", err);
      });
    }

  }
})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('BusinessPlanOverviewController', BusinessPlanOverviewController);

  /** @ngInject */
  function BusinessPlanOverviewController($http, $q, $filter, Principal, swotFactory, ksfFactory, divisionFactory, ccFactory,
                                          accountFactory, swotOpportunityFactory, swotStrengthFactory, swotThreatFactory,
                                          swotWeaknessFactory, objectiveFactory, tacticFactory) {
    var vm = this;

    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------
    vm.principal = Principal;
    vm.thetime = new Date();

    vm.executive_summary = undefined;
    vm.mission_statement = undefined;
    vm.external_review = undefined;

    vm.swotOpportunity = swotOpportunityFactory;
    vm.swotStrength = swotStrengthFactory;
    vm.swotThreat = swotThreatFactory;
    vm.swotWeakness = swotWeaknessFactory;
    vm.objectives = [];

    vm.defaultLogo = undefined;
    vm.organization = undefined;
    vm.accountFactory = accountFactory;
    vm.swotFactory = swotFactory;
    vm.accounts = [];
    vm.showDivision = showDivision;
    vm.getAccounts = getAccounts;
    vm.getSwots = getSwots;
    vm.getCoreCompetencies = getCoreCompetencies;
    vm.getTactics = getTactics;
    vm.ksf = ksfFactory;
    vm.ccFactory = ccFactory;
    vm.division = divisionFactory;

    vm.divisions = [];

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {

      fetchDocument('executive-summary', 'Executive Summary').then(function(record){
        vm.executive_summary = record.body;
      });

      fetchDocument('mission-statement', 'Mission Statement').then(function(record){
        vm.mission_statement = record.body;
      });

      fetchDocument('external-environment-review', 'External Environment Review').then(function(record){
        vm.external_review = record.body;
      });

      $http.get('/api/instance-settings/default_logo_url').then(function(r){
        vm.defaultLogo = r.data.default_logo_url;
      }, function(e){
        alerts.error("Navigation", "Failed to fetch the default logo", e);
      });

      $http.get("/api/organization").then(function(r){
        vm.organization = r.data.organization;
      }, function(e){
        console.log("Error getting organization");
      });

      divisionFactory.get().then(function(divisions) {
        //vm.loading = false;
        vm.divisions = divisions;
      });

      $q.all([
        accountFactory.get(),
        objectiveFactory.get(),
        ksfFactory.get(),
        ccFactory.get(),
        accountFactory.get(),
        divisionFactory.get(),
        tacticFactory.get(),
        swotFactory.get(),
        objectiveFactory.get(),
        swotOpportunityFactory.get(),
        swotStrengthFactory.get(),
        swotThreatFactory.get(),
        swotWeaknessFactory.get()
      ]).then(function() {
        // *sort and set accounts
        vm.accounts = accountFactory.collection;
        vm.accounts.sort(function(a, b) {
          var c = compare(a['division_name'], b['division_name']);
          if (c == 0) {
            c = compare(a['name'], b['name']);
          }
          return c;
        });

        // *sort and set objectives
        vm.objectives = objectiveFactory.collection;
        vm.objectives.sort(function(a, b) {
          var c = compare(a['division_name'], b['division_name']);
          if (c == 0) {
            c = a['priority'] - b['priority'];
          }
          return c;
        });

      })
    }

    function compare(a, b) {
      a = (a && a.toLowerCase() || a);
      b = (b && b.toLowerCase() || b);

      if (a<b) {
        return -1;
      } else if (a>b) {
        return 1;
      } else {
        return 0;
      }
    }

    // FIXME: Copied from ksf.controller.js
    function showDivision(division_id) {
      var selected = $filter('filter')(vm.divisions, {id: division_id});
      return (division_id && selected.length) ? selected[0].name : 'Not set';
    }

    function getSwots(swot_ids) {
      var swots = [];
      if (! swot_ids)
        return swots;
      for (var i = 0; i<swot_ids.length; i++) {
        swots.push(swotFactory.getById(swot_ids[i]));
      }

      swots.sort(function(a, b) {
        return a['priority'] - b['priority'];
      });
      return swots;
    }

    function getCoreCompetencies(cc_ids) {
      var ccs = [];
      if (! cc_ids)
        return ccs;
      for (var i = 0; i<cc_ids.length; i++) {
        ccs.push(ccFactory.getById(cc_ids[i]));
      }

      ccs.sort(function(a, b) {
        return compare(a['description'], b['description']);
      });
      return ccs;
    }

    function getTactics(tactic_ids) {
      var tactics = [];
      if (! tactic_ids)
        return tactics;
      for (var i = 0; i<tactic_ids.length; i++) {
        tactics.push(tacticFactory.getById(tactic_ids[i]));
      }

      tactics.sort(function(a, b) {
        return compare(a['description'], b['description']);
      });
      return tactics;
    }

    function getAccounts(account_ids) {
      var accounts = [];
      if (! account_ids)
        return accounts;
      for (var i = 0; i<account_ids.length; i++) {
        accounts.push(accountFactory.getById(account_ids[i]));
      }

      accounts.sort(function(a, b) {
        return compare(a['name'], b['name']);
      });
      return accounts;
    }

    function fetchDocument(docType, description) {
      var deferred = $q.defer();
      $http.get('/api/' + docType).then(function(r){
        if (r.data.documents && r.data.documents.length > 0) {
          deferred.resolve(r.data.documents[0]);
        } else {
          deferred.reject("Document " + docType + " not found");
        }
      }, function(e) {
        deferred.reject(e);
        alerts.error("Fetching " + description + " documents", "Error while fetching " + description + " document", e);
      });
      return deferred.promise;
    }


  }
})();

/**
 * JQuery Organisation Chart Plugin.
 *
 * Author: Mark Lee
 * Copyright (C)2013-2015 Caprica Software Limited
 * http://www.capricasoftware.co.uk
 *
 * Contributions by: Paul Lautman <paul.lautman at gmail.com>
 *
 * This software is licensed under the Creative Commons Attribution-ShareAlike 3.0 License,
 * see here for license terms:
 *
 *     http://creativecommons.org/licenses/by-sa/3.0
 */
(function($) {

    $.fn.orgChart = function(options) {
        var opts = $.extend({}, $.fn.orgChart.defaults, options);

        return this.each(function() {
            var $chartSource = $(this);
            // Clone the source list hierarchy so levels can be non-destructively removed if needed
            // before creating the chart
            $this = $chartSource.clone();
            if (opts.levels > -1) {
                $this.find("ul").andSelf().filter(function() {return $chartSource.parents("ul").length+1 > opts.levels;}).remove();
            }
            // Store the original element
            $this.data("chart-source", $chartSource);
            // Build the chart...
            var $container = $("<div class='" + opts.chartClass + "'/>");
            if (opts.interactive) {
                $container.addClass("interactive");
            }
            // The chart may be sourced from either a "ul", or an "li" element...
            var $root;
            if ($this.is("ul")) {
                $root = $this.find("li:first");
            }
            else if ($this.is("li")) {
                $root = $this;
            }
            if ($root) {
                buildNode($root, $container, 0, 0, opts);
                // Special case for any hyperlink anchor in the chart to prevent the click on the node itself from propagating
                $container.find("div.node a").click(function(evt) {
                    evt.stopImmediatePropagation();
                });
                if(opts.replace) {
                    opts.container.empty();
                }
                opts.container.append($container);
            }
        });
    };

    $.fn.orgChart.defaults = {
        container  : $("body"),
        depth      : -1,
        levels     : -1,
        showLevels : -1,
        stack      : false,
        chartClass : "orgChart",
        hoverClass : "hover",
        nodeText   : function($node) {return $node.clone().children("ul,li").remove().end().html();},
        interactive: false,
        fade       : false,
        speed      : "slow",
        nodeClicked: function($node) {},
        copyClasses: true,
        copyData   : true,
        copyStyles : true,
        copyTitle  : true,
        replace    : true
    };

    function buildNode($node, $appendTo, level, index, opts) {
        var $table = $("<table cellpadding='0' cellspacing='0' border='0'/>");
        var $tbody = $("<tbody/>");

        // Make this node...
        var $nodeRow = $("<tr/>").addClass("nodes");
        var $nodeCell = $("<td/>").addClass("node").attr("colspan", 2);
        var $childNodes = $node.children("ul:first").children("li");
        if ($childNodes.length > 1) {
            $nodeCell.attr("colspan", $childNodes.length*2);
        }

        var $adjunct = $node.children("adjunct").eq(0);
        if ($adjunct.length > 0) {
            var $adjunctDiv = $("<div>").addClass("adjunct node").addClass("level"+level).addClass("node"+index).addClass("level"+level+"-node"+index).append(opts.nodeText($adjunct));
            $adjunctDiv.appendTo($nodeCell);
            var $linkDiv = $("<div>").addClass("adjunct-link");
            $linkDiv.appendTo($nodeCell);
            $adjunct.remove();
        }

        var $heading = $("<h2>").html(opts.nodeText($node));
        var $nodeDiv = $("<div>").addClass("node").addClass("level"+level).addClass("node"+index).addClass("level"+level+"-node"+index).append($heading);

        // Copy classes from the source list to the chart node
        if (opts.copyClasses) {
            $nodeDiv.addClass($node.attr("class"));
        }

        // Copy data from the source list to the chart node
        if (opts.copyData) {
            $nodeDiv.data($node.data());
        }

        // Copy CSS styles from the source list to the chart node
        if (opts.copyStyles) {
            $nodeDiv.attr("style", $node.attr("style"));
        }

        // Copy the title attribute from the source list to the chart node
        if (opts.copyTitle) {
            $nodeDiv.attr("title", $node.attr("title"));
        }

        $nodeDiv.data("orgchart-level", level).data("orgchart-node", $node);

        $nodeCell.append($nodeDiv);
        $nodeRow.append($nodeCell);
        $tbody.append($nodeRow);

        $nodeDiv.click(function() {
            var $this = $(this);
            opts.nodeClicked($this.data("orgchart-node"), $this);
            if (opts.interactive) {
                var $row = $this.closest("tr");
                if ($row.next("tr").is(":visible")) {
                    if (opts.fade) {
                        $row.nextAll("tr").fadeOut(opts.speed);
                    }
                    else {
                        $row.nextAll("tr").hide();
                    }
                    $this.removeClass("shownChildren").addClass("hiddenChildren");
                }
                else {
                    $this.removeClass("hiddenChildren").addClass("shownChildren");
                    if (opts.fade) {
                        $row.nextAll("tr").fadeIn(opts.speed);
                    }
                    else {
                        $row.nextAll("tr").show();
                    }
                }
            }
        });

        if ($childNodes.length > 0) {
            if (opts.depth == -1 || level+1 < opts.depth) {
                var $downLineRow = $("<tr/>").addClass("lines");
                var $downLineCell = $("<td/>").attr("colspan", $childNodes.length*2);
                $downLineRow.append($downLineCell);

                var $downLineTable = $("<table cellpadding='0' cellspacing='0' border='0'>");
                $downLineTable.append("<tbody>");
                var $downLineLine = $("<tr/>").addClass("lines x");
                var $downLeft = $("<td>").addClass("line left");
                var $downRight = $("<td>").addClass("line right");
                $downLineLine.append($downLeft).append($downRight);
                $downLineTable.children("tbody").append($downLineLine);
                $downLineCell.append($downLineTable);

                $tbody.append($downLineRow);

                if ($childNodes.length > 0) {
                    $nodeDiv.addClass("hasChildren");
                    if (opts.showLevels == -1 || level < opts.showLevels-1) {
                        $nodeDiv.addClass("shownChildren");
                    }
                    else {
                        $nodeDiv.addClass("hiddenChildren");
                    }
                    if (opts.interactive) {
                        $nodeDiv.hover(function() {$(this).addClass(opts.hoverClass);}, function() {$(this).removeClass(opts.hoverClass)});
                    }
                }

                // Recursively make child nodes...
                var $linesRow = $("<tr/>").addClass("lines v");
                $childNodes.each(function() {
                    var $left = $("<td/>").addClass("line left top");
                    var $right = $("<td/>").addClass("line right top");
                    $linesRow.append($left).append($right);
                });
                $linesRow.find("td:first").removeClass("top");
                $linesRow.find("td:last").removeClass("top");
                $tbody.append($linesRow);
                var $childNodesRow = $("<tr/>");
                $childNodes.each(function(index) {
                    var $td = $("<td/>");
                    $td.attr("colspan", 2);
                    buildNode($(this), $td, level+1, index, opts);
                    $childNodesRow.append($td);
                });
                $tbody.append($childNodesRow);
            }
            else if (opts.stack) {
                var $stackNodes = $childNodes.clone();
                var $list = $("<ul class='stack'>").append($stackNodes).addClass("level"+level).addClass("node"+index).addClass("level"+level+"-node"+index);
                var $stackContainer = $("<div class='stack-container'>").append($list);
                $nodeDiv.after($stackContainer);
            }
        }

        if (opts.showLevels > -1 && level >= opts.showLevels-1) {
            $nodeRow.nextAll("tr").hide();
        }

        $table.append($tbody);
        $appendTo.append($table);
    };

})(jQuery);

'use strict';

(function(angular){
    var fsm = angular.module('fsm', []);
    
    fsm.directive('fsmStickyHeader', ["$timeout", function($timeout){
        return {
            restrict: 'EA',
            replace: false,
            scope: { 
                scrollBody: '=',
                scrollStop: '=',
                scrollableContainer: '=',
                contentOffset: '='
            },
            link: function(scope, element, attributes, control){
                var self = this;
                $timeout(function() {
                    var header = $(element, self);
                    var clonedHeader = null;
                    var content = $(scope.scrollBody);
                    var scrollableContainer = $(scope.scrollableContainer);
                    var contentOffset = scope.contentOffset || 0;
    
                    if (scrollableContainer.length === 0){
                        scrollableContainer = $(window);
                    }

                    function setColumnHeaderSizes() {
                        if (clonedHeader.is('tr') || clonedHeader.is('thead')) {
                            var clonedColumns = clonedHeader.find('th');
                            header.find('th').each(function (index, column) {
                                var clonedColumn = $(clonedColumns[index]);
                                clonedColumn.css( 'width', column.offsetWidth + 'px');
                            });
                        }
                    };

                    function determineVisibility(){
                        var scrollTop = scrollableContainer.scrollTop() + scope.scrollStop;
                        var contentTop = content.offset().top + contentOffset;
                        var contentBottom = contentTop + content.outerHeight(false);

                        if ( (scrollTop > contentTop) && (scrollTop < contentBottom) ) {
                            if (!clonedHeader){
                                createClone();    
                                clonedHeader.css({ "visibility": "visible"});
                            }
                            
                            if ( scrollTop < contentBottom && scrollTop > contentBottom - clonedHeader.outerHeight(false) ){
                                var top = contentBottom - scrollTop + scope.scrollStop - clonedHeader.outerHeight(false);
                                clonedHeader.css('top', top + 'px');
                            } else {
                                calculateSize();
                            }
                        } else {
                            if (clonedHeader){
                                /*
                                 * remove cloned element (switched places with original on creation)
                                 */
                                header.remove();
                                header = clonedHeader;
                                clonedHeader = null;

                                header.removeClass('fsm-sticky-header');
                                header.css({
                                    position: 'relative',
                                    left: 0,
                                    top: 0,
                                    width: 'auto',
                                    'z-index': 0,
                                    visibility: 'visible'
                                });
                            }
                        }
                    };
        
                    function calculateSize() {
                        clonedHeader.css({
                            top: scope.scrollStop,
                            width: header.outerWidth(),
                            left: header.offset().left
                        });
    
                        setColumnHeaderSizes();
                    };
                    
                    function createClone(){
                        /*
                         * switch place with cloned element, to keep binding intact
                         */
                        clonedHeader = header;
                        header = clonedHeader.clone();
                        clonedHeader.after(header);
                        clonedHeader.addClass('fsm-sticky-header');
                        clonedHeader.css({
                            position: 'fixed',
                            'z-index': 10000,
                            visibility: 'hidden'
                        });                
                        calculateSize();
                    };          
        
                    scrollableContainer.on('scroll.fsmStickyHeader', determineVisibility).trigger("scroll");
                    scrollableContainer.on('resize.fsmStickyHeader', determineVisibility);

                    scope.$on('$destroy', function() {
                        scrollableContainer.off('.fsmStickyHeader');
                    });
                });
            }
        };
    }]);
    
    fsm.directive('fsmMenu', ['$location', function ($location) {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, el, attrs) {
                var navigationMenu = angular.element(el);
                var menuTitles = navigationMenu.find('.fsm-menu-title');
                var menuItems = navigationMenu.find('[tc-menu-item]:visible');
                var activeMenu = 0;

                function menuOnClick(e) {
                    var menuTitle = angular.element(e.currentTarget);
                    // Find if our menu item has submenu items
                    var submenu = menuTitle.next('.fsm-sub-menu');

                    // If there is submenus, then we wan to either open or close the folder
                    submenu.slideToggle('fast', function () {
                        // swap the arrow from up to down, or vise-versa
                        var chevron = menuTitle.children('[class*=\'fa-chevron\']');
                        chevron.toggleClass('fa-chevron-down fa-chevron-up');

                        // Find the list of currently visible menu items for keyboarding through.
                        menuItems = navigationMenu.find('[tc-menu-item]:visible');
                    });

                }

                function menuOnKeydown(e) {
                    activeMenu = getCurrentMenuItem();

                    if (e.keyCode === 9) {
                        tabOutOfMenu(e);
                    } else if (e.keyCode === 13 || e.keyCode === 37 || e.keyCode === 39) {
                        triggerMenuItem(e);
                    } else if (e.keyCode === 38 || e.keyCode === 40) {
                        highlightMenuItem(e);
                    }
                }

                function tabOutOfMenu(e) {
                    if (e.shiftKey) {
                        $('[fsm-menu-button]').focus();
                    } else {
                        var firstTabItem = $('[tabindex=1]');

                        if (firstTabItem.length == 0) {
                            return;
                        } else {
                            firstTabItem.focus();
                        }
                    }

                    e.preventDefault();
                    e.stopPropagation();
                }

                function triggerMenuItem(e) {
                    e.currentTarget = $(menuItems[activeMenu]).children('a').first();
                    menuOnClick(e);
                }

                function highlightMenuItem(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (e.keyCode === 38) {
                        if (activeMenu > 0) {
                            $(menuItems[activeMenu - 1]).children('a').first().focus();
                        } else {
                            $(menuItems[menuItems.length - 1]).children('a').first().focus();
                        }
                    } else if (e.keyCode === 40) {
                        if (activeMenu < (menuItems.length - 1)) {
                            $(menuItems[activeMenu + 1]).children('a').first().focus();
                        } else {
                            $(menuItems[0]).children('a').first().focus();
                        }
                    }
                }

                function getCurrentMenuItem() {
                    var focusedMenu = navigationMenu.find(':focus');

                    if (focusedMenu.length === 1) {
                        return menuItems.index(focusedMenu.parent('[tc-menu-item]').first());
                    }

                    return menuItems.index(navigationMenu.find('[tc-menu-item].active').first());
                }

                function menuOnFocus(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    activeMenu = getCurrentMenuItem();
                    $(menuItems[activeMenu]).children('a').first().focus();
                }

                menuTitles.click(menuOnClick);
                navigationMenu.keydown(menuOnKeydown);
                navigationMenu.focus(menuOnFocus);

                scope.$watch(function () {
                    return $location.path();
                }, function (path) {
                    // grab all the a tags that start with #, indicating and angular route.
                    var allMenuItems = el.find('a[href^=\'#\']');

                    angular.forEach(allMenuItems, function (menuItem) {
                        var menu = angular.element(menuItem);
                        var link = menu.attr('href').split('#')[1];

                        if (path.indexOf(link) == 0) {
                            // activate the menu item
                            angular.element(menuItem.parentElement).addClass('active');

                            // open up the submenus if they are not open
                            var submenus = menu.parents('.fsm-sub-menu');
                            submenus.show();

                            // turn the chevrons up on the menu titles
                            var chevrons = submenus.prev().children('[class*=\'fa-chevron\']');
                            chevrons.removeClass('fa-chevron-down');
                            chevrons.addClass('fa-chevron-up');
                        } else {
                            angular.element(menuItem.parentElement).removeClass('active');
                        }
                    });

                    menuItems = navigationMenu.find('[tc-menu-item]:visible');
                });
            }
        }
    }]);

    fsm.directive('fsmMenuButton', function () {
        return {
            restrict: 'EA',
            replace: false,
            scope: {},
            link: function (scope, element, attributes, control) {
                var menuButton = $(element, this);

                menuButton.addClass('fsm-menu-button');
                menuButton.keydown(menuOnKeydown);
                $('body').keydown(bodyOnKeydown);

                function bodyOnKeydown(e) {
                    if (e.keyCode === 77 && e.ctrlKey && e.altKey) {
                        if (isMenuClosed()) {
                            menuOnClick();
                        }
                        $('[fsm-menu]').focus();
                    } else if (e.keyCode === 77 && e.ctrlKey) {
                        menuButton.focus();
                        menuOnClick();
                    }
                }

                function isMenuClosed() {
                    return $('body').hasClass('fsm-menu-toggle');
                }

                function menuOnClick() {
                    $('body').toggleClass('fsm-menu-toggle');
                    setMenuSpin();
                    setTimeout(setMenuSpin, 50);
                };

                function menuOnKeydown(e) {
                    if (e.keyCode === 32 || e.keyCode === 13) {
                        e.preventDefault();
                        e.stopPropagation();
                        menuOnClick();
                    }
                }

                function setMenuSpin() {
                    menuButton.find('.fsm-menu-button-open').toggleClass('fsm-spin-forward');
                    menuButton.find('.fsm-menu-button-close').toggleClass('fsm-spin-backward');
                };

                menuButton.on('click.fsmMenuButton', menuOnClick);

                scope.$on('$destroy', function() {
                    menuButton.off('.fsmMenuButton');
                });                
            }
        }
    });
    
    fsm.directive('fsmBigData', ['$filter', function ($filter) {
    
        return {
            restrict: 'AE',
            scope: {},
            replace: false,
            transclude: true,
            link: function (scope, element, attrs, controller, transclude) {
                var orderBy = $filter('orderBy');
                var currentPage = 0;
                var pagedDataName = attrs.fsmBigData.split(' of ')[0];
                var rightHandExpression = attrs.fsmBigData.split(' of ')[1];
                var pageSize = parseInt(rightHandExpression.split(' take ')[1], 10);
                var sourceData = rightHandExpression.split(' take ')[0];
                
                // Interesting things can be done here with the source object...
                // var displayGetter = $parse(sourceData);
                // var displaySetter = displayGetter.assign;
                // var results = orderBy(displayGetter(scope.$parent), sortColumns);
                // displaySetter(scope.$parent, results)
    
                var rawData = [];
                var sortedData = [];
                var pagedData = [];
                var page = $(window);
                var sortTypes = [ 'None', 'Ascending', 'Descending' ];
                var sortColumns = [];
        
                transclude(function (clone, transcludedScope) {

                    transcludedScope.sortTypes = sortTypes;

                    element.append(clone);
                    transcludedScope[pagedDataName] = pagedData;
    
                    function nextPage() {
                        var dataSlice = sortedData.slice(pageSize * currentPage, (pageSize * (currentPage + 1)));
                        if (dataSlice.length > 0) {
                            pagedData.push.apply(pagedData, dataSlice);
                            currentPage++;
                        }
                    }
                    
                    function renderData() {
                        if (sortColumns.length){
                            sortedData = orderBy(rawData, sortColumns);
                        }
                        else {
                            sortedData = rawData;
                        }
    
                        pagedData.length = 0;
                        currentPage = 0;
                        nextPage();
                    }
    
                    function addSortColumn(columnName, sortType) {
                        
                        // If this column is currently in the sort stack, remove it.
                        for (var i = 0; i < sortColumns.length; i ++){
                            if (sortColumns[i].indexOf(columnName) > -1) {
                                sortColumns.splice(i, 1);
                            }
                        }
                        
                        // Push this sort on the top of the stack (aka. array)
                        if (sortType > 0) {
                            var direction = '';
                            if (sortTypes[sortType] === 'Descending'){
                                direction = '-';
                            }
                            sortColumns.unshift(direction + columnName);
                        }
    
                        renderData();
                    }
    
                    function onPageScroll() {
                        var s = $(window).scrollTop();
                        var d = $(document).height();
                        var c = $(window).height();
                        var scrollPercent = (s / (d-c));
    
                        if (scrollPercent > 0.98) {
                            // We use scope.apply here to tell angular about these changes because 
                            // they happen outside of angularjs context... we're using jquery here
                            // to figure out when we need to load another page of data.
                            transcludedScope.$apply(nextPage);
                        }
                    }
        
                    transcludedScope.$parent.$watchCollection(sourceData, function (newData) {
                        if (newData){
                            rawData = newData;
                            renderData();
                        }
                    });
    
                    transcludedScope.addSortColumn = addSortColumn;

                    page.on('scroll.fsmBigData', onPageScroll).trigger('scroll');

                    transcludedScope.$on('$destroy', function() {
                        page.off('.fsmBigData');
                    });
                });
            }
        };
    }]);
    
    fsm.directive('fsmSort', [function () {
        var sortIconTemplate = '<i class="fa fa-sort"></i>';
    
        return {
            restrict: 'AE',
            replace: false,
            scope: {},
            link: function (scope, element, attrs) {
                var columnHeader = element;
                var columnName = attrs.fsmSort;
                var sortIcon = angular.element(sortIconTemplate);
                columnHeader.append('&nbsp;');
                columnHeader.append(sortIcon);
                var currentSortType = 0;
    
                function swapIcons(){
                    sortIcon.removeClass('fa-sort-desc fa-sort-asc fa-sort');
    
                    var classToAdd = 'fa-sort';
    
                    if (scope.$parent.sortTypes[currentSortType] === 'Ascending'){
                        classToAdd = 'fa-sort-asc';
                    } else if(scope.$parent.sortTypes[currentSortType] === 'Descending') {
                        classToAdd = 'fa-sort-desc';
                    }
    
                    sortIcon.addClass(classToAdd);
                };

                function applySort() {
                    // Find the kind of sort this should now be
                    currentSortType ++;
                    if (currentSortType == scope.$parent.sortTypes.length ){
                        currentSortType = 0;
                    }
    
                    scope.$apply( scope.$parent.addSortColumn(columnName, currentSortType) );
    
                    swapIcons();
                };
    
                columnHeader.css({ cursor: 'pointer' });
    
                columnHeader.on('click.fsmSort', applySort);

                columnHeader.on('keydown.fsmSort', function(e) {
                    if (e.keyCode === 13) {
                        applySort();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });

                scope.$on('$destroy', function() {
                    columnHeader.off('.fsmSort');
                });
            }
        };
    }]);
})(window.angular);

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('UserSettingsController', UserSettingsController);

  /** @ngInject */
  function UserSettingsController($log, $http, Principal, $state, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------
    vm.DEFAULT_PASS = "**********";
    vm.subSubSubTitle = "Change your user settings";
    vm.principal = Principal;
    vm.user = undefined;
    vm.orig_user = undefined;
    //vm.selected = undefined;
    vm.save = save;
    vm.cancel = cancel;
    vm.divisions = undefined;
    vm.canCancel = canCancel;
    vm.canSave = canSave;
    vm.messages = "";
    vm.isExistingValid = isExistingValid;
    //vm.selected_division = undefined;
    vm.token_based_session_timeout = undefined;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      $http.get("/api/user").then(function(r){
        console.log("got api/user: ", r);
        vm.user = angular.copy(r.data.user);
        vm.user.password = vm.DEFAULT_PASS;
        vm.user.password2 = vm.DEFAULT_PASS;
        vm.orig_user = r.data.user;
        vm.token_based_session_timeout = vm.orig_user.token_based_session_timeout;
        if (vm.token_based_session_timeout) {
          alerts.infoLong("Please Set Password!", "Please change your password, this session will expire in just a few minutes.");
        }
        //vm.selected_division = {'id': vm.user.division_id};  // set the default
      }, function(e){
        console.log("Error getting user");
      });
      // NOTE: this must be user-divisions, so that we don't get the wrong divisions if we are org-switched
      $http.get("/api/user-divisions").then(function(r){
        console.log("got api/user-division: ", r);
        vm.divisions = r.data.divisions;
      }, function(e){
        console.log("Error getting user's division");
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function isExistingValid() {
      var v = !vm.user ||
        !vm.orig_user ||
        (vm.user.password == vm.DEFAULT_PASS) ||
        (vm.user.password != vm.user.password2) ||
        (vm.user.existing_password || vm.token_based_session_timeout);
      return v;
    }

    function save() {
      //var u = vm.user;
      // we have to patch in the division_id here
      //u.division_id = vm.selected_division.id;
      if (vm.user.password == vm.DEFAULT_PASS) {
        delete vm.user.password;
        delete vm.user.password2;
        console.log("default password already set")
      }

      if (vm.user.password != vm.user.password2) {
        //vm.messages="Your passwords must match!";
        //console.log("password not verified");
        alerts.warning("User Settings", "Passwords mismatch");
        return;
      }

      delete vm.user.token_based_session_timeout;
      $http.put("/api/user", vm.user).then(function (r) {
        console.log("User has been updated! r=", r);
        activate();
        vm.messages = "";
        for (var i=0; i< r.data.details.length; i++) {
          vm.messages = vm.messages + "\n" + r.data.details[i];
        }
        if (Principal.popLastActionLoginByToken()) {
          // Last action was to login by token, so we need to jump to dashboard
          $state.go("personal-dash");
        }
        alerts.info("User Settings", "Successfully updated: " + vm.messages);
      }, function (e) {
        alerts.error("User Settings", "Error writing user", e);
        vm.messages = e;
      });
    }

    function cancel() {
      activate();
    }

    function canCancel() {
      var cancelable = vm.user && vm.user['password'] != vm.DEFAULT_PASS;
      for (var k in vm.user){
        if (k != 'password' && k != 'password2' && vm.orig_user[k] != vm.user[k]) {
          cancelable = true;
          break;
        }
      }
      return cancelable;
    }

    function canSave() {
      var somethingChanged = canCancel();
      return somethingChanged && (
        vm.user.password == vm.DEFAULT_PASS || (
          ( vm.user.password == vm.user.password2 ) && (vm.user.existing_password || vm.token_based_session_timeout)
        )
      );
    }

  }
})();

(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('textFilterBox', TextFilterBoxDirective);

  /** @ngInject */
  function TextFilterBoxDirective() {
    return {
      templateUrl: 'app/components/textFilterBox/filter.html',
      replace: true,
      scope: {
        ngModel: '='
      }
    }
  }

})();


(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('SwotController', SwotController);

  /** @ngInject */
  function SwotController(
    $filter,
    $log,
    $scope,
    $state,
    $uibModal,
    swotStrengthFactory,
    swotWeaknessFactory,
    swotOpportunityFactory,
    swotThreatFactory,
    divisionFactory,
    swotCommentFactory,
    accountFactory,
    Principal,
    currentDivision,
    alerts,
    dimensions
  ) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    //vm.subSubSubTitle = "Manage Your Company's SWOT Elements";
    //vm.things = ['a', 'b', 'c'];
    //vm.widgetFunction = widgetFunction;

    vm.swotFactories = {};
    vm.swotFactories['strength'] = swotStrengthFactory;
    vm.swotFactories['weakness'] = swotWeaknessFactory;
    vm.swotFactories['opportunity'] = swotOpportunityFactory;
    vm.swotFactories['threat'] = swotThreatFactory;
    vm.collections = {};
    vm.collections['strength'] = [];
    vm.collections['weakness'] = [];
    vm.collections['opportunity'] = [];
    vm.collections['threat'] = [];
    vm.commentFactory = swotCommentFactory;

    vm.accordionOpen = {};
    vm.accordionOpen['strength'] = false;
    vm.accordionOpen['weakness'] = true;
    vm.accordionOpen['opportunity'] = false;
    vm.accordionOpen['threat'] = false;

    vm.showDivision = showDivision;
    vm.divisions = [];

    vm.range_max = 1;
    vm.range_min = 1;

    var defaultSortableOptions = {
      handle: '> .myHandle',
      placeholder: "drop_style",
      connectWith: ".apps-container"
    };
    vm.sortableOptions = {};
    vm.sortableOptions['strength'] = angular.copy(defaultSortableOptions);
    vm.sortableOptions['strength']['stop'] = droppedUpdateStrengthPriority;
    vm.sortableOptions['weakness'] = angular.copy(defaultSortableOptions);
    vm.sortableOptions['weakness']['stop'] = droppedUpdateWeaknessPriority;
    vm.sortableOptions['opportunity'] = angular.copy(defaultSortableOptions);
    vm.sortableOptions['opportunity']['stop'] = droppedUpdateOpportunityPriority;
    vm.sortableOptions['threat'] = angular.copy(defaultSortableOptions);
    vm.sortableOptions['threat']['stop'] = droppedUpdateThreatPriority;

    vm.accountFactory = accountFactory;

    vm.layouts = [
      {key: "strength", title: "Strengths", description: "Positive attributes internal to your organization, within your control and that you do particularly well"},
      {key: "weakness", title: "Weaknesses", description: "Areas where your enterprise is below the horizon or underperforming at a minimal requirement in business processes"},
      {key: 'opportunity', title: "Opportunity", description: "Internal or external favorable factors or advantageous circumstances"},
      {key: 'threat', title: "Threats", description: "External factors beyond the control of your organization that have the potential to place your business at risk of failure"}
    ];

    //vm.selectedDivision = "all";
    vm.selectedSwotType = "all";
    vm.copyToCC = copySwotToCC;

    vm.addComment = addComment;
    vm.updateComment = updateComment;
    vm.deleteComment = deleteComment;
    vm.getComment = getComment;
    vm.getCommentAuthor = getCommentAuthor;
    vm.getAccountName = getAccountName;
    vm.showSection = showSection;
    vm.refresh = refresh;
    vm.confirmRemove = confirmRemove;
    vm.add = add;
    vm.update = update;
    vm.newObjective = newObjective;
    vm.currentDivision = currentDivision;
    vm.getScrollStop = dimensions.getScrollStop;
    //vm.stuff = function() {
    //  var found = $("#swot_strength_table_id");
    //  console.log("1: found stuff=", found);
    //  console.log("2: found stuff=", found.offset());
    //  console.log("3: found stuff=", found.offset().top);
    //}

    //vm.stuff();

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      vm.loading = true;
      swotStrengthFactory.get().then(function (swots) {
        // Uses the factory collection
      });
      swotWeaknessFactory.get().then(function (swots) {
        // Uses the factory collection
      });
      swotOpportunityFactory.get().then(function (swots) {
        // Uses the factory collection
      });
      swotThreatFactory.get().then(function (swots) {
        // Uses the factory collection
        addWatchers();
        divisionFactory.get().then(function (divisions) {
          vm.divisions = divisions;
          swotCommentFactory.get().then(function (swotComments) {
            // Uses the factory collection
            accountFactory.get().then(function (accounts) {
              vm.accounts = accounts;
              vm.loading = false;
            });
          })
        });
      });
    }

    function handleCollectionChange(swotType) {
      // Normally we don't want to keep our own copy, but drag'n'drop needs to have its own model object and filters
      // are supposed to be run in the controller (see "Usage" on https://github.com/angular-ui/ui-sortable).
      if (vm.saving) { /*$log.debug('saving, so skip copying');*/ return; }
      //$log.debug('copying');
      var c = angular.copy(vm.swotFactories[swotType].collection);
      c = $filter('filter')(c, $scope.filterText);
      c = $filter('filterDivision')(c, currentDivision.division_id);
      c = $filter('filterSwotType')(c, vm.selectedSwotType);
      c = $filter('orderBy')(c, 'priority');
      vm.collections[swotType] = c;
    }

    function handleAllCollectionChange(newValue, oldValue) {
      handleCollectionChange('strength');
      handleCollectionChange('weakness');
      handleCollectionChange('opportunity');
      handleCollectionChange('threat');
    }

    function addWatchers() {
      $scope.$watchCollection(
        function watchCollection(scope) {
          return swotStrengthFactory.collection;
        },
        function handleChange() { handleCollectionChange('strength'); }
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return swotWeaknessFactory.collection;
        },
        function handleChange() { handleCollectionChange('weakness'); }
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return swotOpportunityFactory.collection;
        },
        function handleChange() { handleCollectionChange('opportunity'); }
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return swotThreatFactory.collection;
        },
        function handleChange() { handleCollectionChange('threat'); }
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return scope.filterText;
        },
        handleAllCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return currentDivision.division_id;
        },
        handleAllCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.selectedSwotType;
        },
        handleAllCollectionChange
      );
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function newObjective(swotType, element) {
      $state.go('objectives', {newWithSwot: element});
    }

    function showDivision(division_id) {
      var selected = $filter('filter')(vm.divisions, {id: division_id});
      return (division_id && selected.length) ? selected[0].name : 'Not set';
    }

    function copySwotToCC(swot) {
      console.log("promoting swot to CC: ", swot);
    }

    // TODO: when updating the priority, the API should re-order all items, forcing the max priority to be
    // TODO: the count(*) amt and least to be 1 and the middle ones to be priority from 0 to count(*), without changing the order
    function editUpdatePriority(element, data) {
      console.log("edit/updating item: ", element.id, " going from ", element.priority, " to ", data);
    }

    function droppedUpdateStrengthPriority(e, ui) {
      droppedUpdatePriority('strength', e, ui);
    }
    function droppedUpdateWeaknessPriority(e, ui) {
      droppedUpdatePriority('weakness', e, ui);
    }
    function droppedUpdateOpportunityPriority(e, ui) {
      droppedUpdatePriority('opportunity', e, ui);
    }
    function droppedUpdateThreatPriority(e, ui) {
      droppedUpdatePriority('threat', e, ui);
    }

    function droppedUpdatePriority(swotType, event, ui) {
      // TODO: can we drag across all lists and if they go to a diff list, then we also move to a SWO or T?
      // Where was it dropped in the visual list?
      var collection = vm.collections[swotType];
      var factoryCollection = vm.swotFactories[swotType].collection;
      var droppedId = null;
      if (ui.item && ui.item.context && ui.item.context.id) {
        droppedId = parseInt(ui.item.context.id);
      } else if (ui.item && ui.item[0] && ui.item[0].id) {
        droppedId = parseInt(ui.item[0].id);
      }
      //var droppedId = parseInt(ui.item.context.id);
      var droppos = collection.map(function(x) {return x.id;}).indexOf(droppedId);
      // Where should it go in the full list?
      var all = $filter('orderBy')(angular.copy(factoryCollection), 'priority');
      var srcPos = all.map(function(x) {return x.id;}).indexOf(droppedId);
      var destPos = all.length - 1;  // This is the case where it was dropped at the end of the list.
      if (droppos < collection.length - 1) {
        // It was dropped somewhere in the middle. It will be replacing whatever was next in the visual list, bumping
        // that one down.
        var destId = collection[droppos + 1].id;
        destPos = all.map(function(x) {return x.id;}).indexOf(destId);
        if (srcPos < destPos) {
          // The current numbers assume they're dragging it up in the list, but in this case they're dragging it down we
          // need to compensate for the fact that we're losing one position
          destPos -= 1;
        }
      }
      // Make the move!
      //$log.debug("moving position " + srcPos + " to " + destPos);
      all.move(srcPos, destPos);
      // Now recalculate the priorities and save
      reprioritize(all, swotType);
    }

    function reprioritize(all, swotType) {
      if (all.length) {
        vm.saving = true;
        var updatedCount = 0;
        for (var i = all.length; i--;) {
          var swot = all[i];
          swot.priority = i + 1;
          vm.swotFactories[swotType].save(swot).then(function (r) {
            updatedCount += 1;
            if (updatedCount == all.length) {
              vm.saving = false;
            }
          });
        }
      }
    }

    function getAccountName(account_id) {
      var accounts = vm.accountFactory.collection;
      for (var i = accounts.length; i--;) {
        if (accounts[i].id == account_id) {
          return accounts[i].name;
        }
      }
      return 'None';
    }

    function getCommentAuthor(comment) {
      return vm.getAccountName(comment.account_id);
    }

    function showSection(swotType) {
      return $filter('filterSwotType')([{type:swotType}], vm.selectedSwotType).length;
    }

    function getComment(parentType, comment_id) {
      for (var i = swotCommentFactory.collection.length; i--;) {
        if (swotCommentFactory.collection[i].id == comment_id) {
          return swotCommentFactory.collection[i];
        }
      }
    }

    function addComment(parentType, commentParent, commentText) {
      if (!commentText) return;
      var newComment = {
        account_id: Principal.user.user_id,
        comment: commentText,
        status: 'active',
        created_date: new Date(),
        swot_id: commentParent.id
      };
      swotCommentFactory.save(newComment).then(function(response) {
        vm.swotFactories[commentParent.type].refreshRecord(response.data.swot_comment.swot_id).then(function(r) {
          r.commentIsOpen = true;
        });
        alerts.info("Situation Analysis", "Saved comment");
      }, function(e) {
        alerts.error("Situation Analysis", "Error Saving Comment", e);
      });
    }

    function updateComment(parentType, commentParent, commentId, commentText) {
      var comment = getComment(parentType, commentId);
      comment.comment = commentText;
      swotCommentFactory.save(comment).then(function(response) {
        vm.swotFactories[commentParent.type].refreshRecord(response.data.swot_comment.swot_id).then(function(r) {
          r.commentIsOpen = true;
        });
        alerts.info("Situation Analysis", "Saved comment");
      }, function(e) {
        alerts.error("Situation Analysis", "Error Saving Comment", e);
      })
    }

    function deleteComment(parentType, commentParent, commentId) {
      var comment = getComment(parentType, commentId);
      swotCommentFactory.delete(comment).then(function(response) {
        vm.swotFactories[commentParent.type].refreshRecord(comment.swot_id).then(function(r) {
          r.commentIsOpen = true;
        });
        alerts.info("Situation Analysis", "Deleted comment");
      }, function(e) {
        alerts.error("Situation Analysis", "Error Deleting Comment", e);
      })
    }

    function remove(swotType, o) {
      vm.swotFactories[swotType].delete(o).then(function(r) {
        console.log("removed")
        var factoryCollection = vm.swotFactories[swotType].collection;
        var all = $filter('orderBy')(angular.copy(factoryCollection), 'priority');
        alerts.info("Situation Analysis", "Deleted " + swotType);
        reprioritize(all, swotType);
      }, function(e){
        alerts.error("Situation Analysis", "Error Deleting " + swotType, e);
        console.log("Failed to delete: ", e);
      });
    }

    function confirmRemove(swotType, o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete SWOT " + o.priority + "?";
          },
          msg: function() {
            return "Delete SWOT " + o.priority + ": '" + o.description + "'?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        remove(swotType, o);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function refresh() {
      for (var swotType in vm.swotFactories) {
        if (vm.swotFactories.hasOwnProperty(swotType)) {
          vm.swotFactories[swotType].refresh().then(function(r) {
            console.log("refreshed!");
            //activate();
          }, function(e){
            console.log("Failed to refresh: ", e);
          });
        }
      }
    }

    function update(swotType, o, key, $data) {
      o[key] = $data;
      vm.swotFactories[swotType].save(o).then(function(r){
        alerts.info("Situation Analysis", "Saved " + swotType);
      }, function(e){
        console.log("Had a problem saving: ", e);
        alerts.error("Situation Analysis", "Error Saving " + swotType, e);
      });
      return false;  // return false so that the model update happens via our factory
    }

    var defaultRecord = {description: null, scope: "present", status: "active", priority: null}

    function add(swotType) {
      var division_id = parseInt(currentDivision.division_id); // if this isn't set, we will use reasonable defaults on the server side
      vm.swotFactories[swotType].save(angular.merge(defaultRecord, {division_id: division_id, type: swotType, priority: 0})).then(function(r) {
        //activate();
        console.log("saved new record, r=", r);
        alerts.info("Situation Analysis", "Saved " + swotType);
      }, function(e){
        console.log("Failed to add, e=", e);
        alerts.error("Situation Analysis", "Error Saving " + swotType, e);
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('PersonalDash', PersonalDash);

  /** @ngInject */
  function PersonalDash($scope, $filter, $log, Principal, personalDashFactory) {
    var vm = this;

    vm.committee_objectives = undefined;
    vm.objectives = undefined;
    vm.tactics = undefined;
    vm.selectedObjective = undefined;
    vm.selectedObjTactics = undefined;
    vm.selectedComObj = undefined;
    vm.selectedComObjTactics = undefined;

    // Public stuff gets added to vm
    vm.loaded = function loaded() {
      return vm.objectives != undefined
        && vm.committee_objectives != undefined
        && vm.tactics != undefined
      ;
    };

    vm.isPast = function isPast(date) {
      return date < new Date();
    };

    // Private stuff

    function setupObjChartData(objectives, forCommittee) {
      var chartData = [];
      var objCount = objectives.length;
      for (var i = objectives.length; i--;) {
        var obj = objectives[i];
        var tactics = obj.tactics;
        var tacticCount = tactics.length;
        var completedSize = 0, completedCount = 0;
        var overdueSize = 0, overdueCount = 0;
        var incompleteSize = 0, incompleteCount = 0;
        var percentDone = 0;
        if (tacticCount == 0) {
          // If there are no tactics we use the objective's state for color.
          if (obj.complete_date) {
            completedCount = 1;
            completedSize = 1 / objCount;
            percentDone = 1;
          }
          else if (vm.isPast(obj.resolved_due_date)) {
            overdueCount = 1;
            overdueSize = 1 / objCount;
            percentDone = 0;
          }
          else {
            incompleteCount = 1;
            incompleteSize = 1 / objCount;
            percentDone = 0;
          }
        }
        else {
          // Based on tactics
          var completedCount = tactics.filter(function (t) {
            return t.complete_date != null;
          }).length;
          completedSize = (1 / objCount) * (completedCount / tacticCount);
          var overdueCount = tactics.filter(function (t) {
            return t.complete_date == null && vm.isPast(t.resolved_due_date);
          }).length;
          overdueSize = (1 / objCount) * (overdueCount / tacticCount);
          var incompleteCount = tactics.filter(function (t) {
            return t.complete_date == null && !vm.isPast(t.resolved_due_date);
          }).length;
          incompleteSize = (1 / objCount) * (incompleteCount / tacticCount);
          percentDone = Math.floor(tacticCount == 0 ? 0 : (completedCount / tacticCount) * 100);
        }
        chartData.push({
          objective: obj,
          state: 'complete',
          useForLabel: completedCount != 0 && overdueCount == 0,
          forCommittee: forCommittee,
          percentDone: percentDone,
          size: completedSize
        });
        chartData.push({
          objective: obj,
          state: 'overdue',
          useForLabel: overdueCount != 0,
          forCommittee: forCommittee,
          percentDone: percentDone,
          size: overdueSize
        });
        chartData.push({
          objective: obj,
          state: 'incomplete',
          useForLabel: completedCount == 0 && overdueCount == 0,
          forCommittee: forCommittee,
          percentDone: percentDone,
          // If tacticCount is 0 we fill up the whole objective with 'incomplete' just to take up the space
          size: incompleteSize
        });
      }
      return chartData;
    }

    function setupChartData() {
      // Objective Chart Data
      var objectives = $filter('orderBy')(vm.objectives, '-resolved_due_date');
      vm.objChartData = setupObjChartData(objectives, false);

      // Committee objective chart data
      objectives = $filter('orderBy')(vm.committee_objectives, '-resolved_due_date');
      vm.comObjChartData = setupObjChartData(objectives, true);


      // http://stackoverflow.com/a/13542669/254603
      function shadeColor2(color, percent) {
        var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
        return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
      }

      vm.objIncompleteColor = "#CCCCCC";
      // Objective chart options
      vm.objChartOptions = {
        chart: {
          type: 'pieChart',
          height: 500,
          donut: true,
          noData: "No Objectives",
          x: function(o){
            var s = "";
            if (o.useForLabel) {
              var div = o.objective.division.name.split(' ')[0];
              s = div + " " + o.objective.priority + " - " + o.percentDone + "%";
            }
            return s;
          },
          y: function(o){return o.size;},
          showLabels: true,
          //labelsOutside: true,
          labelSunbeamLayout: true,
          labelType: "key",
          //valueFormat: function(v) {
          //  return v;
          //},
          duration: 500,
          growOnHover: false,
          showLegend: false,
          //margin: { top: -30 },  // Because we hide the legend
          writeLegend: function(o) {
            $log.debug('writeLegend:' + o);
          },
          tooltip: {
            //contentGenerator: function(o) {
            //  var objDesc = vm.objectives.filter(function(obj) {
            //    return obj.id == o.data.objective_id;
            //  })[0].description;
            //  return objDesc + ": " + o.data.description;
            //}
            contentGenerator: function(o) {
              var s = o.data.objective.description + " (";
              if (o.data.objective.update_due_date) {
                s += $filter('date')(o.data.objective.update_due_date, 'shortDate');
              }
              else {
                s += $filter('date')(o.data.objective.due_date, 'shortDate');
              }
              s += ")";
              return s;
            }
          },
          color: function(d, i) {
            if (d.state == 'complete') {
              return '#5A5';
            }
            if (d.state == 'overdue') {
              return '#DAA';
            }
            return shadeColor2(vm.objIncompleteColor, -0.008 * i);
          },
          pie: {
            dispatch: {
              elementClick: function(e) {
                $log.debug("elementClick: " + e.data.objective.description);
                $scope.$apply(function() {
                  if (e.data.forCommittee) {
                    vm.selectedComObj = e.data.objective;
                    // Put the objective data in each tactic for chart reference
                    e.data.objective.tactics.map(function(tactic) { tactic.objective = angular.copy(e.data.objective); });
                    vm.selectedComObjTactics = $filter('orderBy')(e.data.objective.tactics, ['update_due_date', 'due_date']);
                  }
                  else {
                    vm.selectedObjective = e.data.objective;
                    // Put the objective data in each tactic for chart reference
                    e.data.objective.tactics.map(function(tactic) { tactic.objective = angular.copy(e.data.objective); });
                    vm.selectedObjTactics = $filter('orderBy')(e.data.objective.tactics, ['update_due_date', 'due_date']);
                  }
                });
              }
            }
          }
        }
      };

      // Committee objective chart options
      vm.comObjChartOptions = angular.copy(vm.objChartOptions);
      vm.comObjChartOptions.chart.color = function(d, i) {
        if (d.state == 'complete') {
          return '#5A5';
        }
        if (d.state == 'overdue') {
          return '#DAA';
        }
        return shadeColor2(vm.objIncompleteColor, -0.008 * i);
      };

      // Tactic chart options
      vm.tacticChartOptions = {
        chart: {
          type: 'pieChart',
          height: 500,
          donut: true,
          noData: "No Tactics",
          x: function(tactic){
            var div = tactic.objective.division.name.split(' ')[0];
            return div + " " + tactic.objective.priority + " - T" + tactic.sort_order;
          },
          y: function(o){return 1;},
          //showLabels: false,
          labelSunbeamLayout: true,
          duration: 500,
          showLegend: false,
          //margin: { top: -30 },  // Because we hide the legend
          writeLegend: function(o) {
            $log.debug('writeLegend:' + o);
          },
          tooltip: {
            //contentGenerator: function(o) {
            //  var objDesc = vm.objectives.filter(function(obj) {
            //    return obj.id == o.data.objective_id;
            //  })[0].description;
            //  return objDesc + ": " + o.data.description;
            //}
            contentGenerator: function(o) {
              var s = o.data.description + " (";
              if (o.data.update_due_date) {
                s += $filter('date')(o.data.update_due_date, 'shortDate');
              }
              else {
                s += $filter('date')(o.data.due_date, 'shortDate');
              }
              s += ")";
              return s;
            }
          },
          color: function(d, i) {
            if (d.complete_date) {
              return '#5A5';
            }
            if (vm.isPast(d.resolved_due_date)) {
              return '#DAA';
            }
            return '#BBB';
          },
          pie: {
            dispatch: {
              elementClick: function(e) {
                $log.debug("elementClick: " + e.data.description);
              }
            }
          }
        }
      };
    }

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    activate();
    function activate() {
      vm.principal = Principal;
      personalDashFactory.get().then(function(result) {
        var objectives = angular.copy(result.objectives);
        for (var i = objectives.length; i--;) {
          var o = objectives[i];
          o.due_date = $filter('isoToDate')(o.due_date, true);
          o.update_due_date = $filter('isoToDate')(o.update_due_date, true);
          o.complete_date = $filter('isoToDate')(o.complete_date, true);
          o.resolved_due_date = o.update_due_date ? o.update_due_date : o.due_date;
          for (var j = o.tactics.length; j--;) {
            var t = o.tactics[j];
            t.due_date = $filter('isoToDate')(t.due_date, true);
            t.update_due_date = $filter('isoToDate')(t.update_due_date, true);
            t.complete_date = $filter('isoToDate')(t.complete_date, true);
            t.resolved_due_date = t.update_due_date ? t.update_due_date : t.due_date;
            // Add some extras for display purposes
            t.division = o.division;
          }
        }
        vm.objectives = objectives;
        var tactics = angular.copy(result.tactics);
        for (var i = tactics.length; i--;) {
          var t = tactics[i];
          t.due_date = $filter('isoToDate')(t.due_date, true);
          t.update_due_date = $filter('isoToDate')(t.update_due_date, true);
          t.complete_date = $filter('isoToDate')(t.complete_date, true);
          t.resolved_due_date = t.update_due_date ? t.update_due_date : t.due_date;
        }
        vm.tactics = $filter('orderBy')(tactics, 'resolved_due_date');
        var committee_objectives = angular.copy(result.committee_objectives);
        for (var i = committee_objectives.length; i--;) {
          var o = committee_objectives[i];
          o.due_date = $filter('isoToDate')(o.due_date, true);
          o.update_due_date = $filter('isoToDate')(o.update_due_date, true);
          o.complete_date = $filter('isoToDate')(o.complete_date, true);
          o.resolved_due_date = o.update_due_date ? o.update_due_date : o.due_date;
          for (var j = o.tactics.length; j--;) {
            var t = o.tactics[j];
            t.due_date = $filter('isoToDate')(t.due_date, true);
            t.update_due_date = $filter('isoToDate')(t.update_due_date, true);
            t.complete_date = $filter('isoToDate')(t.complete_date, true);
            t.resolved_due_date = t.update_due_date ? t.update_due_date : t.due_date;
            // Add some extras for display purposes
            t.division = o.division;
          }
        }
        vm.committee_objectives = committee_objectives;
        setupChartData();
        //$timeout(function() { window.dispatchEvent(new Event('resize')) }, 300);  // With the new angular-bootstrap 1.x the charts are starting off tiny until a resize
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('OrgChartController', OrgChartController);

  /** @ngInject */
  function OrgChartController($state, accountFactory, divisionFactory, Principal) {
    var vm = this;
    vm.loaded = false;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------
    vm.currentOrg = Principal.current_org;
    vm.is_admin = Principal.is_admin;

    function organizeAccounts(accounts) {
      // We get:
      // [{
      //   id:..,
      //   name:..,
      //   reports_to_account_id:..
      // },{
      //   id:..,
      //   name:..,
      //   reports_to_account_id:..
      // },{
      //   id:..,
      //   name:..,
      //   reports_to_account_id:..
      // }]
      //
      // And we want to have:
      // [{
      //   id:..,
      //   name:..,
      //   direct_reports: [{
      //     id:..,
      //     name:..
      //     direct_reports: []
      //   },{
      //     id:..,
      //     name:..
      //     direct_reports: [{
      //       ...
      //     }]
      //   }]
      // }]
      var accountTree = [];
      var flatAccounts = {};  // map into the accountTree so we don't have to iterate over the whole tree to search
      var searchAccounts = angular.copy(accounts);
      var oldlen = -1;
      while (searchAccounts.length > 0) {
        // Pretty brute-force, but fun! We just keep filling in the tree until we have no more to fill in.
        // If the length didn't change, there's a bad reference; we stop
        if (searchAccounts.length == oldlen) {
          break;
        }
        oldlen = searchAccounts.length;
        for (var i = searchAccounts.length; i--;) {
          var account = searchAccounts[i];
          if (account.id == 1)
            continue;  // we skip #1 which is the session.py:DbSessionConstants.MASTER_USER_ID from the platform api project
          var div = divisionFactory.getById(account.division_id);
          if (!account.reports_to_account_id) {
            // It looks like empty and 0 both mean top-level; make it so. These should all be handled in the first pass.
            var treeAccount = {
              id: account.id,
              name: account.name,
              division: div ? div.name : '',
              title: account.title,
              direct_reports: []
            };
            accountTree.push(treeAccount);
            flatAccounts[account.id] = treeAccount;
            searchAccounts.splice(i, 1);
          }
          else {
            // They report to someone. If that someone is in the tree, add. If not, wait until the next pass.
            var bossAccount = flatAccounts[account.reports_to_account_id];
            if (bossAccount) {
              if (!bossAccount.direct_reports) {
                bossAccount.direct_reports = [];
              }
              var treeAccount = {
                id: account.id,
                name: account.name,
                division: div ? div.name : '',
                title: account.title,
                direct_reports: []
              };
              bossAccount.direct_reports.push(treeAccount);
              flatAccounts[account.id] = treeAccount;
              searchAccounts.splice(i, 1);
            }
          }
        }
      }
      return accountTree;
    }
    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    activate();
    function activate() {
      vm.loaded = false;
      divisionFactory.get().then(function(divisions) {
        accountFactory.get().then(function(accounts) {
          vm.accountTree = organizeAccounts(accounts);
          vm.loaded = true;
          // The directive was rendering before {{}} expressions were evaluated. :( Do it this way for now...
          setTimeout(function() {
            $("#chart-source").orgChart({
              container: $("#orgchart"),
              interactive: true,
              showLevels: 4  // Actually turns out to be 3 since we hide the top level node
            });
          }, 1);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('webapp')
    .controller('ObjectivesController', ObjectivesController);

  /** @ngInject */
  function ObjectivesController($q,
                                $scope,
                                $log,
                                $filter,
                                $timeout,
                                $stateParams,
                                $uibModal,
                                smoothScroll,
                                divisionFactory,
                                swotFactory,
                                swotOpportunityFactory,
                                swotStrengthFactory,
                                swotThreatFactory,
                                swotWeaknessFactory,
                                accountFactory,
                                objectiveFactory,
                                objectiveCommentFactory,
                                ccFactory,
                                tacticFactory,
                                tacticCommentFactory,
                                Principal,
                                currentDivision,
                                alerts,
                                dimensions
  ) {
    var vm = this;
    var myFactoryMap = {
      objective: objectiveFactory,
      account: accountFactory,
      tactic: tacticFactory
    };

    var yearCount = 5;  // How many years to show in the year view

    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------


    vm.sortableOptions = {
      handle: '> .myHandle',
      placeholder: "drop_style",
      connectWith: ".apps-container",
      //start: startDragging,  // By 'start' it's too late to modify the dom. It makes sortable act wonky.
      stop: droppedUpdatePriority
    };

    vm.range_max = 1;
    vm.range_min = 1;

    vm.tacticFactory = tacticFactory;
    vm.objectiveFactory = objectiveFactory;
    vm.divisionFactory = divisionFactory;
    vm.swotFactory = swotFactory;
    vm.swotOpportunityFactory = swotOpportunityFactory;
    vm.swotStrengthFactory = swotStrengthFactory;
    vm.swotThreatFactory = swotThreatFactory;
    vm.swotWeaknessFactory = swotWeaknessFactory;
    vm.accountFactory = accountFactory;
    vm.objectiveCommentFactory = objectiveCommentFactory;
    vm.tacticCommentFactory = tacticCommentFactory;
    vm.ccFactory = ccFactory;

    vm.unCategorizeSwots = unCategorizeSwots;
    vm.categorizeSwots = categorizeSwots;

    vm.objective_comments = undefined;
    vm.divisions = undefined;
    vm.accounts = undefined;
    vm.swots = undefined;
    vm.ccs = undefined;
    vm.tactics = undefined;
    vm.tactic_comments = undefined;
    vm.collection = undefined;
    vm.allYears = [];
    vm.allMonths = {
      0: 'J',
      1: 'F',
      2: 'M',
      3: 'A',
      4: 'M',
      5: 'J',
      6: 'J',
      7: 'A',
      8: 'S',
      9: 'O',
      10: 'N',
      11: 'D'
    };

    vm.refreshObjectives = refreshObjectives;
    vm.saveXeditable = saveXeditable;
    vm.saveUiSelect = saveUiSelect;
    vm.save = save;
    vm.addObjective = addObjective;
    vm.addTactic = addTactic;
    vm.confirmDeleteObjective = confirmDeleteObjective;
    vm.confirmDeleteTactic = confirmDeleteTactic;
    vm.currentDivision = currentDivision;
    vm.currentAccountId = Principal.is_switched ? 'all' : Principal.user.user_id.toString();
    vm.currentYear = (new Date()).getFullYear();
    vm.getSwotDescription = getSwotDescription;
    vm.startDragging = startDragging;
    vm.getScrollStop = dimensions.getScrollStop;
    vm.getTactics = getTactics;
    vm.loading = true;
    vm.objNotDoneDueInYear = objNotDoneDueInYear;
    vm.objCompletedInYear = objCompletedInYear;
    vm.objCompletedInYearAndMonth = objCompletedInYearAndMonth;
    vm.objNotDoneDueInYearAndMonthPast = objNotDoneDueInYearAndMonthPast;
    vm.objNotDoneDueInYearAndMonthFuture = objNotDoneDueInYearAndMonthFuture;
    vm.objNotDoneUpdateDueInYearAndMonthFuture = objNotDoneUpdateDueInYearAndMonthFuture;

    vm.recordValForSort = function(record) {
      // console.log("recordValForSort: ", record);
      if (! record) return null;
      return record.update_due_date ? record.update_due_date : record.due_date;
    };

    function getResolvedDueDate(obj) {
      return obj.update_due_date ? obj.update_due_date : obj.due_date;
    }

    function objNotDoneDueInYear(obj, year) {
      var d = getResolvedDueDate(obj);
      return d && d.getFullYear() == year && !obj.complete_date;
    }

    function objCompletedInYear(obj, year) {
      return obj.complete_date && obj.complete_date.getFullYear() == year;
    }

    function objCompletedInYearAndMonth(obj, year, month) {
      return objCompletedInYear(obj, year) && obj.complete_date.getMonth() === parseInt(month);
    }

    function objNotDoneDueInYearAndMonthPast(obj, year, month) {
      var d = getResolvedDueDate(obj);
      return !obj.complete_date
        && d
        && d.getFullYear() === year
        && d.getMonth() === parseInt(month)
        && d < (new Date());
    }

    function objNotDoneDueInYearAndMonthFuture(obj, year, month) {
      var d = obj.due_date;
      return !obj.complete_date
        && !obj.update_due_date
        && d
        && d.getFullYear() === year
        && d.getMonth() === parseInt(month)
        && d > (new Date());
    }

    function objNotDoneUpdateDueInYearAndMonthFuture(obj, year, month) {
      var d = obj.update_due_date;
      return !obj.complete_date
        && d
        && d.getFullYear() === year
        && d.getMonth() === parseInt(month)
        && d > (new Date());
    }

    function getAllYears() {
      var year = vm.currentYear - 1;  // Start on the year before the current year to give context
      for (var y = 0; y < yearCount; y++) {
        vm.allYears.push(year++);
      }
    }

    function getSwotDescription(swot_id, truncate_count) {
      truncate_count = typeof truncate_count !== 'undefined' ? truncate_count : -1;
      var swot = swotFactory.getById(swot_id);
      if (swot_id && swot) {
        var s = swot.priority + ': (' + swot.type.charAt(0).toUpperCase() + ') ' + swot.description;
        if (truncate_count > 1) {
          s = $filter('limitToEllipses')(s, truncate_count);
        }
        return s;
      }
      else {
        return 'not set';
      }
    }

    vm.getCcDescription = function getCcDescription(cc_id, truncate_count) {
      truncate_count = typeof truncate_count !== 'undefined' ? truncate_count : -1;
      var cc = vm.getCc(cc_id);
      var s = cc.priority + ': ' + cc.description;
      if (truncate_count > -1) {
        s = $filter('limitToEllipses')(s, truncate_count);
      }
      return s;
    };

    vm.getObjective = function getObjective(obj_id) {
      var objectives = vm.collection;
      for (var i = objectives.length; i--;) {
        if (objectives[i].id == obj_id) {
          return objectives[i];
        }
      }
    };

    vm.getObjectiveComment = function getObjectiveComment(comment_id) {
      var comments = vm.objectiveCommentFactory.collection;
      for (var i = comments.length; i--;) {
        if (comments[i].id == comment_id) {
          return comments[i];
        }
      }
    };

    vm.getTacticComment = function getTacticComment(comment_id) {
      var tactic_comments = vm.tacticCommentFactory.collection;
      for (var i = tactic_comments.length; i--;) {
        if (tactic_comments[i].id == comment_id) {
          return tactic_comments[i];
        }
      }
    };

    vm.getComment = function getComment(parentType, commentId) {
      if (parentType == 'objective') {
        return vm.getObjectiveComment(commentId)
      }
      if (parentType == 'tactic') {
        return vm.getTacticComment(commentId)
      }
    };

    vm.getAccountName = function getAccountName(account_id) {
      var accounts = vm.accountFactory.collection;
      for (var i = accounts.length; i--;) {
        if (accounts[i].id == account_id) {
          return accounts[i].name;
        }
      }
      return 'None';
    };

    vm.getCommentAuthor = function getCommentAuthor(comment) {
      return vm.getAccountName(comment.account_id);
    };

    vm.promoteTactic = function promoteTactic(parentObjective, tactic) {
      var newObjective = {
        //account_id: tactic.account_id,
        description: tactic.description,
        due_date: tactic.due_date,
        update_due_date: tactic.update_due_date,
        complete_date: tactic.complete_date,
        tactic_id: tactic.id,
        status: 'active',
        promotion: true,
        priority: parentObjective.priority,
      };
      objectiveFactory.save(newObjective).then(addObjectiveSuccess, addObjectiveFail);

      function addObjectiveFail(e) {
        alerts.error("Objectives", "Failed To Turn Tactic Into Objective", e);
      }

      function addObjectiveSuccess(resp) {
        alerts.info("Objectives", "Tactic Turned Into Objective");
        var savedObjective = resp.data.objective;
        for (var i=0; i<parentObjective.swots.length; i++) {
          savedObjective.swots.push(parentObjective.swots[i]);
        }
        objectiveFactory.save(savedObjective, function(r) {
          console.log("Finished adding swots into the newly promoted objective");
        }, function(e) {
          console.error("Failed to add in swots: ", e);
        });
        tacticFactory.delete(tactic).then(function(r) {
          console.log("Deleted tactic!");
        }, function(e) {
          console.error("Failed to delete tactic!");
        });
      }

    };

    var saveComment = function(comment, parentType, commentParent) {
      if (parentType == 'objective') {
        comment.objective_id = commentParent.id;
        objectiveCommentFactory.save(comment).then(function (response) {
          alerts.info("Objectives", "Successfully Saved Objective Comment");
          objectiveFactory.refreshRecord(response.data.objective_comment.objective_id).then(function(oresponse) {
            oresponse.commentIsOpen = true;
          });
        }, function(e) {
          alerts.error("Objectives", "Error Saving Objective Comment", e);
        });
      }
      else if (parentType == 'tactic') {
        comment.tactic_id = commentParent.id;
        tacticCommentFactory.save(comment).then(function (response) {
          alerts.info("Objectives", "Successfully saved tactic comment");
          var tactic_id = response.data.tactic_comment.tactic_id;
          tacticFactory.refreshRecord(tactic_id).then(function(tresponse) {
            tresponse.commentIsOpen = true;
            // We also need to refresh the objective since that's ultimately what the UI is bound to
            for (var i = vm.objectiveFactory.collection.length; i--;) {
              var objective = vm.objectiveFactory.collection[i];
              if (objective.tactics.indexOf(tactic_id) > -1) {
                objectiveFactory.refreshRecord(objective.id).then(function(oresponse) {
                  oresponse.isOpen = true;
                });
                break;
              }
            }
          });
        }, function(e) {
          alerts.error("Objectives", "Error Saving Tactic Comment", e);
        });
      }
    };

    var _deleteComment = function(comment, parentType, commentParent) {
      if (parentType == 'objective') {
        objectiveCommentFactory.delete(comment).then(function (response) {
          alerts.info("Objectives", "Successfully Deleted Objective Comment");
          objectiveFactory.refreshRecord(response.data.objective_comment.objective_id).then(function(oresponse) {
            oresponse.commentIsOpen = true;
          });
        }, function(e) {
          alerts.error("Objectives", "Error Deleting Objective Comment", e);
        });
      }
      else if (parentType == 'tactic') {
        tacticCommentFactory.delete(comment).then(function (response) {
          alerts.info("Objectives", "Successfully Saved Tactic Comment");
          var tactic_id = response.data.tactic_comment.tactic_id
          tacticFactory.refreshRecord(tactic_id).then(function(tresponse) {
            tresponse.commentIsOpen = true;
            // We also need to refresh the objective since that's ultimately what the UI is bound to
            for (var i = vm.objectiveFactory.collection.length; i--;) {
              var objective = vm.objectiveFactory.collection[i];
              if (objective.tactics.indexOf(tactic_id) > -1) {
                objectiveFactory.refreshRecord(objective.id).then(function(oresponse) {
                  oresponse.isOpen = true;
                });
                break;
              }
            }
          });
        }, function(e) {
          alerts.error("Objectives", "Error Saving Tactic Comment", e);
        });
      }
    };

    vm.addComment = function addComment(parentType, commentParent, commentText) {
      if (!commentText) return;
      var newComment = {
        account_id: Principal.user.user_id,
        comment: commentText,
        status: 'active',
        created_date: new Date()
      };
      saveComment(newComment, parentType, commentParent);
    };

    vm.updateComment = function updateComment(parentType, commentParent, commentId, commentText) {
      var comment = vm.getComment(parentType, commentId);
      comment.comment = commentText;
      saveComment(comment, parentType, commentParent);
    };

    vm.deleteComment = function deleteComment(parentType, commentParent, commentId) {
      var comment = vm.getComment(parentType, commentId);
      _deleteComment(comment, parentType, commentParent);
    };

    vm.canAddObjective = function canAddObjective() {
      //if (vm.objectives === undefined) { return false; }
      //return (vm.objectives.length == 0 || vm.objectives.filter(function(obj) {
      //  return obj.id === null;
      //}).length == 0);
      return true;
    };


    vm.canAddTactic = function canAddTactic(objective) {
      return (objective.tactics.length == 0 || objective.tactics.filter(function (tactic) {
        return tactic.id === null;
      }).length == 0);
    };

    // used by the UI to move an objective's swots into cats when the user opens the editor
    function categorizeSwots(objective) {
      //console.log("** categorizeSwots **, objective=", objective);
      var cat = {weakness: [], opportunity: [], strength: [], threat: []};
      var mySwots = objective.swots;
      for (var i = mySwots.length; i--;) {
        //for (var i=0; i<mySwots.length; i++) {
        var swot = swotFactory.getById(mySwots[i]);
        if (!swot) {
          $log.warn("Failed to find a swot for id=", mySwots[i]);
        } else {
          cat[swot.type].push(mySwots[i]);
        }
      }
      return cat;
    }

    // used by the UI to flatten (in order) the categorized swots for going back to db
    function unCategorizeSwots(cat) {
      var visited = {};
      var retval = [];
      // preserve the insertion order (weak, op, str, threat)
      var lists = [cat.weakness, cat.opportunity, cat.strength, cat.threat];
      for (var li in lists) {
        for (var i in lists[li]) {
          if (!(lists[li][i] in visited)) {
            visited[lists[li][i]] = true;
            retval.push(lists[li][i]);
          }
        }
      }
      return retval;
    }

    function saveUiSelect($item, $model, object_type, action, element_name, object) {
      var temp = [];
      var visited = {};
      if (action == 'remove') {
        visited[$model] = true;
      }
      for (var i = 0; i < object[element_name].length; i++) {
        if (!(object[element_name][i] in visited)) {
          visited[object[element_name][i]] = true;
          temp.push(object[element_name][i]);
        }
      }

      if (action == 'add') {
        if (!($model in visited)) {
          temp.push($model);
        }
      }
      var outbound = angular.copy(object);
      outbound[element_name] = temp;
      return save(object_type, outbound);
    }

    function allTacticsComplete(objective) {
      for (var i = objective.tactics.length; i--;) {
        var tactic = tacticFactory.getById(objective.tactics[i]);
        if (!tactic.complete_date) {
          return false;
        }
      }
      return true;
    }

    function saveXeditable(object_type, o, key, data) {
      if (data === undefined) data = null;  // Allow saving of blank stuff
      // Objectives can't be marked complete if tactics aren't all complete.
      if (object_type == "objective" && key == "complete_date" && !allTacticsComplete(o)) {
        o.complete_date = null;
        alerts.error("Objectives", "All tactics must be complete before an objective can be marked complete");
        return;
      }
      // Likewise, if an objective is complete, the tactic complete date can't be unset
      if (object_type == "tactic" && key == "complete_date"
        && objectiveFactory.getById(o.objective_id).complete_date && data === null) {
        alerts.error("Tactics", "Tactic completion date cannot be unset while the objective is marked complete");
        tacticFactory.refreshRecord(o.id);
        return;
      }
      var newobj = {};
      newobj[key] = data;
      var outbound = angular.merge(o, newobj);
      return save(object_type, outbound)
    }

    function save(object_type, object) {
      var deferred = $q.defer();
      myFactoryMap[object_type].save(object).then(function (r) {
        alerts.info("Objectives", "Successfully Saved " + object_type);
        if (object_type == 'objective' && (object.isOpen || !object.id )&& r && r.data && r.data.objective) {
          // if they just got this back, we can assume that they were editing it... and keep the accordion open
          r.data.objective.isOpen = true;
        }
        deferred.resolve(r);
      }, function (e) {
        deferred.reject(e);
        console.log("Had a problem saving ", object_type, ": ", e);
        alerts.error("Objectives", "Error Saving " + object_type, e);
      });
      return deferred.promise;
    }

    function getTactics(objective) {
      var tactics = [];
      for (var i=0; i<objective.tactics.length; i++) {
        var tactic_id = objective.tactics[i];
        var tactic = tacticFactory.getById(tactic_id);
        if (tactic) {
          tactics.push(tactic);
        }
      }
      return tactics;
    }

    function deleteObjective(objective) {
      objectiveFactory.delete(objective).then(function(r) {
        alerts.info("Objectives", "Successfully Deleted Objective");
        var all = sortOrder(angular.copy(objectiveFactory.collection));
        var some = all.filter(function(obj) { return obj.division_id == r.data.objective.division_id; });
        reprioritize(some);
      }, function(e) {
        alerts.error("Objectives", "Error Deleting Objective", e);
      });
    }

    function confirmDeleteObjective(o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete Objective " + o.priority + "?";
          },
          msg: function() {
            return "Delete Objective " + o.priority + ": '" + o.description + "'?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        deleteObjective(o);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function deleteTactic(objective, tactic) {
      tacticFactory.delete(tactic).then(function(r){
        console.log("Ok, deleteTactic is done, tactic=", tactic, " with a response of: ", r);
        alerts.info("Objectives", "Successfully Deleted tactic");
        if (r && r.data && r.data.tactic && r.data.tactic.objective_id) {
          objectiveFactory.refreshRecord(r.data.tactic.objective_id).then(function (newObjective) {
            newObjective.isOpen = objective.isOpen;
          }, function (ee) {
            $log.error("Failed to reload the objective!", ee);
          })
        }
      }, function(e){
        alerts.error("Objectives", "Error Deleting Tactic", e);
      });
    }

    function confirmDeleteTactic(o, t) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete Tactic " + t.priority + "?";
          },
          msg: function() {
            return "Delete Tactic " + t.priority + ": '" + t.description + "'?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        deleteTactic(o, t);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function addTactic(objective) {
      var newobj = {};
      newobj['objective_id'] = objective.id;
      newobj['sort_order'] = objective.tactics.length + 1;
      save('tactic', newobj).then(function (r) {
        if (r && r.data && r.data.tactic && r.data.tactic.objective_id) {
          objectiveFactory.refreshRecord(r.data.tactic.objective_id).then(function (newObjective) {
            newObjective.isOpen = objective.isOpen;
          }, function (ee) {
            $log.error("Failed to reload the objective!", ee);
          })
        }

      }, function (e) {
        $log.error(e);
      });
    }

    function addObjective(swot) {
      var newobj = {};
      newobj['division_id'] = currentDivision.division_id;
      newobj['priority'] = 0;
      if (swot) {
        newobj['swots'] = [swot.id];
      }
      save('objective', newobj);
    }

    function refreshObjectives() {
      objectiveFactory.refresh().then(function (r) {
        console.log("refreshed objectives");
      }, function (e) {
        console.log("failed to refresh objectives, e=", e);
      });
    }

    function startDragging(event, ui) {
      // Make sure all objectives are not expanded. Otherwise the child <tr>s look like legit rows that should
      // be counted in calculating where the thing is dropped.
      for (var i = vm.collection.length; i--;) {
        // $log.debug("Closing objective index " + i);
        vm.collection[i].isOpen = false;
      }
    }

    function droppedUpdatePriority(event, ui) {
      var droppedId = null;
      // var oldIndex = ui.item.sortable.index;
      // var newIndex = ui.item.index();
      // // The first way is my preferred way to find the dest, but it doesn't work :-(
      // if (oldIndex > -1 && oldIndex < vm.collection.length && vm.collection[oldIndex].id) {
      //   droppedId = vm.collection[oldIndex].id;
      //   console.log("DroppedId 1=", droppedId)
      // }

      if (ui.item && ui.item.context && ui.item.context.id) {
        droppedId = parseInt(ui.item.context.id.split('_')[1]);
      }
      if (ui.item && ui.item[0] && ui.item[0].id) {
        droppedId = parseInt(ui.item[0].id.split('_')[1]);
      }
      if (! droppedId) {
        console.log("Failed to sort from drag&drop");
        return;
      }

      var droppos = vm.collection.map(function(x) {return x.id;}).indexOf(droppedId);
      // Where should it go in the full list?
      // Use a copy of the original collection because it hasn't been modified by drag'n'drop
      var all = sortOrder(angular.copy(objectiveFactory.collection));
      var srcPos = all.map(function(x) {return x.id;}).indexOf(droppedId);
      var destPos = all.length - 1;  // This is the case where it was dropped at the end of the list.
      if (droppos < vm.collection.length - 1) {
        // It was dropped somewhere in the middle. It will be replacing whatever was next in the visual list, bumping
        // that one down.
        var destId = vm.collection[droppos + 1].id;
        destPos = all.map(function(x) {return x.id;}).indexOf(destId);
        if (srcPos < destPos) {
          // The current numbers assume they're dragging it up in the list, but in this case they're dragging it down we
          // need to compensate for the fact that we're losing one position
          destPos -= 1;
        }
      }
      // Make the move!
      // $log.debug("moving position " + srcPos + " to " + destPos);
      all.move(srcPos, destPos);
      // Now recalculate the priorities and save. Since we only prioritize within divisions for objectives only pass the
      // items that have the same division as the dropped one.
      var division_id = vm.getObjective(droppedId).division_id;
      var some = all.filter(function(obj) { return obj.division_id == division_id; });
      reprioritize(some);
    }

    function reprioritize(all) {
      if (all.length) {
        vm.saving = true;
        var updatedCount = 0;
        for (var i = all.length; i--;) {
          var obj = all[i];
          obj.priority = i+1;
          objectiveFactory.save(obj).then(function(r) {
            updatedCount += 1;
            if (updatedCount == all.length) {
              vm.saving = false;
            }
          });
        }
      }
    }

    function sortOrder(c) {
      return $filter('orderBy')(c, ['division_id', 'priority']);
    }

    function handleCollectionChange(newValue, oldValue) {
      // Normally we don't want to keep our own copy, but drag'n'drop needs to have its own model object and filters
      // are supposed to be run in the controller (see "Usage" on https://github.com/angular-ui/ui-sortable).
      if (vm.saving) { /*$log.debug('saving, so skip copying');*/ return; }
      //$log.debug('copying');
      var c = angular.copy(objectiveFactory.collection);
      c = $filter('filter')(c, $scope.filterText);
      c = $filter('filterDivision')(c, currentDivision.division_id);
      c = $filter('filterAccount')(c, vm.currentAccountId);
      c = sortOrder(c);
      vm.collection = c;
    }

    function addWatchers() {
      $scope.$watchCollection(
        function watchCollection(scope) {
          return objectiveFactory.collection;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return scope.filterText;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return currentDivision.division_id;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.currentAccountId;
        },
        handleCollectionChange
      );
    }

    activate();

    function activate() {
      objectiveFactory.get().then(function(objectives) {
        addWatchers();
        getAllYears();
        // We set current division so we need to make sure it happens after both divisions and objectives are loaded.
        divisionFactory.get().then(function(divisions) {
          accountFactory.get().then(function(accounts) {
            swotFactory.get().then(function(swots) {
              tacticFactory.get().then(function(tactics) {
                ccFactory.get().then(function(ccs) {
                  objectiveCommentFactory.get().then(function(objectiveComments) {
                    tacticCommentFactory.get().then(function(tacticComments) {
                      vm.loading = false;
                      if ($stateParams.objectiveId) {
                        // First use the all-inclusive collection to find division/account ids
                        var objs = objectiveFactory.collection.filter(function(objective) {
                          return objective.id == $stateParams.objectiveId;
                        });
                        if (objs.length > 0) {
                          var tobj = objs[0];
                          vm.currentDivision.division_id = tobj.division_id.toString();
                          vm.currentAccountId = tobj.account_id.toString();
                          $timeout(function() {
                            // Now use the collection to get our local copy of the object so we can manipulate isOpen
                            // This is in a timeout so that vm.collection has a chance to get populated
                            var objs = vm.collection.filter(function (objective) {
                              return objective.id == $stateParams.objectiveId;
                            });
                            if (objs.length > 0) {
                              var obj = objs[0];
                              $timeout(function() {
                                // This is in a timeout so that:
                                // 1 - the currentDivision/AccountId can take effect
                                // 2 - the height calculations below are correct
                                obj.isOpen = true;
                                smoothScroll(document.getElementById("obj_" + obj.id), {
                                  offset: $('#topnavbar').height() + $('#objectives-table-header').height()
                                });
                              }, 0);
                            }
                          }, 0);
                        }
                      }
                      else if ($stateParams.newWithSwot) {
                        vm.addObjective($stateParams.newWithSwot);
                      }
                    });
                  });
                });
              });
            });
          });
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('webapp')
    .controller('ObjectiveReportController', ObjectiveReportController);

  /** @ngInject */
  function ObjectiveReportController($q,
                                divisionFactory,
                                swotFactory,
                                swotOpportunityFactory,
                                swotStrengthFactory,
                                swotThreatFactory,
                                swotWeaknessFactory,
                                accountFactory,
                                objectiveFactory,
                                objectiveCommentFactory,
                                ccFactory,
                                tacticFactory,
                                tacticCommentFactory,
                                $stateParams
  ) {
    var vm = this;
    vm.objective_id = $stateParams.objective_id;

    vm.tacticFactory = tacticFactory;
    vm.objectiveFactory = objectiveFactory;
    vm.divisionFactory = divisionFactory;
    vm.swotFactory = swotFactory;
    vm.swotOpportunityFactory = swotOpportunityFactory;
    vm.swotStrengthFactory = swotStrengthFactory;
    vm.swotThreatFactory = swotThreatFactory;
    vm.swotWeaknessFactory = swotWeaknessFactory;
    vm.accountFactory = accountFactory;
    vm.objectiveCommentFactory = objectiveCommentFactory;
    vm.tacticCommentFactory = tacticCommentFactory;
    vm.ccFactory = ccFactory;

    vm.objective_comments = undefined;
    vm.divisions = undefined;
    vm.accounts = undefined;
    vm.swots = undefined;
    vm.ccs = undefined;
    vm.tactics = undefined;
    vm.tactic_comments = undefined;
    vm.collection = undefined;


    activate();

    function activate() {
      $q.all([
        accountFactory.get(),
        divisionFactory.get(),
        tacticFactory.get(),
        ccFactory.get(),
        swotFactory.get(),
        objectiveFactory.get()
      ]).then(function() {
        vm.objective = objectiveFactory.getById(vm.objective_id);
        vm.division = divisionFactory.getById(vm.objective.division_id);
        vm.account = accountFactory.getById(vm.objective.account_id);
        // ----------
        vm.tactics = [];
        for (var i = 0; i<vm.objective.tactics.length; i++) {
          vm.tactics.push(tacticFactory.getById(vm.objective.tactics[i]));
        }
        // ----------
        vm.swots = [];
        for (var i = 0; i<vm.objective.swots.length; i++) {
          vm.swots.push(swotFactory.getById(vm.objective.swots[i]));
        }
        // ----------
        vm.committee_members = [];
        for (var i = 0; i<vm.objective.committee_members.length; i++) {
          vm.committee_members.push(accountFactory.getById(vm.objective.committee_members[i]));
        }

        // ----------
        vm.core_competencies = [];
        for (var i = 0; i<vm.objective.core_competencies.length; i++) {
          vm.core_competencies.push(ccFactory.getById(vm.objective.core_competencies[i]));
        }

      })

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .directive('opgNavbar', opgNavbar);

  /** @ngInject */
  function opgNavbar() {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'navbarCtrl',
      bindToController: true
    };

    /** @ngInject */
    function NavbarController(alerts, $rootScope, $uibModal, $log, $http, Principal) {
      var vm = this;
      vm.principal = Principal;
      vm.logout = logout;
      vm.changeTenant = changeTenant;
      vm.showlogo = true;
      vm.selected = "nothing";
      vm.aboutLink = undefined;
      vm.instanceLogo = undefined;
      vm.defaultLogo = undefined;



      activate();

      function logout() {
        Principal.logout().then(function(r){
          //$state.go("login");
          window.location.reload();
        }, function(e) {
          console.error("Failed to log out?", e);
        });
      }

      function changeTenant() {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/navbar/change-org-modal.html',
          controller: 'ChangeOrgModalController',
          controllerAs: 'modal',
          size: 'sm',
          resolve: {
            getSelectedOrg: function() {
              return vm.selected;
            }
          }
        });

        // modal example: https://angular-ui.github.io/bootstrap/
        modalInstance.result.then(function (selectedItem) {
          console.log("Selected item...", selectedItem);
          vm.selected = selectedItem;
        }, function () {
          $log.info('Modal dismissed at: ' + new Date());
        });
      }

      function reloadLogo() {
        // Force reload of the image
        vm.showlogo = false;
        setTimeout(function() {
          vm.showlogo = true;
          setTimeout(function() {
            // In case they had reset it to fall-back to opg
            $("#company-logo-img").attr('src', '/api/organization/image');
          }, 0);
        }, 0);
      }

      $rootScope.$on("logo-update", reloadLogo);

      function activate() {
        // Make mobile navbar menu collapse when a link in it is clicked.
        // Thanks https://github.com/twbs/bootstrap/issues/12852
        $(document).on('click','.navbar-collapse.in',function(e) {
          if( $(e.target).is('a') && ( $(e.target).attr('class') != 'dropdown-toggle' ) ) {
            $(this).collapse('hide');
          }
        });

        $http.get('/api/instance-settings/about_url').then(function(r){
          vm.aboutLink = r.data.about_url;
        }, function(e){
          alerts.error("Navigation", "Failed to fetch the about url", e);
        });

        $http.get('/api/instance-settings/instance_logo_url').then(function(r){
          vm.instanceLogo = r.data.instance_logo_url;
        }, function(e){
          alerts.error("Navigation", "Failed to fetch the instance logo", e);
        });

        $http.get('/api/instance-settings/default_logo_url').then(function(r){
          vm.defaultLogo = r.data.default_logo_url;
        }, function(e){
          alerts.error("Navigation", "Failed to fetch the default logo", e);
        });
      }

    }

    return directive;

  }

})();

/**
 * Created by eric on 12/15/15.
 */
(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('ChangeOrgModalController', ChangeOrgModalController);

  /** @ngInject */
  function ChangeOrgModalController($window, $uibModalInstance, Principal, tenantFactory, getSelectedOrg) {
    var vm = this;
    vm.selected = getSelectedOrg;
    vm.tenants = undefined;
    vm.editorHeight = $window.innerHeight * .6;
    vm.cancel = cancelModal;
    vm.selectTenant = selectTenant;
    vm.selectMyTenant = selectMyTenant;
    vm.principal = Principal;

    activate();

    function cancelModal() {
      $uibModalInstance.dismiss('cancel');
      console.log("cancel pressed");
    }

    function selectTenant(tenant) {
      console.log("Selected org! ", tenant);
      Principal.switchTenant(tenant.id).then(function(r) {
        $uibModalInstance.dismiss('cancel');
        $window.location.reload();
        console.log("Just switched to ", tenant.id, " otherwise=", tenant, " and now we are reloading")
      }, function(e) {
        console.log("Failed to switch organization");
      });
    };

    function selectMyTenant() {
      Principal.switchTenant('ORIGIN').then(function(r) {
        $uibModalInstance.dismiss('cancel');
        $window.location.reload();
        console.log("Just switched to home schema")
      }, function(e) {
        console.log("Failed to switch organization");
      });
    };


    function activate() {
      tenantFactory.get().then(function(tenants){
        vm.tenants = tenants;
      });
    }

  }


})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('MissionStatementController', MissionStatementController);

  /** @ngInject */
  function MissionStatementController($http, $window, TinymceOptions, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    //vm.subSubSubTitle = "Your Mission Statement";
    vm.document = undefined;
    vm.tinymceOptions = TinymceOptions;
    vm.editorHeight = $window.innerHeight * .6;
    vm.ms = {id: null, body: ""};

    vm.cancel = cancel;
    vm.save = save;

    vm.canCancel = canCancel;
    vm.canSave = canSave;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------

    function activate() {
      vm.loading = true;
      $http.get('/api/mission-statement').then(function(r){
        if (r.data.documents && r.data.documents.length > 0) {
          vm.ms = r.data.documents[0];
          vm.document = angular.copy(vm.ms.body);
          vm.loading = false;
        }
      }, function(e) {
        alerts.error("Fetching Mission Statement", "Error while fetching mission statement", e);
        console.log("Error getting mission statement")
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function canSave() {
      return vm.ms && (vm.document != vm.ms.body);
    }

    function canCancel() {
      return vm.ms && (vm.document != vm.ms.body);
    }

    function cancel() {
      if (vm.ms) {
        vm.document = vm.ms.body;
      }
    }

    function save() {
      if (canSave()) {
        $http.put('/api/mission-statement/' + vm.ms.id, {'body': vm.document}).then(function (r) {
          activate();
          alerts.info("Mission Statement", "Successfully updated");
        }, function(e) {
          alerts.error("Mission Statement", "Failed to update", e);
        });
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('MeetingsController', MeetingsController);

  /** @ngInject */
  function MeetingsController($http) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.subSubSubTitle = "Meetings";
    vm.meetings = undefined;
    vm.loading = false;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      vm.loading = true;
      $http.get('/api/meeting').then(function(r){
        vm.loading = false;
        vm.meetings = r.data.meetings;
      }, function(e) {
        console.log("Error getting meetings")
      });

    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    //function widgetFunction() {
    //    console.log("the user clicked this widget function thing");
    //}

  }
})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('KeySuccessFactorsController', KeySuccessFactorsController);

  /** @ngInject */
  function KeySuccessFactorsController(
    $scope,
    $filter,
    $log,
    $uibModal,
    ksfFactory,
    divisionFactory,
    ccFactory,
    currentDivision,
    alerts,
    dimensions
  ) {

    var scrollTop = undefined;

    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.showDivision = showDivision;
    vm.divisions = [];
    vm.ksfFactory = ksfFactory;
    vm.ccFactory = ccFactory;
    vm.currentDivision = currentDivision;
    vm.loading = true;
    vm.selectedCc = 'all';

    vm.range_max = 1;
    vm.range_min = 1;


    vm.sortableOptions = {
      handle: '> .myHandle',
      placeholder: "drop_style",
      connectWith: ".apps-container",
      stop: droppedUpdatePriority
    };

    vm.editUpdatePriority = editUpdatePriority;
    vm.add = add;
    vm.update = update;
    vm.confirm_remove = confirm_remove;
    vm.refresh = refresh;
    vm.canAdd = canAdd;
    vm.getScrollStop = dimensions.getScrollStop;
    vm.getCc = getCc;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      vm.loading = true;
      ksfFactory.get().then(function(ksfs) {
        addWatchers();
        vm.range_max = ksfFactory.collection.length;
        ccFactory.get().then(function(ccs) {
          // -------------------------------------
          // now fetch the divisions
          // -------------------------------------
          divisionFactory.get().then(function(divisions) {
            vm.loading = false;
            vm.divisions = divisions;
          });
        });
      });
    }

    function getCc(ccId) {
      var ccs = ccFactory.collection.filter(function(cc) {
        return cc.id == ccId;
      });
      if (ccs.length > -1) {
        return ccs[0];
      }
      return null;
    }

    function handleCollectionChange(newValue, oldValue) {
      // Normally we don't want to keep our own copy, but drag'n'drop needs to have its own model object and filters
      // are supposed to be run in the controller (see "Usage" on https://github.com/angular-ui/ui-sortable).
      if (vm.saving) { /*$log.debug('saving, so skip copying');*/ return; }
      //$log.debug('copying');
      var c = angular.copy(ksfFactory.collection);
      c = $filter('filter')(c, $scope.filterText);
      c = $filter('filterDivision')(c, currentDivision.division_id);
      c = $filter('filterCc')(c, vm.selectedCc);
      c = $filter('orderBy')(c, 'priority');
      vm.collection = c;
    }

    // We use watchers because drag'n'drop requires filtering to happen here and not in the view
    function addWatchers() {
      $scope.$watchCollection(
        function watchCollection(scope) {
          return ksfFactory.collection;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return ccFactory.collection;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return scope.filterText;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return currentDivision.division_id;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.selectedCc;
        },
        handleCollectionChange
      )
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function showDivision(division_id) {
      var selected = $filter('filter')(vm.divisions, {id: division_id});
      return (division_id && selected.length) ? selected[0].name : 'Not set';
    }

    // TODO: when updating the priority, the API should re-order all items, forcing the max priority to be
    // TODO: the count(*) amt and least to be 1 and the middle ones to be priority from 0 to count(*), without changing the order
    function editUpdatePriority(element, data) {
      console.log("edit/updating item: ", element.id, " going from ", element.priority, " to ", data);
    }

    function droppedUpdatePriority(event, ui) {
      // Where was it dropped in the visual list?
      var droppedId = parseInt(ui.item.context.id);
      var droppos = vm.collection.map(function(x) {return x.id;}).indexOf(droppedId);
      // Where should it go in the full list?
      var all = $filter('orderBy')(angular.copy(ksfFactory.collection), 'priority');
      var srcPos = all.map(function(x) {return x.id;}).indexOf(droppedId);
      var destPos = all.length - 1;  // This is the case where it was dropped at the end of the list.
      if (droppos < vm.collection.length - 1) {
        // It was dropped somewhere in the middle. It will be replacing whatever was next in the visual list, bumping
        // that one down.
        var destId = vm.collection[droppos + 1].id;
        destPos = all.map(function(x) {return x.id;}).indexOf(destId);
        if (srcPos < destPos) {
          // The current numbers assume they're dragging it up in the list, but in this case they're dragging it down we
          // need to compensate for the fact that we're losing one position
          destPos -= 1;
        }
      }
      // Make the move!
      //$log.debug("moving position " + srcPos + " to " + destPos);
      all.move(srcPos, destPos);
      // Now recalculate the priorities and save
      reprioritize(all);
    }

    function reprioritize(all) {
      vm.saving = true;
      var updatedCount = 0;
      for (var i = all.length; i--;) {
        var ksf = all[i];
        ksf.priority = i+1;
        ksfFactory.save(ksf).then(function(r) {
          updatedCount += 1;
          if (updatedCount == all.length) {
            vm.saving = false;
          }
        });
      }
    }

    function canAdd() {
      return true;
      //return (ksfFactory.collection.length > 0 && (vm.ksfs.length == 0 || vm.ksfs[vm.ksfs.length - 1].id != 0));
    }

    var defaultRecord = {description: null, status: "active"}

    function add() {
      if (canAdd()) {
        var division_id = parseInt(currentDivision.division_id);
        if (isNaN(division_id)) {
          division_id = vm.divisions[0].id;
        }
        ksfFactory.save(angular.merge(defaultRecord, {priority: 0, division_id:division_id})).then(function(r) {
          alerts.info("Industry Key Success Factor", "Successfully updated");
        }, function(e){
          alerts.error("Industry Key Success Factor", "Failed to update", e);
          console.log("Failed to add: ", e);
        });
      }
    }

    function remove(o) {
      ksfFactory.delete(o).then(function(r) {
        var all = $filter('orderBy')(angular.copy(ksfFactory.collection), 'priority');
        reprioritize(all);
        alerts.info("Industry Key Success Factor", "Successfully removed");
      }, function(e){
        console.log("Failed to delete: ", e);
        alerts.error("Industry Key Success Factor", "Failed to update", e);
      });
    }

    function confirm_remove(o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete Industry Key Success Factor " + o.priority + "?";
          },
          msg: function() {
            return "Delete Industry Key Success Factor " + o.priority + ": '" + o.description + "'?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        remove(o);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function refresh() {
      ksfFactory.refresh().then(function(r) {
        console.log("refreshed!");
      }, function(e){
        console.log("Failed to refresh: ", e);
      });
    }

    function update(o, key, $data) {
      o[key] = $data;
      ksfFactory.save(o).then(function(r){
        alerts.info("Industry Key Success Factor", "Successfully updated");
      }, function(e){
        console.log("iksf: Had a problem saving: ", e);
        alerts.error("Industry Key Success Factor", "Failed to update", e);
      });
      return false;  // return false so that the model update happens via our factory
    }

  }
})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('ExternalEnvironmentReviewController', ExternalEnvironmentReviewController);

  /** @ngInject */
  function ExternalEnvironmentReviewController($http, $window, TinymceOptions, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.document = undefined;
    vm.tinymceOptions = TinymceOptions;
    vm.editorHeight = $window.innerHeight * .6;
    vm.eer = {id: null, body: ""};

    vm.cancel = cancel;
    vm.save = save;

    vm.canCancel = canCancel;
    vm.canSave = canSave;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      vm.loading = true;
      $http.get('/api/external-environment-review').then(function(r){
        console.log("we got some eer's: ", r);
        if (r.data.documents && r.data.documents.length > 0) {
          vm.eer = r.data.documents[0];
          vm.document = angular.copy(vm.eer.body);
          vm.loading = false;
        }
      }, function(e) {
        alerts.error("Fetching Environment Review", "Error while fetching external environment review", e);
        console.log("Error getting external env rev")
      });
      console.log("I am activating this controller");

    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function canSave() {
      return vm.eer && (vm.document != vm.eer.body);
    }

    function canCancel() {
      return vm.eer && (vm.document != vm.eer.body);
    }

    function cancel() {
      if (vm.eer) {
        vm.document = vm.eer.body;
      }
    }

    function save() {
      if (canSave()) {
        $http.put('/api/external-environment-review/' + vm.eer.id, {'body': vm.document}).then(function (r) {
          activate();
          alerts.info("External Environment Review", "Successfully updated");
        }, function(e) {
          alerts.error("External Environment Review", "Failed to update", e);
        });
      }
    }

  }
})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('ExecutiveSummaryController', ExecutiveSummaryController);

  /** @ngInject */
  function ExecutiveSummaryController($http, $window, TinymceOptions, alerts) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.document = undefined;
    vm.tinymceOptions = TinymceOptions;
    vm.editorHeight = $window.innerHeight * .6;
    vm.es = {id: null, body: ""};

    vm.cancel = cancel;
    vm.save = save;

    vm.canCancel = canCancel;
    vm.canSave = canSave;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      vm.loading = true;
      $http.get('/api/executive-summary').then(function(r){
        console.log("we got some es's: ", r);
        if (r.data.documents && r.data.documents.length > 0) {
          vm.es = r.data.documents[0];
          vm.document = angular.copy(vm.es.body);
          vm.loading = false;
        }
      }, function(e) {
        alerts.error("Fetching Executive Summary", "Error while fetching executive summary", e);
        console.log("Error getting exec review")
      });
      console.log("I am activating this controller");

    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function canSave() {
      return vm.es && (vm.document != vm.es.body);
    }

    function canCancel() {
      return vm.es && (vm.document != vm.es.body);
    }

    function cancel() {
      if (vm.es) {
        vm.document = vm.es.body;
      }
    }

    function save() {
      if (canSave()) {
        $http.put('/api/executive-summary/' + vm.es.id, {'body': vm.document}).then(function (r) {
          activate();
          alerts.info("Executive Summary", "Successfully updated");
        }, function(e) {
          alerts.error("Executive Summary", "Failed to update", e);
        });
      }
    }

  }
})();

(function() {
  'use strict';


  angular
    .module('webapp')
    .controller('CoreCompetenciesController', CoreCompetenciesController);

  /** @ngInject */
  function CoreCompetenciesController(
    $scope,
    $filter,
    $log,
    $uibModal,
    divisionFactory,
    ccFactory,
    statusFactory,
    scopeFactory,
    ksfFactory,
    currentDivision,
    alerts,
    dimensions
  ) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.subSubSubTitle = "Manage Your Core Competencies";

    vm.showDivision = showDivision;
    vm.divisions = [];
    vm.collection = undefined;
    vm.ccFactory =ccFactory;
    vm.currentDivision = currentDivision;
    vm.loading = true;

    vm.selectedKsf = "all";
    vm.selectedScope = "all";
    vm.selectedStatus = "active";
    vm.range_max = 1;
    vm.range_min = 1;

    vm.saving = false;

    vm.sortableOptions = {
      handle: '> .myHandle',
      placeholder: "drop_style",
      connectWith: ".apps-container",
      stop: droppedUpdatePriority
    };

    vm.editUpdatePriority = editUpdatePriority;
    vm.refresh = refresh;
    vm.confirm_remove = confirm_remove;
    vm.add = add;
    vm.canAdd = canAdd;
    vm.showKSF = showKSF;
    vm.statuses = undefined;
    vm.update = update;
    vm.getScrollStop = dimensions.getScrollStop;
    vm.ksfs = undefined;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      loadAll();
    }

    function handleCollectionChange(newValue, oldValue) {
      // Normally we don't want to keep our own copy, but drag'n'drop needs to have its own model object and filters
      // are supposed to be run in the controller (see "Usage" on https://github.com/angular-ui/ui-sortable).
      if (vm.saving) { /*$log.debug('saving, so skip copying');*/ return; }
      //$log.debug('copying');
      var c = angular.copy(ccFactory.collection);
      c = $filter('filter')(c, $scope.filterText);
      c = $filter('filterDivision')(c, currentDivision.division_id);
      c = $filter('filterScope')(c, vm.selectedScope);
      c = $filter('filterStatus')(c, vm.selectedStatus);
      c = $filter('filterKsf')(c, vm.selectedKsf);
      c = $filter('orderBy')(c, 'priority');
      vm.collection = c;
    }

    // We use watchers because drag'n'drop requires filtering to happen here and not in the view
    function addWatchers() {
      $scope.$watchCollection(
        function watchCollection(scope) {
          return ccFactory.collection;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return scope.filterText;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return currentDivision.division_id;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.selectedScope;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.selectedStatus;
        },
        handleCollectionChange
      );
      $scope.$watchCollection(
        function watchCollection(scope) {
          return vm.selectedKsf;
        },
        handleCollectionChange
      );
    }

    function loadAll() {
      vm.loading = true;
      ccFactory.get().then(function(ccs) {
        addWatchers();
        //console.log("I just got from factory CCS=", vm.collection);
        vm.range_max = ccFactory.collection.length;

        // -------------------------------------
        // now fetch the divisions
        // -------------------------------------
        divisionFactory.get().then(function(divisions) {
          vm.loading = false;
          vm.divisions = divisions;
        });

        // -------------------------------------
        // now fetch the ksfs
        // -------------------------------------
        ksfFactory.get().then(function(ksfs) {
          vm.loading = false;
          vm.ksfs = ksfs;
        });
      });
      // can these happen in parallel? (we could use $q.all too right?)
      statusFactory.get().then(function(statuses){
        vm.statuses = statuses;
      });
      scopeFactory.get().then(function(scopes){
        vm.scopes = scopes;
      });
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function showDivision(division_id) {
      var selected = $filter('filter')(vm.divisions, {id: division_id});
      return (division_id && selected.length) ? selected[0].name : null;
    }

    // TODO: when updating the priority, the API should re-order all items, forcing the max priority to be
    // TODO: the count(*) amt and least to be 1 and the middle ones to be priority from 0 to count(*), without changing the order
    function editUpdatePriority(element, data) {
      console.log("edit/updating item: ", element.id, " going from ", element.priority, " to ", data);
    }

    function droppedUpdatePriority(event, ui) {
      // Where was it dropped in the visual list?
      var droppedId = parseInt(ui.item.context.id);
      var droppos = vm.collection.map(function(x) {return x.id;}).indexOf(droppedId);
      // Where should it go in the full list?
      var all = $filter('orderBy')(angular.copy(ccFactory.collection), 'priority');
      var srcPos = all.map(function(x) {return x.id;}).indexOf(droppedId);
      var destPos = all.length - 1;  // This is the case where it was dropped at the end of the list.
      if (droppos < vm.collection.length - 1) {
        // It was dropped somewhere in the middle. It will be replacing whatever was next in the visual list, bumping
        // that one down.
        var destId = vm.collection[droppos + 1].id;
        destPos = all.map(function(x) {return x.id;}).indexOf(destId);
        if (srcPos < destPos) {
          // The current numbers assume they're dragging it up in the list, but in this case they're dragging it down we
          // need to compensate for the fact that we're losing one position
          destPos -= 1;
        }
      }
      // Make the move!
      //$log.debug("moving position " + srcPos + " to " + destPos);
      all.move(srcPos, destPos);
      // Now recalculate the priorities and save
      reprioritize(all);
    }

    function reprioritize(all) {
      vm.saving = true;
      var updatedCount = 0;
      for (var i = all.length; i--;) {
        var cc = all[i];
        cc.priority = i+1;
        ccFactory.save(cc).then(function(r) {
          updatedCount += 1;
          if (updatedCount == all.length) {
            vm.saving = false;
          }
        });
      }
    }

    function canAdd() {
      //return (vm.collection.length == 0 || vm.collection[vm.collection.length - 1].id != 0);
      return true;

    }

    function showKSF(element) {
      var selected = [];
      angular.forEach(vm.ksfs, function(s) {
        if (element.key_success_factors.indexOf(s.id) >= 0) {
          selected.push(s.priority + ': ' + s.description);
        }
      });
      return selected.length ? selected.join(', ') : null;
    }

    function remove(o) {
      ccFactory.delete(o).then(function(r) {
        console.log("removed")
        var all = $filter('orderBy')(angular.copy(ccFactory.collection), 'priority');
        reprioritize(all);
        alerts.info("Core Competency", "Successfully removed");
      }, function(e){
        console.log("Failed to delete: ", e);
        alerts.error("Core Competency", "Failed to remove", e);
      });
    }

    function confirm_remove(o) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/components/confirm-modal/confirm-modal.html',
        controller: 'ConfirmModalCtrl',
        resolve: {
          title: function() {
            return "Delete Core Competency " + o.priority + "?";
          },
          msg: function() {
            return "Delete Core Competency " + o.priority + ": '" + o.description + "'?";
          }
        }
      });
      modalInstance.result.then(function (selectedItem) {
        remove(o);
      }, function () {
        $log.debug("No delete for you!");
      });
    }

    function refresh() {
      ccFactory.refresh().then(function(r) {
        console.log("refreshed!");
      }, function(e){
        console.log("Failed to refresh: ", e);
      });
    }

    function update(o, key, $data) {
      o[key] = $data;
      ccFactory.save(o).then(function(r){
        console.log("really great, just saved: ", r);
        alerts.info("Core Competency", "Successfully updated");
        if (key == 'key_success_factors') {
          // Since we changed ksf, refresh that.
          ksfFactory.refresh();
        }
      }, function(e){
        alerts.error("Core Competency", "Failed to update", e);
        console.log("Had a problem saving: ", e);
      });
      return false;  // return false so that the model update happens via our factory
    }

    var defaultRecord = {description: null, scope: "present", status: "active"}

    function add() {
      if (canAdd()) {
        var division_id = parseInt(currentDivision.division_id);
        if (isNaN(division_id)) {
          division_id = vm.divisions[0].id;
        }
        ccFactory.save(angular.merge(defaultRecord, {division_id: division_id, priority: 0})).then(function (r) {
          console.log("saved new record, r=", r);
          alerts.info("Core Competency", "Successfully saved");
        }, function (e) {
          alerts.error("Core Competency", "Failed to add", e);
        });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController() {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.subSubSubTitle = "I am a sub sub sub title";
    vm.things = ['a', 'b', 'c'];
    vm.widgetFunction = widgetFunction;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
        console.log("I am activating this controller");

    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function widgetFunction() {
        console.log("the user clicked this widget function thing");
    }


  }
})();


(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('ConfirmModalCtrl', ConfirmModalCtrl);

  /** @ngInject */
  function ConfirmModalCtrl($scope, $uibModalInstance, msg, title) {
    $scope.title = title;
    $scope.msg = msg;

    $scope.ok = function () {
      $uibModalInstance.close();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  };
})();


(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('ConfirmModalSelectCtrl', ConfirmModalSelectCtrl);

  /** @ngInject */
  function ConfirmModalSelectCtrl($scope, $uibModalInstance, msg, title, items, display_attribute, select_message) {
    $scope.title = title;
    $scope.msg = msg;
    $scope.items = items;
    $scope.selected_item = undefined;
    $scope.display_attribute = display_attribute;
    $scope.select_message = select_message;

    $scope.ok = function () {
      $uibModalInstance.close($scope.selected_item);
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.notReadyToClick = function() {
      return ! $scope.selected_item;
    };

  };
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('CompanyDash', CompanyDash);

  /** @ngInject */
  function CompanyDash(companyDashFactory) {
    var vm = this;

    // Public stuff gets added to vm
    vm.divisionCounts = undefined;
    vm.totals = undefined;

    vm.loaded = function loaded() {
      return vm.divisionCounts != undefined;
    };

    vm.isPast = function isPast(date) {
      return date < new Date().getTime()/1000;
    };

    // Private stuff

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    activate();
    function activate() {
      companyDashFactory.get().then(function(results) {
        vm.divisionCounts = results.division_counts;
        vm.totals = results.totals;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('BaseController', BaseController);

  /** @ngInject */
  function BaseController($scope, $window, Principal) {
    var vm = $scope;  // this is unlike other controllers, we have to use $scope with an abstract base.. not sure why
    // NOTE: only $scope seems to work with a base/parent controller... maybe because controllerAs is being occupied by the child?
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    // NOTE: only $scope seems to work with a base/parent controller... maybe because controllerAs is being occupied by the child?
    vm.contentMinHeight = $window.innerHeight * .9;
    vm.principal = Principal;
    vm.thetime = new Date();

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

  }
})();

/**
 * Created by eric on 10/19/15.
 */


(function () {
  'use strict';

  angular
    .module('webapp')
    .factory('Principal', principal);

  /** @ngInject */
  function principal($q, $http, accountFactory, allDivisionFactory, ccFactory, ksfFactory,
                     objectiveCommentFactory, objectiveFactory, personalDashFactory, statusFactory,
                     swotCommentFactory, swotFactory, swotOpportunityFactory, swotStrengthFactory,
                     swotThreatFactory, swotWeaknessFactory, tacticCommentFactory, tacticFactory,
                     tenantFactory) {
    var ORDERED_ROLES = ['support', 'assistant', 'admin'];
    console.log("Ordered Roles=", ORDERED_ROLES);
    var _identity = undefined, _authenticated = false;

    var allFactories = [
      accountFactory, allDivisionFactory, ccFactory, ksfFactory,
      objectiveCommentFactory, objectiveFactory, personalDashFactory, statusFactory,
      swotCommentFactory, swotFactory, swotOpportunityFactory, swotStrengthFactory,
      swotThreatFactory, swotWeaknessFactory, tacticCommentFactory, tacticFactory,
      tenantFactory
    ];

    var service = {
      name: undefined,
      in_master_org: false,
      is_switched: false,
      is_admin: false,
      user: undefined,
      can_switch: false,

      // This allows us to check to see if the last login was by token, so that when the user saves their profile, we can just take them right to their dashboard
      // We only do this the 1st time after token login (assuming that they reset their password)
      last_action_login_by_token: false,
      popLastActionLoginByToken: function() {
        var r = this.last_action_login_by_token;
        this.last_action_login_by_token = false;
        return r;
      },

      isIdentityResolved: function () {
        return angular.isDefined(_identity);
      },

      isAuthenticated: function () {
        //console.log("isAuthenticated: ", _authenticated);
        return _authenticated;
      },

      hasRole: function (role) {
        console.log("hasRole: ", role, "?");
        if (_identity) {
          var userRoleIdx = ORDERED_ROLES.indexOf(_identity.role);
          var requestedRoleIdx = ORDERED_ROLES.indexOf(role);
          console.log("the userRoleIdx=", userRoleIdx, " while requestedRoleIdx=", requestedRoleIdx);
          if (userRoleIdx != -1 && requestedRoleIdx != -1) {
            console.log("well, is >=? ", userRoleIdx >= requestedRoleIdx);
            return userRoleIdx >= requestedRoleIdx;
          }
        }
        return false;
      },

      __signed_in: function (data) {
        console.log("data.user=", data.user);
        if (data.user) {
          service.name = data.user.user_name;
          service.username = data.user.user_username;
          service.current_org = data.user.current_org;
          service.division_id = data.user.division_id;
          service.user = data.user;
          service.in_master_org = data.user.in_master_org;
          service.is_switched = data.user.current_org != data.user.origin_schema;
          service.is_admin = data.user.is_admin;
          service.can_switch = data.user.in_master_org && data.user.is_admin;
          //service.org_name = data.user.logged_in_user_selected_org.name;
          //service.orgs = data.user.logged_in_user_available_orgs;
          _identity = data.user;
          _authenticated = true;
        }
      },

      __signed_out: function () {
        service.name = undefined;
        service.orgs = undefined;
        _identity = undefined;
        _authenticated = false;
        for (var i=0; i<allFactories.length; i++) {
          allFactories[i].invalidate();
        }
      },

      identity: function (force) {
        var deferred = $q.defer();
        if (force === true) _identity = undefined;
        // check and see if we have retrieved the identity data from the server. if we have, reuse it by immediately resolving
        if (angular.isDefined(_identity)) {
          deferred.resolve(_identity);
          return deferred.promise;
        }
        $http.get('/api/user/authorized', {ignoreErrors: true}).
          success(function (r) {
            console.log("get/login: r=", r);
            if (r.authorized) {
              service.__signed_in(r);
            } else {
              service.__signed_out();
            }
            deferred.resolve(_identity);
          }).
          error(function (r) {
            service.__signed_out();
            deferred.resolve(_identity);
          });

        return deferred.promise;
      },

      login: function (organization_slug, username, password, remember) {
        var deferred = $q.defer();
        $http.post('/api/login', {
          organization_slug: organization_slug,
          username: username,
          password: password,
          remember: remember
        }).then(function success(r) {
          //console.log("post/login: r=", r);
          service.__signed_in(r.data);
          deferred.resolve(r.data);
        }).catch(function error(result) {
          console.log("FAILED to login, keep up the login form!!");
          deferred.reject(result);
        });
        return deferred.promise;
      },

      loginWithToken: function (organization_slug, token) {
        var deferred = $q.defer();
        $http.post('/api/login-with-token', {org: organization_slug, token: token}).then(function success(r) {
          service.__signed_in(r.data);
          service.last_action_login_by_token = true;
          deferred.resolve(r);
        }).catch(function error(result) {
          console.log("FAILED to login with token!")
          deferred.reject(result);
        });
        return deferred.promise;
      },

      logout: function () {
        var deferred = $q.defer();
        var self = service;
        $http.delete('/api/login').then(function success(r) {
          self.__signed_out();

          deferred.resolve();
        }).catch(function error(r) {
          deferred.reject();
          console.log("Failed to log out... ", r);
        });
        return deferred.promise;
      },

      switchTenant: function (tenant_id) {
        var deferred = $q.defer();
        $http.put('/api/current-tenant/' + tenant_id).then(function success(r) {
          service.identity(true);
          deferred.resolve();
        }).catch(function error(result) {
          console.log("FAILED to change selected organization");
          deferred.reject();
        });
        return deferred.promise;
      }

    };

    service.identity(true);
    return service;
  }

})();


/**
 * Created by eric on 10/19/15.
 */


(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('Password', Password);

  /** @ngInject */
  function Password($q, $http) {
    var service = {
      sendPasswordReset: function(organization_slug, email, style) {
        // send a token to the user's email
        var deferred = $q.defer();
        $http.post('/api/send-password-reset', {org: organization_slug, email: email, style: style, origin: window.location.origin}).then(function success(r) {
          deferred.resolve(r);
        }).catch(function error(result) {
          deferred.reject(result);
        });
        return deferred.promise;
      }

    };

    return service;
  }

})();


/**
 * Created by eric on 10/19/15.
 * see: http://stackoverflow.com/questions/22537311/angular-ui-router-login-authentication
 */

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('Authorization', authorization);

  /** @ngInject */
  function authorization($rootScope, $state, Principal) {
    // This is for role authorization on a particular state
    var service = {
      authorize: function() {
        return Principal.identity()
          .then(function () {
            var isAuthenticated = Principal.isAuthenticated();
            if (isAuthenticated) {
              if ($rootScope.toState) {
                if ($rootScope.toState.data && $rootScope.toState.data.role) {
                  if (Principal.hasRole($rootScope.toState.data.role)) {
                    console.log("Looks good, we won't interfere with the page transition");
                  } else {
                    $state.go('accessdenied'); // user is signed in but not authorized for desired state
                  }
                } else {
                  console.log("Looks good, we won't interfere with the page transition");
                }
              } else {
                console.log("authorization, and we are good, let the transition happen!");
              }
            } else {
              // user is not authenticated. stow the state they wanted before you
              // send them to the signin state, so you can return them when you're done
              $rootScope.returnToState = $rootScope.toState;
              $rootScope.returnToStateParams = $rootScope.toStateParams;
              $state.go('login');
            }

          });
      }
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .controller('BaseOrganizationController', BaseOrganizationController);

  /** @ngInject */
  function BaseOrganizationController($log, $state, Principal) {
    var vm = this;
    // ----------------------------------
    // This is where we modify the vm variable, prepping the controller before it runs against the template
    // ----------------------------------

    vm.isActive = isActive;
    vm.principal = Principal;

    activate();

    // ----------------------------------
    // This is where we initialize the controller
    // ----------------------------------
    function activate() {
      // nothing yet
    }

    // ----------------------------------
    // This is where we put all the function definitions
    // ----------------------------------

    function isActive(name) {
      //console.log("is ", name, " == ", $state.current.name, "?");
      return name == $state.current.name;
    }

  }
})();

/**
 * Created by eric on 01/09/16.
 */


(function () {
  'use strict';

  angular
    .module('webapp')
    .factory('dimensions', Dimensions);

  /** @ngInject */
  function Dimensions($q, $timeout) {
    var scrollStopChecks = 0;
    var scrollStopCache = null;
    var service = {
      getScrollStop: function(id) {
        //var deferred = $q.defer();
        //
        //$timeout(function() {
        //  console.log("Ok, we can return now!!!");
        //  deferred.resolve(50);
        //  //deferred.resolve($('.navbar').height());
        //}, 0);


        var s = scrollStopCache;
        if (true || s == null) {
          scrollStopChecks++;
          var s = $('.navbar-fixed-top').height();
          //var s = $('.navbar').height();
          if (scrollStopChecks > 10) {  // it stabilizes before this
            scrollStopCache = s;
          }
        }
        return s;
        //return deferred.promise;
      }
    };

    return service;
  }

})();


/**
 * Created by eric on 01/09/16.
 */


(function () {
  'use strict';

  angular
    .module('webapp')
    .factory('currentDivision', CurrentDivision);

  /** @ngInject */
  function CurrentDivision($log, $q, Principal) {
    var service = {
      division_id: 'all',
      reload: function() {
        var deferred = $q.defer();
        var self = this;
        Principal.identity().then(function(r){
          if ((!Principal.is_switched) && Principal.division_id) {
            self.division_id = Principal.division_id.toString();
            console.log("Just set division_id=", self.division_id);
          }
          deferred.resolve(r);
        }, function(e){
          deferred.reject(e);
          $log.error(e);
        });
        return deferred.promise;
      }
    };

    service.reload();

    return service;
  }

})();


/**
 * Created by eric on 01/09/16.
 */


(function () {
  'use strict';

  angular
    .module('webapp')
    .factory('Annotator', Annotator);

  /** @ngInject */
  function Annotator($q) {
    var makeShallowList = function (deepList, primaryKey) {
      var shallowList = [];
      for (var i = 0; i < deepList.length; i++) {
        shallowList.push(deepList[i][primaryKey]);
      }
      return shallowList;
    };

    var service = {
      // injects an '__annotation' object into each element to resolve later
      annotateList: function (aList, aFactory, deepListKey, shallowListKey, primaryKey) {
        for (var i = 0; i < aList.length; i++) {
          service.annotateObject(aList[i], aFactory, deepListKey, shallowListKey, primaryKey);
        }
        return aList;
      },

      annotateObject: function (object, aFactory, deepListKey, shallowListKey, primaryKey) {
        //var object = angular.copy(rawObject);
        object[shallowListKey] = makeShallowList(object[deepListKey], primaryKey);  // these are the currently selected items
        object.__annotation = {
          unwind: function () {
            var deferred = $q.defer();
            var newobject = angular.copy(object);
            delete newobject.__annotation;
            //console.log("RESOLVING IDS: ", newobject[shallowListKey]);
            aFactory.resolveIds(newobject[shallowListKey]).then(function (objects) {
              //console.log("RESOLVED OBJS: ", objects);
              newobject[deepListKey] = objects;
              delete newobject[shallowListKey];
              deferred.resolve(newobject);
            }, function (e) {
              deferred.reject(e);
            });
            return deferred.promise;
          }
        };
      }

    };

    return service;
  }

})();


/**
 * Created by eric on 01/09/16.
 */


(function () {
  'use strict';

  angular
    .module('webapp')
    .factory('alerts', Alerts);

  // Thanks: http://stackoverflow.com/questions/17289448/angularjs-to-output-plain-text-instead-of-html
  function htmlToPlaintext(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  }

  function dumpError(error) {
    if (! error || error == undefined || error == null) {
      return "";
    }
    var keys = ['statusText', 'status', 'data'];
    var retval = "";
    for (var i = 0; i < keys.length; i++) {
      if (keys[i] in error) {
        retval = retval + " " + error[keys[i]];
      }
    }
    var r = htmlToPlaintext(retval);
    return r.length > 0 ? ": " + r : "";
  };

  var LONG_TIMEOUT = 20000;


  /** @ngInject */
  function Alerts(toastr) {
    var service = {
      error: function (title, body, error) {
        toastr.error(body + dumpError(error), title, {timeOut: LONG_TIMEOUT});
      },
      info: function (title, body) {
        toastr.info(body, title);
      },
      warning: function (title, body) {
        toastr.warning(body, title);
      },
      infoLong: function(title, body) {
        toastr.info(body, title, {timeOut: LONG_TIMEOUT});
      }
    };

    return service;
  }

})();


(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('tenantFactory', tenantFactory);

  /** @ngInject */
  function tenantFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'tenantFactory';
    child.getUrl = '/api/tenant';
    child.saveUrl = '/api/tenant';
    child.deleteUrl = '/api/tenant';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.tenants;
    };

    child.transformObjectFromSave = function (d) {
      return d.tenant;
    };

    child.transformObjectFromDelete = function(d) {
      return d.tenant;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.tenant;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('tacticFactory', tacticFactory);

  /** @ngInject */
  function tacticFactory($filter, CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'tacticFactory';
    child.getUrl = '/api/tactic';
    child.saveUrl = '/api/tactic';
    child.deleteUrl = '/api/tactic';  // caller will tack in /<id>

    function convertDates(tactic) {
      tactic.due_date = $filter('isoToDate')(tactic.due_date, true);
      tactic.update_due_date = $filter('isoToDate')(tactic.update_due_date, true);
      tactic.complete_date = $filter('isoToDate')(tactic.complete_date, true);
      return tactic;
    }

    child.transformCollectionFromGet = function (d) {
      for (var i = d.tactics.length; i--;) {
        d.tactics[i] = convertDates(d.tactics[i]);
      }
      return d.tactics;
    };

    child.transformObjectFromSave = function (d) {
      return convertDates(d.tactic);
    };

    child.transformObjectFromDelete = function(d) {
      return d.tactic;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return convertDates(d.tactic);
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('tacticCommentFactory', tacticCommentFactory);

  /** @ngInject */
  function tacticCommentFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'tacticCommentFactory';
    child.getUrl = '/api/tactic-comment';
    child.saveUrl = '/api/tactic-comment';
    child.deleteUrl = '/api/tactic-comment';  // caller will tack in /<id>

    child.transformCollectionFromGet = function (d) {
      return d.tactic_comments;
    };

    child.transformObjectFromSave = function (d) {
      return d.tactic_comment;
    };

    child.transformObjectFromDelete = function(d) {
      return d.tactic_comment;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.tactic_comment;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotWeaknessFactory', swotWeaknessFactory);

  /** @ngInject */
  function swotWeaknessFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'swotWeaknessFactory';
    child.getUrl = '/api/swot/weakness';
    child.saveUrl = '/api/swot/weakness';
    child.deleteUrl = '/api/swot/weakness';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.swots;
    };

    child.transformObjectFromSave = function (d) {
      return d.swot;
    };

    child.transformObjectFromDelete = function(d) {
      return d.swot;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.swot;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotThreatFactory', swotThreatFactory);

  /** @ngInject */
  function swotThreatFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'swotThreatFactory';
    child.getUrl = '/api/swot/threat';
    child.saveUrl = '/api/swot/threat';
    child.deleteUrl = '/api/swot/threat';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.swots;
    };

    child.transformObjectFromSave = function (d) {
      return d.swot;
    };

    child.transformObjectFromDelete = function(d) {
      return d.swot;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.swot;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotStrengthFactory', swotStrengthFactory);

  /** @ngInject */
  function swotStrengthFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'swotStrengthFactory';
    child.getUrl = '/api/swot/strength';
    child.saveUrl = '/api/swot/strength';
    child.deleteUrl = '/api/swot/strength';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.swots;
    };

    child.transformObjectFromSave = function (d) {
      return d.swot;
    };

    child.transformObjectFromDelete = function(d) {
      return d.swot;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.swot;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotOpportunityFactory', swotOpportunityFactory);

  /** @ngInject */
  function swotOpportunityFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'swotOpportunityFactory';
    child.getUrl = '/api/swot/opportunity';
    child.saveUrl = '/api/swot/opportunity';
    child.deleteUrl = '/api/swot/opportunity';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.swots;
    };

    child.transformObjectFromSave = function (d) {
      return d.swot;
    };

    child.transformObjectFromDelete = function(d) {
      return d.swot;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.swot;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotFactory', swotFactory);

  /** @ngInject */
  function swotFactory($q, swotOpportunityFactory, swotStrengthFactory, swotThreatFactory, swotWeaknessFactory) {

    var factories = [swotOpportunityFactory, swotStrengthFactory, swotThreatFactory, swotWeaknessFactory];
    var cache = {};

    var pub = {};
    pub.name = "swotFactory";
    pub.invalidate = function() {
      cache={};
    };

    pub.getById = function(id) {
      for (var i=0; i<factories.length; i++) {
        var o = factories[i].getById(id);
        if (o) {
          cache[id] = o;
          return o;
        }
      }
      return undefined;
    };

    pub.get = function() {
      return $q.all([
        swotOpportunityFactory.get(),
        swotStrengthFactory.get(),
        swotThreatFactory.get(),
        swotWeaknessFactory.get()
      ]);
    };

    return pub;
  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('swotCommentFactory', swotCommentFactory);

  /** @ngInject */
  function swotCommentFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'swotCommentFactory';
    child.getUrl = '/api/swot-comment';
    child.saveUrl = '/api/swot-comment';
    child.deleteUrl = '/api/swot-comment';  // caller will tack in /<id>


    function isoToDate(isoDateStr) {
      // 'undefined' will cause the date filter to not show a date
      return isoDateStr ? new Date(isoDateStr) : undefined;
    }

    child.transformCollectionFromGet = function (d) {
      if (!d.swot_comments) { return []; }
      for (var i = d.swot_comments.length; i--;) {
        var comment = d.swot_comments[i];
        comment.created_date = isoToDate(comment.created_date);
      }
      return d.swot_comments;  // convenience
    };

    child.transformObjectFromSave = function (d) {
      return d.swot_comment;
    };

    child.transformObjectFromDelete = function(d) {
      return d.swot_comment;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.swot_comment;
    };


    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('statusFactory', statusFactory);

  /** @ngInject */
  function statusFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'statusFactory';
    child.getUrl = '/api/status';

    child.transformCollectionFromGet = function(d) {
      return d.statuses;
    };

    child.transformObjectFromGet = function(d) {
      return d.status;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('scopeFactory', scopeFactory);

  /** @ngInject */
  function scopeFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'scopeFactory';
    child.getUrl = '/api/scopes';

    child.transformCollectionFromGet = function(d) {
      return d.scopes;
    };

    child.transformObjectFromGet = function(d) {
      return d.status;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('personalDashFactory', personalDashFactory);

  /** @ngInject */
  function personalDashFactory($http, $log, $q) {
    //
    // Private
    //
    var promises = [];

    //
    // Public
    //
    var pub = {};
    pub.name = "personalDashFactory";
    pub.invalidate = function() {};
    // Multiple promise resolution from a single request idea courtesy of
    // http://maurizionapoleoni.de/blog/using-effective-promise-caching-in-factories-with-angularjs/

    pub.get = function search() {
      return $http.get('/api/dashboard/personal').then(function (response) {
        return response.data;
      })
    };

    return pub;
  }
})();


(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('objectiveFactory', objectiveFactory);

  /** @ngInject */
  function objectiveFactory($filter, CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'objectiveFactory';
    child.getUrl = '/api/objective';
    child.saveUrl = '/api/objective';
    child.deleteUrl = '/api/objective';  // caller will tack in /<id>

    function convertDates(objective) {
      objective.due_date = $filter('isoToDate')(objective.due_date, true);
      objective.update_due_date = $filter('isoToDate')(objective.update_due_date, true);
      objective.complete_date = $filter('isoToDate')(objective.complete_date, true);
      return objective;
    }

    child.transformCollectionFromGet = function(d) {
      for (var i = d.objectives.length; i--;) {
        d.objectives[i] = convertDates(d.objectives[i]);
      }
      return d.objectives;
    };

    child.transformObjectFromSave = function(d) {
      return convertDates(d.objective);
    };

    child.transformObjectFromDelete = function(d) {
      return d.objective;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return convertDates(d.objective);
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('objectiveCommentFactory', objectiveCommentFactory);

  /** @ngInject */
  function objectiveCommentFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'objectiveCommentFactory';
    child.getUrl = '/api/objective-comment';
    child.saveUrl = '/api/objective-comment';
    child.deleteUrl = '/api/objective-comment';  // caller will tack in /<id>

    child.transformCollectionFromGet = function (d) {
      return d.objective_comments;
    };

    child.transformObjectFromSave = function (d) {
      return d.objective_comment;
    };

    child.transformObjectFromDelete = function(d) {
      return d.objective_comment;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.objective_comment;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('ksfFactory', ksfFactory);

  /** @ngInject */
  function ksfFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'ksfFactory';
    child.getUrl = '/api/ksf';
    child.saveUrl = '/api/ksf';
    child.deleteUrl = '/api/ksf';


    child.transformCollectionFromGet = function(d) {
      return d.ksfs;
    };

    child.transformObjectFromSave = function(d) {
      return d.ksf;
    };

    child.transformObjectFromDelete = function(d) {
      return d.ksf;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.ksf;
    };

    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('divisionFactory', divisionFactory);

  /** @ngInject */
  function divisionFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'divisionFactory';

    child.getUrl = '/api/division';

    child.transformCollectionFromGet = function(d) {
      return d.divisions;
    };

    child.transformObjectFromGet = function(d) {
      return d.division;
    };


    return child;

  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('companyDashFactory', companyDashFactory);

  /** @ngInject */
  function companyDashFactory($http, $log, $q) {
    //
    // Private
    //
    var cache = null;
    var promises = [];

    //
    // Public
    //
    var pub = {};
    pub.name = 'companyDashFactory';
    pub.invalidate = function() {};

    // Multiple promise resolution from a single request idea courtesy of
    // http://maurizionapoleoni.de/blog/using-effective-promise-caching-in-factories-with-angularjs/

    pub.get = function search() {
      // For now we don't actually support search queries, we just return them all.
      var deferred = $q.defer();
      if (promises.length > 0) {
        $log.debug('companyDashFactory: saving another promise');
        promises.push(deferred);
      }
      else if (cache === null) {
        $log.debug('companyDashFactory: saving promise and calling api');
        promises.push(deferred);
        $http.get('/api/dashboard/company')
          .then(getComplete)
          .catch(getFailed);
      }
      else {
        $log.debug('companyDashFactory: resolving from cache');
        deferred.resolve(cache);
      }

      function getComplete(response) {
        $log.debug('companyDashFactory: response received, resolving ' + promises.length + ' promises');
        cache = response.data;
        for (var i = promises.length; i--;) {
          promises.shift().resolve(cache);
        }
      }

      function getFailed(error) {
        $log.error('XHR Failed for companyDashFactory.search: ' + error.data);
        for (var i = promises.length; i--;) {
          promises.shift().reject(error);
        }
      }

      return deferred.promise;
    };

    return pub;
  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('ccFactory', ccFactory);

  /** @ngInject */
  function ccFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'ccFactory';
    child.getUrl = '/api/cc';
    child.saveUrl = '/api/cc';
    child.deleteUrl = '/api/cc';  // caller will tack in /<id>


    child.transformCollectionFromGet = function (d) {
      return d.ccs;
    };

    child.transformObjectFromSave = function (d) {
      return d.cc;
    };

    child.transformObjectFromDelete = function(d) {
      return d.cc;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.cc;
    };

    return child;

  }

})();



(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('CollectionBaseFactory', CollectionBaseFactory);

  /** @ngInject */
  function CollectionBaseFactory($http, $log, $q) {
    return {
      factory: function() {
        return new CollectionBase($http, $log, $q);
      }
    };
  }

  // passed in, not injected!!!
  function CollectionBase($http, $log, $q) {
    // --------------------------------
    // The Outside rules of the factory.collection
    // --------------------------------
    // 1. you may reference factory.collection
    // 2. you may get it via promises result
    // 3. you shouldn't copy it
    // 4. you must NEVER write to it or any of it's objects
    //   a. to store, call factory.save(angular.merge(original_object, {'attr1', "val1', ...}))
    //   b. then you will automatically receive updates from the server in the form of the collection being updated
    //
    // --------------------------------
    // The Inside rules of the factory.collection
    // --------------------------------
    // 1. any method may write to pub.collection, but you MUST call reIndexCache each time
    // 2. any method may read from the supporting cache indexes (cacheIdToIdx, cacheIdToObjectMap, etc)
    // 2. no method except for reIndexCache may modify a supporting cache index

    var cacheIdToIdx = {};
    var cacheIdToObjectMap = {};
    var promises = [];

    function reIndexCache() {
      //console.log("and the cache = ", pub.collection);
      // store index by id for quick retrieval
      cacheIdToIdx = {};
      cacheIdToObjectMap = {};
      for (var i in pub.collection) {
        cacheIdToObjectMap[pub.collection[i].id] = pub.collection[i];
        cacheIdToIdx[pub.collection[i].id] = i;
      }
    }

    //
    // Public
    //
    var pub = {};
    pub.name = "baseFactory";
    pub.getUrl = null;
    pub.saveUrl = null;
    pub.deleteUrl = null;

    // WARNING: public reference for speedy access, DO NOT MODIFY array or elements, always copy, then send back to factory!!
    pub.collection = [];

    /**
     * transformCollectionFromGetApi: runs on the data that the api returns following a get
     * @param d
     */
    pub.transformCollectionFromGet = function(d) {
      throw new Error("Abstract Method");
    };

    /**
     * transformObjectFromSave: runs on the data that the api returns following a save
     * @param d
     */
    pub.transformObjectFromSave = function(d) {
      throw new Error("Abstract Method");
    };

    /**
     * transformObjectFromGet: runs on the data that the api returns following a get
     * @param d
     */
    pub.transformObjectFromGet = function(d) {
      throw new Error("Abstract Method");
    };

    /**
     * transformObjectFromDelete: runs on the data that the api returns following a delete(edited)
     * @param d
     */
    pub.transformObjectFromDelete = function(d) {
      throw new Error("Abstract Method");
    };

    /**
     * transformObjectBeforeSave: runs on your object right before it gets saved to the api
     * @param d
     */
    pub.transformObjectBeforeSave = function(d) {
      throw new Error("Abstract Method");
    };

    pub.invalidate = function() {
      pub.collection = [];
      reIndexCache();
      console.log(pub.name + ": reset cache");
    };

    pub.refresh = function() {
      this.invalidate();
      return this.get();
    };

    pub.refreshRecord = function(id) {
      var self = this;
      var deferred = $q.defer();
      $http.get(this.getUrl + "/" + id).then(function (r) {
        var o = self.transformObjectFromGet(r.data);
        if (o && o.id && o.id in cacheIdToIdx) {
          pub.collection[cacheIdToIdx[o.id]] = o;
          reIndexCache();
          deferred.resolve(o);
        } else {
          pub.refresh().then(function(rr){
            deferred.resolve(rr);
          }, function(e) {
            deferred.reject(e);
          });
        }
      }, function (e) {
        deferred.reject(e);
      });
      return deferred.promise;
    };

    pub.getById = function(id) {
      //console.log("getById(", id, ") = ", cacheIdToObjectMap[id]);
      return cacheIdToObjectMap[id];
    };

    pub.delete = function(object) {
      var deferred = $q.defer();
      if (this.deleteUrl) {
        var id = 'id' in object ? object.id : object;
        // NOTE: to signify that we can just remove this object safely from the collection, a client should return {id:formerId}
        $http.delete(this.deleteUrl + "/" + id).then(function(r) {
          var updatedModel = false;
          if (r && r.data) {
            var deleteResponse = pub.transformObjectFromDelete(r.data);
            if (deleteResponse && 'id' in deleteResponse && parseInt(deleteResponse.id) == id) {
              if (id in cacheIdToIdx) {
                var idx = cacheIdToIdx[id];
                if (idx > -1) {
                  pub.collection.splice(idx, 1);
                  reIndexCache();
                  updatedModel = true;
                  deferred.resolve(r);
                }
              }
            }
          }

          if (! updatedModel) {
            $log.debug("Unfamiliar response, lets just refresh the whole list: ", r);
            pub.refresh().then(function(rr) {
              deferred.resolve(rr);
            }, function(ee) {
              deferred.reject(ee);
            });
          }

        }, function(e) {
          deferred.reject(e);
        });
      } else {
        deferred.reject("Cannot delete from this collection");
      }
      return deferred.promise;
    };

    pub.resolveIds = function(idlist) {
      var deferred = $q.defer();
      this.get().then(function(cache) {
        var objects = [];
        for (var id in idlist) {
          objects.push(cacheIdToObjectMap[idlist[id]]);
        }
        deferred.resolve(objects);
      }, function(e) {
        deferred.reject(e);
      });
      return deferred.promise;
    };

    pub.save = function(object) {
      var deferred = $q.defer();
      if (this.saveUrl) {
        var self = this;
        var isNew = ! ('id' in object);
        $http.post(this.saveUrl, self.transformObjectBeforeSave(object)).then(function(r){
          // NOTE: if you return a saveresponse object with the id, we'll assume that it is the new object and update the cache, else we refresh the whole cache
          var updatedModel = false;
          if (r && r.data) {
            var saveResponse = self.transformObjectFromSave(r.data);

            if (isNew) {
              if (saveResponse && saveResponse.id) {
                $log.debug("Is New Record, and we have a legit response");
                pub.collection.unshift(saveResponse);
                reIndexCache();
                updatedModel = true;
                deferred.resolve(r);
              }
            } else if (object.id && saveResponse && saveResponse.id && saveResponse.id == object.id && object.id in cacheIdToIdx) {
              pub.collection[cacheIdToIdx[object.id]] = saveResponse;
              reIndexCache();
              updatedModel = true;
              deferred.resolve(r);
            }
          }

          if (! updatedModel) {
            $log.debug("Unexpected response, refreshing cache");
            self.refresh().then(function(rr){
              deferred.resolve(rr);
            }, function(e) {
              deferred.reject(e);
            });
          }

        }).catch(function(e){
          deferred.reject(e);
        });
      } else {
        console.log("Cannot save to this collection");
        deferred.reject("Cannot save this collection");
      }
      return deferred.promise;
    };

    // Multiple promise resolution from a single request idea courtesy of
    // http://maurizionapoleoni.de/blog/using-effective-promise-caching-in-factories-with-angularjs/
    pub.get = function() {
      // For now we don't actually support search queries, we just return them all.
      var self = this;
      var deferred = $q.defer();
      if (promises.length > 0) {
        $log.debug('baseFactory: saving another promise');
        promises.push(deferred);
      }
      else if (! pub.collection || pub.collection.length < 1) {
        //$log.debug('baseFactory: saving promise and calling GET api');
        promises.push(deferred);
        $http.get(self.getUrl)
          .then(getComplete)
          .catch(getFailed);
      }
      else {
        //$log.debug('baseFactory: resolving from cache');
        deferred.resolve(pub.collection);
      }

      function getComplete(response) {
        //$log.debug('baseFactory: response received, resolving ' + promises.length + ' promises');
        if (response && response.data) {
          pub.collection = self.transformCollectionFromGet(response.data);
          reIndexCache();
          for (var i = promises.length; i--;) {
            promises.shift().resolve(pub.collection);
          }
        } else {
          for (var i = promises.length; i--;) {
            promises.shift().reject({'status': false, details: "Failed to download data "});
          }
        }

      }

      function getFailed(error) {
        $log.error('XHR Failed for baseFactory.search: ' + error.data);
        for (var i = promises.length; i--;) {
          promises.shift().reject(error);
        }
      }

      return deferred.promise;
    };

    return pub;
  }
})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('allDivisionFactory', allDivisionFactory);

  /** @ngInject */
  function allDivisionFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'allDivisionFactory';
    child.getUrl = '/api/division?all=true';
    child.saveUrl = '/api/division';
    child.deleteUrl = '/api/division';

    child.transformCollectionFromGet = function(d) {
      return d.divisions;
    };

    child.transformObjectFromSave = function(d) {
      return d.division;
    };

    child.transformObjectFromDelete = function(d) {
      return d.division;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.division;
    };


    return child;

  }

})();


(function() {
  'use strict';

  angular
    .module('webapp')
    .factory('accountFactory', accountFactory);

  /** @ngInject */
  function accountFactory(CollectionBaseFactory) {

    var child = CollectionBaseFactory.factory();
    child.name = 'accountFactory';
    child.getUrl = '/api/account';
    child.saveUrl = '/api/account';
    child.deleteUrl = '/api/account';


    child.transformCollectionFromGet = function (d) {
      return d.accounts;
    };

    child.transformObjectFromSave = function (d) {
      return d.account;
    };


    child.transformObjectFromDelete = function(d) {
      return d.account;
    };

    child.transformObjectBeforeSave = function(d) {
      return d;
    };

    child.transformObjectFromGet = function(d) {
      return d.account;
    };

    return child;

  }

})();

// Thanks to http://stackoverflow.com/a/14425022/924006
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('slugify', Slugify);

  /** @ngInject */
  function Slugify() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {

          var transformedInput = inputValue.toLowerCase().replace(/[^a-z0-9_-]/g, '');

          if (transformedInput!=inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('validUsername', ValidUsername);

  /** @ngInject */
  function ValidUsername() {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {

          var transformedInput = inputValue.toLowerCase().replace(/[^a-z0-9@._-]/g, '');

          if (transformedInput!=inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    }
  }
})();

// Keep this around for now, but as-is it doesn't work. It renders the org
// chart before the angular bindings have been evaluated, so you get lots of
// {{}} junk in the org chart instead of real data.
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('title', PageTitleDirective);

  /** @ngInject */
  function PageTitleDirective($rootScope, $timeout) {
    //SWITCH-FOR-ZURIXX
    //var defaultTitle = 'Launch Academy';
    var defaultTitle = 'OPG';
    return {
      restrict: 'E',
      link: function () {
        var listener = function(event, toState) {
          $timeout(function() {
            if (toState.data && toState.data.pageTitle) {
              if (typeof toState.data.pageTitle == 'function') {
                $rootScope.title = toState.data.pageTitle();
              } else {
                $rootScope.title = toState.data.pageTitle;
              }
            } else {
              $rootScope.title = defaultTitle;
            }
          });

        };
        $rootScope.$on('$stateChangeSuccess', listener);
      }
    }
  }
})();

// Keep this around for now, but as-is it doesn't work. It renders the org
// chart before the angular bindings have been evaluated, so you get lots of
// {{}} junk in the org chart instead of real data.
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('orgchart', OrgChartDirective);

  /** @ngInject */
  function OrgChartDirective() {
    return {
      restrict: 'AE',
      link: function (scope, element, attrs) {
        var target = $(element);
        var source = $('#' + attrs.chartSource);
        var options = {
          container: target,
          nodeClicked: attrs.clicked,
          stack: attrs.stack,
          depth: attrs.depth,
          interactive: attrs.interactive,
          showLevels: attrs.showLevels
        };
        source.orgChart(options);
      }
    }
  }
})();

// modified from http://stackoverflow.com/a/17472118/254603
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('onEscape', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 27) {
            scope.$apply(function () {
              scope.$eval(attrs.onEscape);
            });
            event.preventDefault();
          }
        });
      };
    });
})();

// http://stackoverflow.com/a/17472118/254603
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('onEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.onEnter);
            });
            event.preventDefault();
          }
        });
      };
    });
})();

// http://stackoverflow.com/questions/14995884/select-text-on-input-focus
(function() {
  'use strict';
  angular
    .module('webapp')
    .directive('autoSelect', AutoSelectDirective);

  /** @ngInject */
  function AutoSelectDirective($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('click', function () {
          if (!$window.getSelection().toString()) {
            // Required for mobile Safari
            this.setSelectionRange(0, this.value.length)
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

    .state('base', {
        abstract: true,
        templateUrl: 'app/components/base/base.html',
        controller: 'BaseController',
        controllerAs: 'thebase',
        data: {
          //superbase: false
        }
      })

      .state('contact', {
        parent: 'base',
        url: '/contact',

        views: {
          title: {
            template: "Contact OPG"
          },
          tagline: {
            template: "Our Support Team is ready to help you, from account questions to software support."
          },
          content: {
            templateUrl: 'app/components/contact/contact.html',
            controller: 'ContactController',
            controllerAs: 'contact'
          }
        }
      })

      // .state('about', {
      //  parent: 'base',
      //  url: '/about',
      //
      //  views: {
      //    title: {
      //      template: "About OPG"
      //    },
      //    tagline: {
      //      template: ""
      //    },
      //    content: {
      //      templateUrl: 'app/components/about/about.html',
      //      controller: 'AboutController',
      //      controllerAs: 'about'
      //    }
      //  }
      //})

      .state('accessdenied', {
        parent: 'base',
        url: '/accessdenied',

        views: {
          title: {
            template: "Access Denied"
          },
          tagline: {
            template: "Sorry, you don't have the credentials for that operation"
          },
          content: {
            templateUrl: 'app/components/auth/accessdenied.html',
            controller: 'AccessDeniedController',
            controllerAs: 'accessdenied'
          }
        }
      })

      .state('login', {
        parent: 'base',
        url: '/login?org',

        views: {
          title: {
            template: ""
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/auth/login/login.html',
            controller: 'LoginController',
            controllerAs: 'login'
          }
        }
      })

      .state('forgot-password', {
        parent: 'base',
        url: '/forgot-password?org',

        views: {
          title: {
            template: "Recover Password"
          },
          tagline: {
            template: "Recover your password through your email"
          },
          content: {
            templateUrl: 'app/components/auth/forgot-password/forgot.html',
            controller: 'ForgotPasswordController',
            controllerAs: 'forgot'
          }
        }
      })

      .state('login-with-token', {
        parent: 'base',
        url: '/login-with-token?org&token',

        views: {
          title: {
            template: "Restore Password"
          },
          tagline: {
            template: "Validate your temporary login credentials"
          },
          content: {
            templateUrl: 'app/components/auth/login-with-token/token-login.html',
            controller: 'LoginWithTokenController',
            controllerAs: 'token'
          }
        }
      })

      .state('auth-base', {
        abstract: true,
        templateUrl: 'app/components/base/base.html',
        controller: 'BaseController',
        controllerAs: 'base',
        resolve: {authenticate: authorize}
        //resolve: {
        //  authorize: /** @ngInject */ function(Authorization) {
        //    console.log("I am checking for authorization");
        //    return Authorization.authorize();
        //  }
        //}
      })

      .state('personal-dash', {
        parent: 'auth-base',
        url: '/dashboard/personal',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Personal Dashboard'
        },
        views: {
          title: {
            template: "Personal Dashboard"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/personal-dash/personal-dash.html',
            controller: 'PersonalDash',
            controllerAs: 'personalDash'
          }
        }
      })

      .state('company-dash', {
        parent: 'auth-base',
        url: '/dashboard/company',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Company Dashboard'
        },
        views: {
          title: {
            template: "Company Dashboard"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/company-dash/company-dash.html',
            controller: 'CompanyDash',
            controllerAs: 'companyDash'
          }
        }
      })

      .state('swot', {
        parent: 'auth-base',
        url: '/swot',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Situation Analysis'
        },
        views: {
          title: {
            template: "Situation Analysis"
          },
          tagline: {
            //template: "View your company's SWOTs"
            template: ""
          },
          content: {
            templateUrl: 'app/components/swot/swot.html',
            controller: 'SwotController',
            controllerAs: 'swotCtrl'
          }
        }
      })

      .state('core-competency', {
        parent: 'auth-base',
        url: '/core-competency',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Core Competencies'
        },
        views: {
          title: {
            template: "Core Competencies"
          },
          tagline: {
            template: "A unique capability a company develops that cannot be easily imitated or matched by competitors."
          },
          content: {
            templateUrl: 'app/components/core-competencies/cc.html',
            controller: 'CoreCompetenciesController',
            controllerAs: 'cc'
          }
        }
      })

      .state('key-success-factors', {
        parent: 'auth-base',
        url: '/key-success-factors',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Industry Key Success Factors'
        },
        views: {
          title: {
            template: "Industry Key Success Factors"
          },
          tagline: {
            template: "Industry-specific attributes (usually 3-5 key) that, when performed competently, ensure successful company performance."
          },
          content: {
            templateUrl: 'app/components/key-success-factors/ksf.html',
            controller: 'KeySuccessFactorsController',
            controllerAs: 'ksf'
          }
        }
      })

      .state('mission-statement', {
        parent: 'auth-base',
        url: '/mission-statement',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Mission Statement'
        },
        views: {
          title: {
            template: "Mission Statement"
          },
          tagline: {
            template: "A Mission Statement answers the following questions – Who we are, What we do and How we do it."
          },
          content: {
            templateUrl: 'app/components/mission-statement/ms.html',
            controller: 'MissionStatementController',
            controllerAs: 'ms'
          }
        }
      })

      .state('external-environment-review', {
        parent: 'auth-base',
        url: '/external-environment-review',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'External Environment Review'
        },
        views: {
          title: {
            template: "External Environment Review"
          },
          tagline: {
            template: "The External Environment Review focuses on external risks relating to the industry and market conditions"
          },
          content: {
            templateUrl: 'app/components/external-environment-review/eer.html',
            controller: 'ExternalEnvironmentReviewController',
            controllerAs: 'eer'
          }
        }
      })

      .state('executive-summary', {
        parent: 'auth-base',
        url: '/executive-summary',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Executive Summary'
        },
        views: {
          title: {
            template: "Executive Summary"
          },
          tagline: {
            template: "A brief synopsis of the Business Plan that highlights it's key points."
          },
          content: {
            templateUrl: 'app/components/executive-summary/es.html',
            controller: 'ExecutiveSummaryController',
            controllerAs: 'es'
          }
        }
      })

      .state('business-plan-overview', {
        resolve: {authenticate: authorize},
        url: '/business-plan-overview',
        templateUrl: 'app/components/business-plan-overview/plan.html',
        controller: 'BusinessPlanOverviewController',
        controllerAs: 'overview',

        data: {
          pageTitle: 'Company Confidential - Business Plan'
        }
      })

      .state('orgchart', {
        parent: 'auth-base',
        url: '/orgchart',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Organization Chart'
        },
        views: {
          title: {
            template: "Organization Chart"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/orgchart/orgchart.html',
            controller: 'OrgChartController',
            controllerAs: 'orgChartCtrl'
          }
        }
      })

      .state('objectives', {
        parent: 'auth-base',
        url: '/objectives/:objectiveId',
        params: {
          newWithSwot: null  // If this is passed we'll create a new objective with the given swot prepopulated
        },
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Objective Tracker'
        },
        views: {
          title: {
            template: "Objective Tracker"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/objectives/objectives.html',
            controller: 'ObjectivesController',
            controllerAs: 'objCtrl'
          }
        }
      })

      .state('objective', {
        parent: 'auth-base',
        url: '/objective/:objective_id',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Objective'
        },
        views: {
          title: {
            template: "Objective"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/objectives/objective.report.html',
            controller: 'ObjectiveReportController',
            controllerAs: 'o'
          }
        }
      })

      .state('objectives-5yr', {
        parent: 'auth-base',
        url: '/objectives-5yr',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Five Year Objectives'
        },
        views: {
          title: {
            template: "Five Year Objectives"
          },
          tagline: {
            template: ""
          },
          content: {
            templateUrl: 'app/components/objectives/objectives-5yr.html',
            controller: 'ObjectivesController',
            controllerAs: 'objCtrl'
          }
        }
      })

      .state('meetings', {
        parent: 'auth-base',
        url: '/meetings',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Meetings'
        },
        views: {
          title: {
            template: "Meetings"
          },
          tagline: {
            template: "Meetings"
          },
          content: {
            templateUrl: 'app/components/meetings/meetings.html',
            controller: 'MeetingsController',
            controllerAs: 'meetingsCtrl'
          }
        }
      })

      .state('user-settings', {
        parent: 'auth-base',
        url: '/user-settings',

        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'User Settings'
        },
        views: {
          title: {
            template: "User Settings"
          },
          tagline: {
            template: "Change your own account settings"
          },
          content: {
            templateUrl: 'app/components/user-settings/user-settings.html',
            controller: 'UserSettingsController',
            controllerAs: 'u_settings'
          }
        }
      })

      .state('admin-settings', {
        parent: 'auth-base',
        abstract: true,

        data: {
          pageTitle: 'Admin Settings'
        },

        views: {
          title: {
            template: "Admin Settings"
          },
          tagline: {
            //template: "View your organization settings"
            template: ""
          },
          content: {
            templateUrl: 'app/components/admin-settings/orgBase.html',
            controller: 'BaseOrganizationController',
            controllerAs: 'base_settings'
          }
        }
      })

      .state('admin-settings.company', {
        url: '/admin-settings/company',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Edit Company'
        },
        views: {
          settings_title: {
            template: "Edit Company"
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/company/orgEdit.html',
            controller: 'OrganizationEditorController',
            controllerAs: 'e_settings'
          }
        }
      })

      .state('admin-settings.instance-settings', {
        url: '/admin-settings/instance-settings',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Instance Settings'
        },
        views: {
          settings_title: {
            template: "Instance Settings"
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/instance-settings/instanceSettings.html',
            controller: 'InstanceSettingsController',
            controllerAs: 'settings'
          }
        }
      })

      .state('admin-settings.accounts', {
        url: '/admin-settings/accounts',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Manage Users'
        },
        views: {
          settings_title: {
            template: "Manage Users"
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/accounts/orgAccounts.html',
            controller: 'OrganizationAccountsController',
            controllerAs: 'a_settings'
          }
        }
      })

      .state('admin-settings.divisions', {
        url: '/admin-settings/divisions',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Manage Divisions'
        },
        views: {
          settings_title: {
            template: "Manage Divisions"
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/divisions/orgDivisions.html',
            controller: 'OrganizationDivisionsController',
            controllerAs: 'd_settings'
          }
        }
      })

      .state('admin-settings.uploads', {
        url: '/admin-settings/uploads',
        data: {
          homeArea: false,
          role: 'support',
          pageTitle: 'Manage Uploads'
        },
        views: {
          settings_title: {
            template: "Manage Uploads"
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/uploads/orgUploads.html',
            controller: 'OrganizationUploadsController',
            controllerAs: 'ul_settings'
          }
        }
      })

      .state('admin-settings.tenants', {
        url: '/admin-settings/tenants',
        data: {
          homeArea: false,
          role: 'support'
        },
        views: {
          settings_title: {
            template: "Manage Organizations",
            pageTitle: 'Manage Organizations'
          },
          settings_content: {
            templateUrl: 'app/components/admin-settings/tenants/tenants.html',
            controller: 'EditTenantsController',
            controllerAs: 'tenants'
          }
        }
      })

    ;

    $urlRouterProvider.otherwise('/dashboard/personal');
  }

  /** @ngInject */
  function authorize(Authorization) {
    console.log("I am checking for authorization");
    return Authorization.authorize();
  }

})();

(function() {
  'use strict';

  angular
    .module('webapp')
    .filter('limitToEllipses', LimitToEllipses)
    .filter('propsFilter', PropsFilter)
    .filter('secondsToDate', SecondsToDate)
    .filter('filterDivision', FilterDivision)
    .filter('filterAccount', FilterAccount)
    .filter('filterStatus', FilterStatus)
    .filter('filterScope', FilterScope)
    .filter('filterSwotType', FilterSwotType)
    .filter('filterKsf', FilterKsf)
    .filter('filterCc', FilterCc)
    .filter('isoToDate', IsoToDate)
    .filter('ifEmpty', IfEmpty);

  /** @ngInject */
  function LimitToEllipses($filter) {
    return function(input, limit, defaultString) {
      var o = $filter('limitTo')(input, limit, 0);
      if (o) {
        o = o.trim();
      }
      if ((! o || o.length < 1) && defaultString ) {
        o = defaultString;
      }
      return o + (o ? (o.length < input.length ? "..." : "") : "");
    };
  }

  /**
   * From http://plnkr.co/edit/juqoNOt1z1Gb349XabQ2?p=preview
   *
   * AngularJS default filter with the following expression:
   * "person in people | filter: {name: $select.search, age: $select.search}"
   * performs a AND between 'name: $select.search' and 'age: $select.search'.
   * We want to perform a OR.
   */
  function PropsFilter() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        items.forEach(function (item) {
          var itemMatches = false;

          var keys = Object.keys(props);
          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            if (typeof(props[prop]) != 'string' && ! (props[prop] instanceof String)) {
              break;
            }
            var text = props[prop].toLowerCase();
            // Safeguard against null/undefined
            if (item[prop] === null || item[prop] === undefined) {
              break;
            }
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    }
  }

  function SecondsToDate() {
    return function(seconds) {
      if (seconds == 0) {
        return undefined;  // This allows us to use a default value for the 'date' filter
      }
      var d = new Date(0);
      d.setUTCSeconds(seconds);
      return d;
    }
  }

  function FilterDivision() {
    return function(items, division_id) {
      if (!items) return [];
      return items.filter(function(item) {
        return division_id == 'all' || division_id == item.division_id;
      });
    }
  }

  function FilterAccount() {
    return function(items, account_id) {
      if (!items) return [];
      return items.filter(function(item) {
        return account_id == 'all' || account_id == item.account_id;
      });
    }
  }

  function FilterScope() {
    return function(items, scope) {
      if (!items) return [];
      return items.filter(function(item) {
        return scope == 'all' || scope == item.scope;
      });
    }
  }

  function FilterStatus() {
    return function(items, status) {
      if (!items) return [];
      return items.filter(function(item) {
        return status == 'all' || status == item.status;
      });
    }
  }

  function FilterKsf() {
    return function(items, ksfId) {
      if (!items) return [];
      return items.filter(function(item) {
        return ksfId == 'all' || item.key_success_factors.indexOf(parseInt(ksfId)) != -1;
      });
    }
  }

  function FilterCc() {
    return function(items, ccId) {
      if (!items) return [];
      return items.filter(function(item) {
        return ccId == 'all' || item.core_competencies.indexOf(parseInt(ccId)) != -1;
      });
    }
  }

  function FilterSwotType() {
    return function(items, swot_type) {
      if (!items) return [];
      return items.filter(function(item) {
        return swot_type == 'all' || item.type == swot_type;
      });
    }
  }

  function IsoToDate() {
    return function(isoDateStr, convertTz) {
      convertTz = convertTz === undefined ? false : convertTz;
      var d = isoDateStr ? new Date(isoDateStr) : null;
      if (d && convertTz) {
        d = new Date(d.getTime() + d.getTimezoneOffset()*60000);
      }
      return d;
    }
  }

  //http://stackoverflow.com/a/30471421/254603
  function IfEmpty() {
    return function (input, defaultValue) {
      if (angular.isUndefined(input) || input === null || input === '') {
        return defaultValue;
      }
      return input;
    }
  }

})();

/* global moment:false */
(function () {
  'use strict';

  angular
    .module('webapp')
    .constant('TinymceOptions', {
      //resize: false,
      //width: 400,  // I *think* its a number and not '400' string
      //height: 300,
      //theme: 'advanced',
      //plugins: 'print paste textcolor advlist autolink link image lists charmap print preview code',
      plugins: [
        //'fullscreen media',
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code',
        'insertdatetime nonbreaking save table contextmenu directionality',
        'emoticons template paste textcolor colorpicker textpattern imagetools'
      ],
      //toolbar: "undo redo styleselect bold italic print forecolor backcolor ",
      //toolbar: "print,bold,italic,underline, strikethrough, separator,justifyleft, justifycenter,justifyright,  justifyfull, separator, indent, outdent, separator, bullist, numlist, separator, fontsizeselect, fontselect",
      toolbar1: 'print preview media | forecolor backcolor | insertfile undo redo | styleselect | bold italic fontsizeselect fontselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image' ,
      toolbar2: '',
      onChange: function (e) {
        // put logic here for keypress and cut/paste changes
      },
      inline: false,
      //xplugins : '',
      skin: 'lightgray',
      theme: 'modern'
    });


})();

(function() {
  'use strict';
  var app = angular.module('webapp');

  app.config(config);
  app.run(editableConf);
  //app.factory('AuthInterceptor', authInterceptor);
  //app.config(provider);

  /** @ngInject */
  function editableConf(editableOptions) {
    editableOptions.theme = 'bs3';
  }

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    toastrConfig.closeButton = true;
    toastrConfig.newestOnTop = true

  }

  ///** @ngInject */
  //function authInterceptor($q, $rootScope) {
  //  return {
  //    responseError: function (response) {
  //      if (response.status === 401) {
  //        console.log("unauthorized pal");
  //        $rootScope.$broadcast('401:unauthorized');
  //      } else if (response.status === 405) {
  //        console.log("method not allowed");
  //      } else if (response.status === 501) {
  //        console.log("not implemented");
  //      } else if (response.status === 500) {
  //        console.log("server error occurred");
  //      } else if (response.status === 200) {
  //        console.log("another successful request!");
  //      }
  //      return $q.reject(response);
  //    }
  //  }
  //}
  //
  ///** @ngInject */
  //function provider($httpProvider) {
  //  $httpProvider.interceptors.push('AuthInterceptor');
  //}

})();

// credit: http://stackoverflow.com/a/5306832/254603
Array.prototype.move = function (old_index, new_index) {
  if (new_index >= this.length) {
    var k = new_index - this.length;
    while ((k--) + 1) {
      this.push(undefined);
    }
  }
  this.splice(new_index, 0, this.splice(old_index, 1)[0]);
  return this; // for testing purposes
};


angular.module("webapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/admin-settings/orgBase.html","<div class=\"container-fluid\"><div id=\"org-base-nav\" class=\"row\"><div class=\"col-sm-2\"><ul class=\"nav nav-pills nav-stacked\"><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.company\')}\"><a href=\"\" ui-sref=\"admin-settings.company\">Company</a></li><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.accounts\')}\"><a href=\"\" ui-sref=\"admin-settings.accounts\">Users</a></li><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.divisions\')}\"><a href=\"\" ui-sref=\"admin-settings.divisions\">Divisions</a></li><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.uploads\')}\"><a href=\"\" ui-sref=\"admin-settings.uploads\">Uploads</a></li><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.instance-settings\')}\" ng-if=\"base_settings.principal.can_switch\"><a href=\"\" ui-sref=\"admin-settings.instance-settings\">Instance Settings</a></li><li role=\"presentation\" ng-class=\"{active: base_settings.isActive(\'admin-settings.tenants\')}\" ng-if=\"base_settings.principal.can_switch\"><a href=\"\" ui-sref=\"admin-settings.tenants\">Organizations</a></li></ul></div><div class=\"col-sm-10\"><legend ui-view=\"settings_title\"></legend><div ui-view=\"settings_content\"></div></div></div></div>");
$templateCache.put("app/components/auth/accessdenied.html","access denied here");
$templateCache.put("app/components/base/base.html","<div id=\"base\"><div class=\"container-fluid meta-content\" ng-style=\"{\'min-height\': contentMinHeight}\"><div class=\"navbar-fixed-top\"><div><opg-navbar creation-date=\"creationDate\"></opg-navbar></div><div class=\"container-fluid base\"><div class=\"page-header\" print-section=\"\"><h1 class=\"title\" ui-view=\"title\"></h1><hr class=\"separator\"><div class=\"tagline\" ui-view=\"tagline\"></div></div></div></div><div class=\"container-fluid thecontent\"><div><div ui-view=\"content\"></div></div></div></div><div class=\"printed-footer row\" print-only=\"\" print-section=\"\"><div class=\"text-center\">&copy; Copyright 2014-2016 Optimal Performance Group, LLC -- Printed by {{principal.name}} for {{principal.current_org}} {{thetime}}</div></div><div class=\"footer text-center\"><div class=\"row\"><div class=\"copyright\">&copy; Copyright 2014-2016 Optimal Performance Group, LLC</div></div><div class=\"row\"><div class=\"reserved\">Version 3.0 All Rights Reserved</div></div></div></div>");
$templateCache.put("app/components/business-plan-overview/plan.html","<div id=\"business-plan-overview-container\" class=\"container-fluid\"><a href=\"\" print-btn=\"\" class=\"btn btn-success\"><i class=\"glyphicon glyphicon-print\"></i> Print Report</a> <a href=\"/\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-home\"></i> Go Home</a><div print-section=\"\"><div class=\"break-after\"><div class=\"text-center\"><h1 class=\"title\">Business Plan Overview</h1><img class=\"nav-logo company-logo-img\" src=\"/api/organization/image\" onerror=\"this.onerror=null;this.src=\'/assets/images/default-company-logo.jpg\';\"><h2>{{overview.organization.name}}</h2><p>{{overview.organization.description}}</p></div><div class=\"footer\">Company Confidential -- Printed by {{overview.principal.name}} {{overview.thetime | date:\'MM/dd/yyyy\'}}</div></div><div class=\"break-after\"><h1 class=\"title\">Table Of Contents</h1><div class=\"toc\"><ol><li>Executive Summary</li><li>Mission Statement</li><li>Industry Key Success Factors</li><li>Company Core Competencies</li><li>External Environment Review</li><li>Organization</li><li>Situation Analysis</li><ol class=\"child-1\"><li>Strengths</li><li>Weakness</li><li>Opportunity</li><li>Threats</li></ol><li>Objectives</li></ol></div></div><div class=\"break-after\"><h1 class=\"full-page\">Executive Summary</h1></div><div class=\"break-after\"><h1>Executive Summary</h1><p ng-bind-html=\"overview.executive_summary\"></p></div><div class=\"break-after\"><h1 class=\"full-page\">Mission Statement</h1></div><div class=\"break-after\"><h1>Mission Statement</h1><p ng-bind-html=\"overview.mission_statement\"></p></div><div class=\"break-after\"><h1 class=\"full-page\">Industry Key Success Factors</h1></div><div class=\"break-after\"><h1>Industry Key Success Factors ({{overview.ksf.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Description</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.ksf.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1 class=\"full-page\">Company Core Competencies</h1></div><div class=\"break-after\"><h1>Company Core Competencies ({{overview.ccFactory.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Description</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.ccFactory.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1 class=\"full-page\">External Environment Review</h1></div><div class=\"break-after\"><h1>External Environment Review</h1><p ng-bind-html=\"overview.external_review\"></p></div><div class=\"break-after\"><h1 class=\"full-page\">Organization</h1></div><div class=\"break-after\"><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-25\">Name</div><div class=\"rTableHead rcol-25\">Title</div><div class=\"rTableHead rcol-25\">Manager</div><div class=\"rTableHead rcol-25\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"account in overview.accounts\" ng-if=\"account.id != 1\"><div class=\"rTableCell rcol-25\">{{account.name | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-25\">{{account.title | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-25\">{{ account.reports_to_account_name | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-25\">{{ overview.showDivision(account.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1 class=\"full-page\">Situation Analysis</h1></div><div class=\"break-after\"><h1>Strengths ({{overview.swotStrength.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Element</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.swotStrength.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1>Weakness ({{overview.swotWeakness.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Element</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.swotWeakness.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1>Opportunity ({{overview.swotOpportunity.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Element</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.swotOpportunity.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1>Threats ({{overview.swotThreat.collection.length}})</h1><div class=\"rTable\"><div class=\"rTableRow\"><div class=\"rTableHead rcol-10\">Priority</div><div class=\"rTableHead rcol-60\">Element</div><div class=\"rTableHead rcol-30\">Division</div></div><div class=\"rTableRow\" ng-repeat=\"element in overview.swotThreat.collection\"><div class=\"rTableCell rcol-10\">{{element.priority | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-60\">{{element.description | ifEmpty:\'Not set\' }}</div><div class=\"rTableCell rcol-30\">{{ overview.showDivision(element.division_id) | ifEmpty:\'Not set\' }}</div></div></div></div><div class=\"break-after\"><h1 class=\"full-page\">Objectives</h1></div><div class=\"break-after\" ng-repeat=\"obj in overview.objectives\" ng-init=\"account = overview.accountFactory.getById(obj.account_id)\"><h3>{{ obj.division_name | ifEmpty:\'Not set\' }} - Priority #{{obj.priority}}</h3><h4>{{obj.description}}</h4><br><div class=\"row\"><div class=\"col-xs-6\"><table id=\"vertical-2\"><caption>Responsible</caption><tr><th>Name: &nbsp;</th><td>{{account.name}}</td></tr><tr><th>Phone: &nbsp;</th><td>{{account.phone}}</td></tr><tr><th>Email: &nbsp;</th><td>{{account.email}}</td></tr></table></div><div class=\"col-xs-6\"><table id=\"vertical-1\"><caption>Important Dates</caption><tr><th>Created: &nbsp;</th><td>{{(obj.created_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr><tr><th>Due: &nbsp;</th><td>{{(obj.due_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr><tr><th>Completed: &nbsp;</th><td>{{(obj.complete_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr></table></div></div><div class=\"obj-section\"><div ng-if=\"obj.swots.length < 1\"><h4 class=\"caption\">No Related SWOTs</h4></div><div class=\"rTable\" ng-if=\"obj.swots.length > 0\"><h4 class=\"caption\">Related SWOTs</h4><div class=\"rTableRow\"><div class=\"rTableHead rcol-5\">Priority</div><div class=\"rTableHead rcol-15\">Type</div><div class=\"rTableHead rcol-60\">Description</div><div class=\"rTableHead rcol-20\">Status</div></div><div class=\"rTableRow\" ng-repeat=\"swot in overview.getSwots(obj.swots)\"><div class=\"rTableCell rcol-5\">{{swot.priority}}</div><div class=\"rTableCell rcol-15\">{{swot.type}}</div><div class=\"rTableCell rcol-60\">{{swot.description}}</div><div class=\"rTableCell rcol-20\">{{swot.status}}</div></div></div></div><div class=\"obj-section\"><div ng-if=\"obj.core_competencies.length < 1\"><h4 class=\"caption\">No Related Core Competencies</h4></div><div class=\"rTable\" ng-if=\"obj.core_competencies.length > 0\"><h4 class=\"caption\">Related Core Competencies</h4><div class=\"rTableRow\"><div class=\"rTableHead rcol-70\">Description</div><div class=\"rTableHead rcol-10\">Division</div><div class=\"rTableHead rcol-10\">Scope</div><div class=\"rTableHead rcol-10\">Status</div></div><div class=\"rTableRow\" ng-repeat=\"cc in overview.getCoreCompetencies(obj.core_competencies)\"><div class=\"rTableCell rcol-70\">{{cc.description}}</div><div class=\"rTableCell rcol-10\">{{overview.showDivision(cc.division_id)}}</div><div class=\"rTableCell rcol-10\">{{cc.scope || \'Not set\'}}</div><div class=\"rTableCell rcol-10\">{{cc.status || \'Not set\'}}</div></div></div></div><div class=\"obj-section\"><div ng-if=\"obj.tactics.length < 1\"><h4 class=\"caption\">No Tactics</h4></div><div class=\"rTable\" ng-if=\"obj.tactics.length > 0\"><h4 class=\"caption\">Tactics</h4><div class=\"rTableRow\"><div class=\"rTableHead rcol-50\">Description</div><div class=\"rTableHead rcol-20\">Responsible</div><div class=\"rTableHead rcol-10\">Due</div><div class=\"rTableHead rcol-10\">Update</div><div class=\"rTableHead rcol-10\">Completed</div></div><div class=\"rTableRow\" ng-repeat=\"tactic in overview.getTactics(obj.tactics)\"><div class=\"rTableCell rcol-50\">{{tactic.description}}</div><div class=\"rTableCell rcol-20\">{{obj.accountFactory.getById(tactic.id).name}}</div><div class=\"rTableCell rcol-10\">{{(tactic.due_date | date:\'MM/dd/yyyy\') || \'Not set\'}}</div><div class=\"rTableCell rcol-10\">{{(tactic.update_due_date | date:\'MM/dd/yyyy\') || \'Not set\'}}</div><div class=\"rTableCell rcol-10\">{{(tactic.complete_date | date:\'MM/dd/yyyy\') || \'Not set\'}}</div></div></div></div><div class=\"obj-section\"><div ng-if=\"obj.committee_members.length < 1\"><h4 class=\"caption\">No Committee Members</h4></div><div class=\"rTable\" ng-if=\"obj.committee_members.length > 0\"><h4 class=\"caption\">Committee Members</h4><div class=\"rTableRow\"><div class=\"rTableHead rcol-25\">Name</div><div class=\"rTableHead rcol-25\">Title</div><div class=\"rTableHead rcol-25\">Phone</div><div class=\"rTableHead rcol-25\">Email</div></div><div class=\"rTableRow\" ng-repeat=\"member in overview.getAccounts(obj.committee_members)\"><div class=\"rTableCell rcol-25\">{{member.name}}</div><div class=\"rTableCell rcol-25\">{{member.title}}</div><div class=\"rTableCell rcol-25\">{{member.phone}}</div><div class=\"rTableCell rcol-25\">{{member.email}}</div></div></div></div></div></div></div><div class=\"pad\">&nbsp;</div>");
$templateCache.put("app/components/company-dash/company-dash.html","<div ng-if=\"!companyDash.loaded()\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div id=\"company-dash-container\" ng-if=\"companyDash.loaded()\"><table class=\"table table-striped\" role=\"table\"><thead><tr><th>Division</th><th># Objectives</th><th>Completed</th><th>% Completed</th><th>Postponed</th><th>To Be Complete</th></tr></thead><tbody><tr ng-repeat=\"(divisionName, counts) in companyDash.divisionCounts\"><td>{{divisionName}}</td><td>{{counts.total_count}}</td><td>{{counts.completed}}</td><td>{{counts.p_complete}}%</td><td>{{counts.postponed}}</td><td>{{counts.to_be_completed}}</td></tr><tr class=\"totals-row\"><td>Totals</td><td>{{companyDash.totals.total_count}}</td><td>{{companyDash.totals.completed}}</td><td>{{companyDash.totals.p_complete}}%</td><td>{{companyDash.totals.postponed}}</td><td>{{companyDash.totals.to_be_completed}}</td></tr></tbody></table></div>");
$templateCache.put("app/components/confirm-modal/confirm-modal-select.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{title}}</h3></div><div class=\"modal-body\" style=\"height: 150px\">{{msg}}<h5>{{select_message}}</h5><div class=\"col-md-6\"><select class=\"form-control\" ng-model=\"selected_item\" ng-options=\"d[display_attribute] for d in items track by d.id\"></select></div></div><div class=\"modal-footer\"><button ng-disabled=\"notReadyToClick()\" class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Ok</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div>");
$templateCache.put("app/components/confirm-modal/confirm-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{title}}</h3></div><div class=\"modal-body\">{{msg}}</div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">Ok</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">Cancel</button></div>");
$templateCache.put("app/components/contact/contact.html","<div id=\"contact\" class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-4\"></div><div class=\"col-sm-4\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"row\"><h4>Phone</h4><p>(801)-984-3160</p></div><div class=\"row\"><h4>Email</h4><p>Info@theopg.com</p></div></div><div class=\"col-sm-6\"><h4>Address</h4><p>2940 W Maple Loop Drive, Ste 301<br>Lehi, UT 84043, USA</p></div></div></div><div class=\"col-sm-4\"></div></div></div>");
$templateCache.put("app/components/core-competencies/cc.html","<div class=\"filtration\" print-remove=\"\"><div class=\"row\"><div class=\"col-sm-1 col-filter\"><a ng-disabled=\"!cc.canAdd()\" href=\"\" class=\"btn btn-primary\" ng-click=\"cc.add()\"><i class=\"glyphicon glyphicon-plus\"></i></a></div><div class=\"col-sm-1 col-filter\"><a ng-disabled=\"!cc.canAdd()\" href=\"\" class=\"btn btn-primary\" ng-click=\"cc.refresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-default\" print-btn=\"\"><i class=\"glyphicon glyphicon-print\"></i></a></div><div class=\"col-sm-2 col-filter\"><select name=\"selectDivision\" ng-model=\"cc.currentDivision.division_id\" class=\"form-control\"><option value=\"all\">All Divisions</option><option ng-repeat=\"option in cc.divisions\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"col-sm-2 col-filter\"><select name=\"selectScope\" ng-model=\"cc.selectedScope\" class=\"form-control\"><option value=\"all\">All Scopes</option><option ng-repeat=\"option in cc.scopes\" value=\"{{option.value}}\">{{option.value}}</option></select></div><div class=\"col-sm-2 col-filter\"><select name=\"selectKsf\" ng-model=\"cc.selectedKsf\" class=\"form-control\"><option value=\"all\">All IKSFs</option><option ng-repeat=\"option in cc.ksfs\" value=\"{{option.id}}\">{{option.priority}}: {{option.description | limitToEllipses:30}}</option></select></div><div class=\"col-sm-3 col-filter\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div><div id=\"cc-container\" class=\"container-fluid\"><div class=\"row\"><table id=\"cc-table\" class=\"table scrolling-table\" print-section=\"\"><thead><tr fsm-sticky-header=\"\" scroll-body=\"\'#cc-table\'\" scroll-stop=\"cc.getScrollStop(\'cc-table\')\"><th>Priority</th><th>Description</th><th>Division</th><th>IKSF</th><th>Scope</th><th print-remove=\"\">&nbsp;</th></tr></thead><tbody id=\"apps-container\" ui-sortable=\"cc.sortableOptions\" ng-model=\"cc.collection\"><tr ng-repeat=\"element in cc.collection\" id=\"{{element.id}}\" ng-class=\"\'r\' + $index\"><td class=\"priority myHandle text-center\" ng-mouseenter=\"hover=true\" ng-mouseleave=\"hover=false\" ng-class=\"{ready_to_drag: hover}\"><span ng-switch=\"\" on=\"element.priority\"><i class=\"glyphicon glyphicon-move\" ng-switch-when=\"0\">&nbsp;</i> <span ng-switch-default=\"\">{{element.priority}}</span></span></td><td><div class=\"popover-wrapper\"><div class=\"description truncate-line\"><a href=\"#\" editable-textarea=\"element.description\" onbeforesave=\"cc.update(element, \'description\', $data)\"><div uib-tooltip=\"{{element.description}}\" tooltip-class=\"details-tooltip\" tooltip-placement=\"top-left\" tooltip-popup-delay=\"700\">{{ element.description | ifEmpty:\'none\' }}</div></a></div></div></td><td class=\"division\"><div class=\"popover-wrapper pull-left\"><a href=\"#\" editable-select=\"element.division_id\" onbeforesave=\"cc.update(element, \'division_id\', $data)\" e-ng-options=\"d.id as d.name for d in cc.divisions\">{{ cc.showDivision(element.division_id) | ifEmpty:\'none\' }}</a></div></td><td class=\"ksf\"><div class=\"popover-wrapper popover-multiple pull-left\"><a href=\"#\" editable-select=\"element.key_success_factors\" onbeforesave=\"cc.update(element, \'key_success_factors\', $data)\" e-multiple=\"\" e-ng-options=\"s.id as s.priority+\': \'+s.description for s in cc.ksfs\">{{ cc.showKSF(element) | ifEmpty:\'none\'}}</a></div></td><td class=\"scope\"><div class=\"popover-wrapper pull-left\"><a href=\"#\" editable-select=\"element.scope\" onbeforesave=\"cc.update(element, \'scope\', $data)\" e-ng-options=\"s.value as s.name for s in cc.scopes\">{{ element.scope }}</a></div></td><td class=\"extra\" print-remove=\"\"><button type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Delete Objective\" ng-click=\"cc.confirm_remove(element)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/executive-summary/es.html","<div id=\"es-container\" class=\"container-fluid\"><div class=\"row\"><div class=\"button-group\"><a href=\"\" ng-disabled=\"!es.canSave()\" ng-click=\"es.save()\" class=\"btn btn-success btn-md\">Save</a> <a href=\"\" ng-disabled=\"!es.canCancel()\" ng-click=\"es.cancel()\" class=\"btn btn-warning btn-md\">Cancel</a></div></div><div class=\"row\"><form method=\"post\"><textarea ui-tinymce=\"es.tinymceOptions\" ng-model=\"es.document\" ng-style=\"{height: es.editorHeight }\"></textarea></form></div></div>");
$templateCache.put("app/components/external-environment-review/eer.html","<div id=\"eer-container\" class=\"container-fluid\"><div class=\"row\"><div class=\"button-group\"><a href=\"\" ng-disabled=\"!eer.canSave()\" ng-click=\"eer.save()\" class=\"btn btn-success btn-md\">Save</a> <a href=\"\" ng-disabled=\"!eer.canCancel()\" ng-click=\"eer.cancel()\" class=\"btn btn-warning btn-md\">Cancel</a></div></div><div class=\"row\"><form method=\"post\"><textarea ui-tinymce=\"eer.tinymceOptions\" ng-model=\"eer.document\" ng-style=\"{height: eer.editorHeight }\"></textarea></form></div></div>");
$templateCache.put("app/components/key-success-factors/ksf.html","<div class=\"filtration\" print-remove=\"\"><div class=\"row\"><div class=\"col-sm-1 col-filter\"><a ng-disabled=\"!ksf.canAdd()\" href=\"\" class=\"btn btn-primary\" ng-click=\"ksf.add()\"><i class=\"glyphicon glyphicon-plus\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-primary\" ng-click=\"ksf.refresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-default\" print-btn=\"\"><i class=\"glyphicon glyphicon-print\"></i></a></div><div class=\"col-sm-3 col-filter\"><select name=\"selectDivision\" ng-model=\"ksf.currentDivision.division_id\" class=\"form-control\"><option value=\"all\">All Divisions</option><option ng-repeat=\"option in ksf.divisions\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"col-sm-2 col-filter\"><select name=\"selectCc\" ng-model=\"ksf.selectedCc\" class=\"form-control\"><option value=\"all\">All CCs</option><option ng-repeat=\"option in ksf.ccFactory.collection\" value=\"{{option.id}}\">{{option.priority + \" \" + option.description | limitToEllipses:75}}</option></select></div><div class=\"col-sm-4 col-filter\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div><div id=\"ksf-container\" class=\"container-fluid\"><div class=\"row\"><table id=\"ksf-table\" class=\"table scrolling-table\" print-section=\"\"><thead><tr fsm-sticky-header=\"\" scroll-body=\"\'#ksf-table\'\" scroll-stop=\"ksf.getScrollStop()\"><th>Priority</th><th>Description</th><th>Division</th><th>CC Reference</th><th print-remove=\"\">&nbsp;</th></tr></thead><tbody id=\"apps-container\" ui-sortable=\"ksf.sortableOptions\" ng-model=\"ksf.collection\"><tr ng-repeat=\"element in ksf.collection\" id=\"{{element.id}}\" ng-class=\"\'r\' + $index\"><td class=\"priority myHandle text-center\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-class=\"{ready_to_drag: hover}\"><span ng-switch=\"\" on=\"element.priority\"><i class=\"glyphicon glyphicon-move\" ng-switch-when=\"0\">&nbsp;</i> <span ng-switch-default=\"\">{{element.priority}}</span></span></td><td><div class=\"popover-wrapper\"><div class=\"truncate-line description\"><a href=\"#\" editable-textarea=\"element.description\" onbeforesave=\"ksf.update(element, \'description\', $data)\"><div uib-tooltip=\"{{element.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{ element.description | ifEmpty:\'none\' }}</div></a></div></div></td><td class=\"division\"><div class=\"popover-wrapper pull-left\"><a href=\"#\" editable-select=\"element.division_id\" onbeforesave=\"ksf.update(element, \'division_id\', $data)\" e-ng-options=\"d.id as d.name for d in ksf.divisions\">{{ ksf.showDivision(element.division_id) }}</a></div></td><td class=\"ccref\"><span class=\"badge\" ng-repeat=\"ccId in element.core_competencies\" uib-tooltip=\"{{ksf.getCc(ccId).description}}\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"300\">{{ ksf.getCc(ccId).priority }}</span></td><td class=\"extra\" print-remove=\"\"><button type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Delete Objective\" ng-click=\"ksf.confirm_remove(element)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/meetings/meetings.html","<div ng-show=\"meetingsCtrl.loading\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div class=\"meeting-container\"><uib-accordion ng-hide=\"meetingsCtrl.loading\" close-others=\"false\"><uib-accordion-group ng-repeat=\"meeting in meetingsCtrl.meetings\" is-open=\"meeting_group.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-4\">{{meeting.description}}</div><div class=\"col-sm-4\">{{meeting.division.name}}</div><div class=\"col-sm-3\">{{meeting.created_date}}</div><div class=\"col-sm-1\"><div class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': meeting_group.open, \'glyphicon-chevron-right\': !meeting_group.open}\"></div></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-4\"><strong>Description</strong></div><div class=\"col-sm-8\">{{meeting.description}}</div></div><div class=\"row\"><div class=\"col-sm-4\"><strong>Division</strong></div><div class=\"col-sm-8\">{{meeting.division.name}}</div></div><uib-accordion-group is-open=\"att_group.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-11\">Attendees ({{meeting.attendees.length}})</div><div class=\"col-sm-1\"><div class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': att_group.open, \'glyphicon-chevron-right\': !att_group.open}\"></div></div></div></uib-accordion-heading><div class=\"list-group\"><a href=\"\" class=\"list-group-item\" ng-repeat=\"attendee in meeting.attendees\">{{attendee.name}}</a></div></uib-accordion-group><uib-accordion-group is-open=\"ai_group.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-11\">Action Items ({{meeting.action_items.length}})</div><div class=\"col-sm-1\"><div class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': ai_group.open, \'glyphicon-chevron-right\': !ai_group.open}\"></div></div></div></uib-accordion-heading><table class=\"table\"><thead><tr><th>Name</th><th>Responsible</th><th>Due Date</th><th>Update Due Date</th><th>Status</th><th>Complete Date</th></tr></thead><tbody><tr ng-repeat=\"ai in meeting.action_items\"><td>{{ai.name}}</td><td>{{ai.account.display_name || ai.account.name}}</td><td>{{ai.due_date}}</td><td>{{ai.update_due_date}}</td><td>{{ai.status}}</td><td>{{ai.complete_date}}</td></tr></tbody></table></uib-accordion-group><uib-accordion-group is-open=\"comment_group.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-11\">Comments ({{meeting.comments.length}})</div><div class=\"col-sm-1\"><div class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': comment_group.open, \'glyphicon-chevron-right\': !comment_group.open}\"></div></div></div></uib-accordion-heading><div ng-repeat=\"comment in meeting.comments\"><div class=\"row\"><div class=\"col-sm-10\"><strong>{{comment.account.dispaly_name || comment.account.name}}</strong></div><div class=\"col-sm-2\"><strong>{{comment.created_date}}</strong></div></div><p>{{comment.comment}}</p></div></uib-accordion-group></uib-accordion-group></uib-accordion></div>");
$templateCache.put("app/components/mission-statement/ms.html","<div id=\"ms-container\" class=\"container-fluid\"><div class=\"row\"><div class=\"button-group\"><a href=\"\" ng-disabled=\"!ms.canSave()\" ng-click=\"ms.save()\" class=\"btn btn-success btn-md\">Save</a> <a href=\"\" ng-disabled=\"!ms.canCancel()\" ng-click=\"ms.cancel()\" class=\"btn btn-warning btn-md\">Cancel</a></div></div><div class=\"row\"><form method=\"post\"><textarea ui-tinymce=\"ms.tinymceOptions\" ng-model=\"ms.document\" ng-style=\"{height: ms.editorHeight }\"></textarea></form></div></div>");
$templateCache.put("app/components/navbar/change-org-modal.html","<div class=\"modal-header\"><h3 class=\"modal-title\">Switch Organization</h3></div><div class=\"switch-modal modal-body\"><h4>Click An Organization To Switch</h4><div class=\"row\"><div class=\"form-group\"><div class=\"col-md-12\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div><div class=\"row\"><div class=\"list-group\" ng-style=\"{height: modal.editorHeight }\"><a href=\"\" class=\"list-group-item\" ng-click=\"modal.selectTenant(x)\" ng-repeat=\"x in modal.tenants | filter:filterText | orderBy:\'organization_slug\'\">{{x.organization_slug}}</a></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"! modal.principal.is_switched\" ng-click=\"modal.selectMyTenant()\">My Organization</button> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"modal.cancel()\">Cancel</button></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#topnavbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button><a class=\"navbar-brand\" href=\"#/\"><img class=\"nav-logo instance-logo-img\" ng-src=\"{{navbarCtrl.instanceLogo}}\" onerror=\"this.onerror=null\"></a> <a ng-show=\"navbarCtrl.principal.isAuthenticated()\" class=\"navbar-brand\" href=\"#/\"><img class=\"nav-logo company-logo-img\" src=\"/api/organization/image\" onerror=\"this.onerror=null;this.src=\'/assets/images/default-company-logo.jpg\';\"></a></div><div id=\"topnavbar\" class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav\"><li class=\"dropdown-menu-item\" ng-show=\"navbarCtrl.principal.isAuthenticated()\" uib-dropdown=\"\"><a href=\"\" id=\"nav-dashboards\" uib-dropdown-toggle=\"\">Dashboards</a><ul uib-dropdown-menu=\"\" class=\"uib-dropdown-menu\" aria-labelledby=\"nav-dashboards\"><li><a href=\"\" ui-sref=\"personal-dash\" ui-sref-opts=\"{reload:true}\">Personal</a></li><li><a href=\"\" ui-sref=\"company-dash\">Company</a></li></ul></li><li class=\"dropdown-menu-item\" ng-show=\"navbarCtrl.principal.isAuthenticated()\" uib-dropdown=\"\"><a href=\"\" id=\"nav-state-of-company\" uib-dropdown-toggle=\"\">State of Company</a><ul uib-dropdown-menu=\"\" class=\"uib-dropdown-menu\" aria-labelledby=\"nav-state-of-company\"><li><a href=\"\" ui-sref=\"mission-statement\">Mission Statement</a></li><li><a href=\"\" ui-sref=\"key-success-factors\">Industry Key Success Factors</a></li><li><a href=\"\" ui-sref=\"core-competency\">Core Competencies</a></li><li><a href=\"\" ui-sref=\"external-environment-review\">External Environment Review</a></li><li><a href=\"\" ui-sref=\"orgchart\">Organization Chart</a></li><li><a href=\"\" ui-sref=\"executive-summary\">Executive Summary</a></li></ul></li><li ng-show=\"navbarCtrl.principal.isAuthenticated()\"><a href=\"\" ui-sref=\"swot\">Situation Analysis</a></li><li ng-show=\"navbarCtrl.principal.isAuthenticated()\"><a href=\"\" ui-sref=\"objectives\">Objectives</a></li><li class=\"dropdown-menu-item\" ng-show=\"navbarCtrl.principal.isAuthenticated()\" uib-dropdown=\"\"><a href=\"\" id=\"nav-reports\" uib-dropdown-toggle=\"\">Reports</a><ul uib-dropdown-menu=\"\" class=\"uib-dropdown-menu\" aria-labelledby=\"nav-objectives\"><li><a href=\"\" ui-sref=\"business-plan-overview\">Business Plan Overview</a></li><li><a href=\"\" ui-sref=\"objectives-5yr\">Five Year Objectives</a></li></ul></li><li ng-hide=\"navbarCtrl.principal.isAuthenticated()\"><a href=\"{{navbarCtrl.aboutLink}}\" target=\"_blank\">About</a></li><li ng-hide=\"navbarCtrl.principal.isAuthenticated()\"><a href=\"\" ui-sref=\"contact\">Contact</a></li></ul><ul id=\"profile-nav\" class=\"nav navbar-nav pull-right text-center\"><li ng-show=\"navbarCtrl.principal.is_admin\" class=\"profile\"><a href=\"\" ui-sref=\"admin-settings.company\" class=\"profile\"><div class=\"row\"><span class=\"glyphicon glyphicon-wrench\"></span></div><div class=\"row\">Admin</div></a></li><li ng-show=\"navbarCtrl.principal.can_switch\" class=\"profile\" ng-class=\"{switched: navbarCtrl.principal.is_switched}\"><a href=\"\" ng-click=\"navbarCtrl.changeTenant()\" class=\"org profile\"><div class=\"row\"><span class=\"glyphicon glyphicon-briefcase\"></span></div><div class=\"row\">{{navbarCtrl.principal.current_org}}</div></a></li><li class=\"profile pull-right\" ng-show=\"navbarCtrl.principal.isAuthenticated()\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\" class=\"profile\"><div class=\"row\"><span class=\"glyphicon glyphicon-user\"></span></div><div class=\"row\">My Profile</div></a><div uib-dropdown-menu=\"\" class=\"account-menu uib-dropdown-menu\"><div class=\"content\"><span class=\"welcome\">Welcome {{navbarCtrl.principal.name}}!</span><div class=\"button-group\"><a href=\"\" class=\"btn btn-primary btn-sm\" ui-sref=\"user-settings\"><span class=\"glyphicon glyphicon-user\"></span> My Account</a> <a href=\"\" class=\"btn btn-danger btn-md\" ng-click=\"navbarCtrl.logout()\"><span class=\"glyphicon glyphicon-log-out\"></span> Logout</a></div><div class=\"current-company\" ng-if=\"navbarCtrl.principal.can_switch\"><div>Organization <span class=\"glyphicon glyphicon-briefcase\"></span> {{navbarCtrl.principal.current_org}}</div><div><a href=\"\" class=\"\" ng-click=\"navbarCtrl.changeTenant()\">Switch Organization</a></div></div></div></div></li><li ng-hide=\"navbarCtrl.principal.isAuthenticated()\" class=\"pull-right\"><a href=\"\" ui-sref=\"login\">Login</a></li></ul></div></div></nav>");
$templateCache.put("app/components/objectives/objective.report.html","<a href=\"\" print-btn=\"\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-print\"></i> Print</a><div print-section=\"\" class=\"container-fluid\"><h3>{{o.division.name}} - Priority #{{o.objective.priority}}</h3><h4>{{o.objective.description}}</h4><br><div class=\"row\"><div class=\"col-xs-6\"><table id=\"vertical-2\"><caption>Responsible</caption><tr><th>Name: &nbsp;</th><td>{{o.account.name}}</td></tr><tr><th>Phone: &nbsp;</th><td>{{o.account.phone}}</td></tr><tr><th>Email: &nbsp;</th><td>{{o.account.email}}</td></tr></table></div><div class=\"col-xs-6\"><table id=\"vertical-1\"><caption>Important Dates</caption><tr><th>Created: &nbsp;</th><td>{{(o.objective.created_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr><tr><th>Due: &nbsp;</th><td>{{(o.objective.due_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr><tr><th>Completed: &nbsp;</th><td>{{(o.objective.complete_date| date:\'MM/dd/yyyy\') || \'Not set\'}}</td></tr></table></div></div><br><table class=\"table inner-table\"><caption>Related SWOTs</caption><thead><tr print-avoid-break=\"\"><th class=\"col-sm-1\">Priority</th><th class=\"col-sm-2\">Type</th><th class=\"col-sm-8\">Description</th><th class=\"col-sm-1\">Status</th></tr></thead><tbody><tr print-avoid-break=\"\" ng-repeat=\"swot in o.swots | orderBy:\'sort_order\'\"><td>{{swot.priority}}</td><td>{{swot.type}}</td><td>{{swot.description}}</td><td>{{swot.status}}</td></tr></tbody></table><br><table class=\"table inner-table\"><caption>Related Core Competencies</caption><thead><tr print-avoid-break=\"\"><th class=\"col-sm-4\">Description</th><th class=\"col-sm-2\">Division</th><th class=\"col-sm-2\">Scope</th><th class=\"col-sm-2\">Status</th></tr></thead><tbody><tr print-avoid-break=\"\" ng-repeat=\"cc in o.core_competencies| orderBy:\'sort_order\'\"><td>{{cc.description}}</td><td>{{o.divisionFactory.getById(cc.division_id).name}}</td><td>{{cc.scope || \'none\'}}</td><td>{{cc.status || \'none\'}}</td></tr></tbody></table><br><table class=\"table inner-table\"><caption>Tactics</caption><thead><tr print-avoid-break=\"\"><th class=\"col-sm-4\">Description</th><th class=\"col-sm-2\">Responsible</th><th class=\"col-sm-2\">Due</th><th class=\"col-sm-2\">Update</th><th class=\"col-sm-2\">Completed</th></tr></thead><tbody><tr print-avoid-break=\"\" ng-repeat=\"tactic in o.tactics | orderBy:\'sort_order\'\"><td>{{tactic.description}}</td><td>{{obj.accountFactory.getById(tactic.id).name}}</td><td>{{(tactic.due_date | date:\'MM/dd/yyyy\') || \'none\'}}</td><td>{{(tactic.update_due_date | date:\'MM/dd/yyyy\') || \'none\'}}</td><td>{{(tactic.complete_date | date:\'MM/dd/yyyy\') || \'none\'}}</td></tr></tbody></table><br><table class=\"table inner-table\"><caption>Committee Members</caption><thead><tr print-avoid-break=\"\"><th class=\"col-sm-3\">Name</th><th class=\"col-sm-3\">Title</th><th class=\"col-sm-3\">Phone</th><th class=\"col-sm-3\">Email</th></tr></thead><tbody><tr print-avoid-break=\"\" ng-repeat=\"member in o.committee_members | orderBy:\'sort_order\'\"><td>{{member.name}}</td><td>{{member.title}}</td><td>{{member.phone}}</td><td>{{member.email}}</td></tr></tbody></table><br></div>");
$templateCache.put("app/components/objectives/objectives-5yr.html","<div ng-show=\"objCtrl.loading\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div class=\"objectives-5yr-container\" ng-if=\"!objCtrl.loading\"><div class=\"filtration\"><div print-remove=\"\" class=\"row\"><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-primary\" ng-click=\"objCtrl.refreshObjectives()\"><i class=\"glyphicon glyphicon-refresh\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" print-btn=\"\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-print\"></i></a></div><div class=\"col-sm-2 col-filter\"><select name=\"selectAccount\" ng-model=\"objCtrl.currentAccountId\" class=\"form-control\"><option value=\"all\">All Users</option><option ng-repeat=\"account in objCtrl.accountFactory.collection\" value=\"{{account.id}}\">{{account.name}}</option></select></div><div class=\"col-sm-3 col-filter\"><select name=\"selectDivision\" ng-model=\"objCtrl.currentDivision.division_id\" class=\"form-control\"><option value=\"all\">All Divisions</option><option ng-repeat=\"option in objCtrl.divisionFactory.collection\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"col-sm-2 col-filter\"><select name=\"selectYear\" ng-model=\"objCtrl.currentYear\" class=\"form-control\" ng-options=\"year for year in objCtrl.allYears\"></select></div><div class=\"col-sm-3 col-filter\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"legend pull-right\"><ul><li><span class=\"legend-label pull-left\"><strong>Legend:</strong></span></li><li><span class=\"glyphicon glyphicon-check text-success\"></span> Completed</li><li><span class=\"glyphicon glyphicon-unchecked\"></span> Due</li><li><span class=\"glyphicon glyphicon-log-in\"></span> Updated</li><li><span class=\"glyphicon glyphicon-remove text-danger\"></span> Overdue</li></ul></div></div></div><table print-section=\"\" id=\"objectives-table\" class=\"table scrolling-table outer-table\"><thead><tr fsm-sticky-header=\"\" scroll-body=\"\'#objectives-table\'\" scroll-stop=\"objCtrl.getScrollStop()\"><th></th><th>Div</th><th class=\"text-center\">#</th><th>Desc</th><th>Owner</th><th class=\"text-center\">{{objCtrl.currentYear - 1}}</th><th class=\"text-center\" ng-repeat=\"(monthIndex, monthStr) in objCtrl.allMonths\">{{monthStr}}</th><th class=\"text-center\">{{objCtrl.currentYear + 1}}</th><th class=\"text-center\">{{objCtrl.currentYear + 2}}</th><th class=\"text-center\">{{objCtrl.currentYear + 3}}</th></tr></thead><tbody ui-sortable=\"objCtrl.sortableOptions\" ng-model=\"objCtrl.collection\"><tr ng-repeat-start=\"objective in objCtrl.collection\" ng-model=\"row_hover\" id=\"obj_{{objective.id}}\" class=\"outer-table-header\"><td><button type=\"button\" class=\"btn btn-default btn-xs btn-chevron\" aria-label=\"Show/Hide\" ng-click=\"objective.isOpen = !objective.isOpen\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': objective.isOpen, \'glyphicon-chevron-right\': !objective.isOpen}\" aria-hidden=\"true\"></span></button></td><td>{{objCtrl.divisionFactory.getById(objective.division_id).name || \'none\'}}</td><td class=\"priority text-center\"><span>{{objective.priority}}</span></td><td><div class=\"popover-wrapper\"><div uib-tooltip=\"{{objective.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" class=\"description\">{{ objective.description || \'none\' }}</div></div></td><td>{{objCtrl.accountFactory.getById(objective.account_id).name || \'none\'}}</td><td class=\"text-center\"><span class=\"glyphicon\" ng-class=\"{ \'glyphicon-check text-success\': objCtrl.objCompletedInYear(objective, objCtrl.currentYear - 1), \'glyphicon-remove text-danger\': objCtrl.objNotDoneDueInYear(objective, objCtrl.currentYear - 1) }\"></span></td><td class=\"text-center\" ng-repeat=\"(monthIndex, monthName) in objCtrl.allMonths\"><span class=\"glyphicon\" ng-class=\"{ \'glyphicon-check text-success\': objCtrl.objCompletedInYearAndMonth(objective, objCtrl.currentYear, monthIndex), \'glyphicon-check text-success\': objCtrl.objNotDoneDueInYearAndMonthPast(objective, objCtrl.currentYear, monthIndex), \'glyphicon-unchecked\': objCtrl.objNotDoneDueInYearAndMonthFuture(objective, objCtrl.currentYear, monthIndex), \'glyphicon-log-in\': objCtrl.objNotDoneUpdateDueInYearAndMonthFuture(objective, objCtrl.currentYear, monthIndex) }\"></span></td><td class=\"text-center\" ng-repeat=\"additionalYear in [1,2,3]\"><span class=\"glyphicon\" ng-class=\"{ \'glyphicon-check text-success\': objCtrl.objCompletedInYear(objective, objCtrl.currentYear + additionalYear), \'glyphicon-unchecked\': objCtrl.objNotDoneDueInYear(objective, objCtrl.currentYear + additionalYear), \'glyphicon-log-in\': objCtrl.objNotDoneUpdateDueInYearAndMonthFuture(objective, objCtrl.currentYear, monthIndex) }\"></span></td></tr><tr ng-repeat-end=\"\" class=\"inner-table-header\" ng-if=\"objective.isOpen\"><td colspan=\"21\" class=\"collapsible-td\"><div class=\"tactic-header\"><h4>Tactics</h4></div><table class=\"table inner-table\"><thead><tr><th class=\"col-sm-4\">Description</th><th class=\"col-sm-2\">Responsible</th><th class=\"col-sm-2\">Due</th><th class=\"col-sm-2\">Update</th><th class=\"col-sm-2\">Completed</th><th class=\"col-sm-2\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"tactic_id in objective.tactics | orderBy:\'sort_order\'\" ng-init=\"tactic = objCtrl.tacticFactory.getById(tactic_id)\"><td><div class=\"popover-wrapper\"><div class=\"description\"><div uib-tooltip=\"{{tactic.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" class=\"description\">{{ tactic.description || \'none\' }}</div></div></div></td><td><div class=\"popover-wrapper\">{{objCtrl.accountFactory.getById(tactic.account_id).name || \'none\'}}</div></td><td><div class=\"popover-wrapper\"><span>{{(tactic.due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span>{{(tactic.update_due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span>{{(tactic.complete_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td></tr></tbody></table></td></tr></tbody></table></div>");
$templateCache.put("app/components/objectives/objectives.html","<div ng-show=\"objCtrl.loading\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div class=\"objectives-container\" ng-hide=\"objCtrl.loading\"><div print-remove=\"\" class=\"filtration\"><div class=\"row\"><div class=\"col-sm-1 col-filter\"><a ng-disabled=\"!objCtrl.canAddObjective()\" href=\"\" class=\"btn btn-primary\" ng-click=\"objCtrl.addObjective()\"><i class=\"glyphicon glyphicon-plus\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-primary\" ng-click=\"objCtrl.refreshObjectives()\"><i class=\"glyphicon glyphicon-refresh\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-default\" print-btn=\"\"><i class=\"glyphicon glyphicon-print\"></i></a></div><div class=\"col-sm-3 col-filter\"><select name=\"selectDivision\" ng-model=\"objCtrl.currentDivision.division_id\" class=\"form-control\"><option value=\"all\">All Divisions</option><option ng-repeat=\"option in objCtrl.divisionFactory.collection\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"col-sm-2 col-filter\"><select name=\"selectAccount\" ng-model=\"objCtrl.currentAccountId\" class=\"form-control\"><option value=\"all\">All Users</option><option ng-repeat=\"account in objCtrl.accountFactory.collection\" value=\"{{account.id}}\">{{account.name}}</option></select></div><div class=\"col-sm-4 col-filter\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div><table print-section=\"\" id=\"objectives-table\" class=\"table scrolling-table outer-table\"><thead><tr id=\"objectives-table-header\" fsm-sticky-header=\"\" scroll-body=\"\'#objectives-table\'\" scroll-stop=\"objCtrl.getScrollStop()\"><th print-remove=\"\"></th><th print-remove=\"\"></th><th>Priority</th><th>Description</th><th>Responsible</th><th>Division</th><th>Due</th><th>Update</th><th>Completed</th><th>Primary SWOT</th><th print-remove=\"\">&nbsp;</th></tr></thead><tbody ui-sortable=\"objCtrl.sortableOptions\" ng-model=\"objCtrl.collection\"><tr print-avoid-break=\"\" ng-repeat-start=\"objective in objCtrl.collection\" ng-model=\"row_hover\" id=\"obj_{{objective.id}}\" class=\"outer-table-header\"><td print-remove=\"\" class=\"myHandle\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-mousedown=\"objCtrl.startDragging()\" ng-class=\"{ready_to_drag: hover || row_hover}\"></td><td print-remove=\"\"><button type=\"button\" class=\"btn btn-default btn-xs btn-chevron\" aria-label=\"Show/Hide\" ng-click=\"objective.isOpen = !objective.isOpen\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': objective.isOpen, \'glyphicon-chevron-right\': !objective.isOpen}\" aria-hidden=\"true\"></span></button></td><td class=\"priority myHandle text-center\" ng-mouseenter=\"row_hover = true\" ng-mouseleave=\"row_hover = false\" ng-mousedown=\"objCtrl.startDragging()\"><span ng-switch=\"\" on=\"objective.priority\"><i class=\"glyphicon glyphicon-move\" ng-switch-when=\"0\">&nbsp;</i> <span ng-switch-default=\"\">{{objective.priority}}</span></span></td><td><div class=\"popover-wrapper\"><a href=\"#\" editable-textarea=\"objective.description\" onbeforesave=\"objCtrl.saveXeditable(\'objective\', objective, \'description\', $data)\"><div uib-tooltip=\"{{objective.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" ng-class=\"{\'editable-empty\': !objective.description}\" class=\"truncate-line description editable-click\">{{ objective.description || \'none\' }}</div></a></div></td><td><div class=\"popover-wrapper\"><a href=\"#\" class=\"editable-click\" ng-class=\"{\'editable-empty\': !objective.account_id}\" editable-select=\"objective.account_id\" e-ng-options=\"account.id as account.name for account in objCtrl.accountFactory.collection\" onbeforesave=\"objCtrl.saveXeditable(\'objective\', objective, \'account_id\', $data)\">{{objCtrl.accountFactory.getById(objective.account_id).name || \'none\'}}</a></div></td><td><div class=\"popover-wrapper\"><a href=\"#\" editable-select=\"objective.division_id\" class=\"editable-click\" e-ng-options=\"d.id as d.name for d in objCtrl.divisionFactory.collection\" onbeforesave=\"objCtrl.saveXeditable(\'objective\', objective, \'division_id\', $data)\">{{objCtrl.divisionFactory.getById(objective.division_id).name || \'none\'}}</a></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-click=\"objective.dueDateOpened=true\" ng-class=\"{\'editable-empty\': !objective.due_date}\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"objective.due_date\" ng-change=\"objCtrl.saveXeditable(\'objective\', objective, \'due_date\', objective[\'due_date\'])\" is-open=\"objective.dueDateOpened\" ng-required=\"true\" close-text=\"Close\">{{(objective.due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-click=\"objective.updateDueDateOpened=true\" ng-class=\"{\'editable-empty\': !objective.update_due_date}\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"objective.update_due_date\" ng-change=\"objCtrl.saveXeditable(\'objective\', objective, \'update_due_date\', objective[\'update_due_date\'])\" is-open=\"objective.updateDueDateOpened\" ng-required=\"true\" close-text=\"Close\">{{(objective.update_due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-click=\"objective.completeDateOpened=true\" ng-class=\"{\'editable-empty\': !objective.complete_date}\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"objective.complete_date\" ng-change=\"objCtrl.saveXeditable(\'objective\', objective, \'complete_date\', objective[\'complete_date\'])\" is-open=\"objective.completeDateOpened\" ng-required=\"true\" close-text=\"Close\">{{(objective.complete_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><span class=\"editable-click\" uib-tooltip=\"{{objCtrl.getSwotDescription(objective.primary_swot_id, -1)}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" ng-class=\"{\'editable-empty\': !objective.primary_swot_id}\" ng-click=\"objective.isOpen = !objective.isOpen\">{{objCtrl.getSwotDescription(objective.primary_swot_id, 75) || \'none\'}}</span></td><td print-remove=\"\" class=\"extra control\"><div class=\"button-group comment-container\"><span uib-tooltip=\"Open comments box\" tooltip-placement=\"top\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\"><div class=\"btn row-control\" role=\"button\" ng-init=\"commentParent = objective; ctrl = objCtrl; parentType = \'objective\'\" popover-is-open=\"commentParent.commentIsOpen\" popover-trigger=\"outsideClick\" uib-popover-template=\"\'app/templates/commentbox/commentbox.html\'\" popover-placement=\"left\">{{objective.comments.length}} <span class=\"glyphicon glyphicon-comment\"></span></div></span><button type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Delete Objective\" ng-click=\"objCtrl.confirmDeleteObjective(objective)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></td></tr><tr print-remove=\"\" ng-repeat-end=\"\" class=\"inner-table-header\" ng-if=\"objective.isOpen\" ng-init=\"categorizedSwotIds = objCtrl.categorizeSwots(objective)\"><td colspan=\"11\" class=\"collapsible-td\"><a href=\"\" ui-sref=\"objective({objective_id: objective.id})\" class=\"btn btn-default btn-sm\"><i class=\"glyphicon glyphicon-book\"></i> Report</a><h4>SWOT</h4><form class=\"form-horizontal top-collapsible-form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Strengths</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"categorizedSwotIds.strength\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'swots\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'swots\', objective)\"><ui-select-match placeholder=\"Select strength...\"><div uib-tooltip=\"{{$item.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.priority}}: {{$item.description | limitToEllipses:75}}</div></ui-select-match><ui-select-choices repeat=\"strength.id as strength in objCtrl.swotStrengthFactory.collection | propsFilter: {description: $select.search}\"><div ng-bind-html=\"strength.description | limitToEllipses:125 | highlight: $select.search\"></div><small>priority: {{strength.priority}}</small></ui-select-choices></ui-select></div></div></form><form class=\"form-horizontal top-collapsible-form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Weaknesses</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"categorizedSwotIds.weakness\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'swots\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'swots\', objective)\"><ui-select-match placeholder=\"Select weakness...\"><div uib-tooltip=\"{{$item.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.priority}}: {{$item.description | limitToEllipses:75}}</div></ui-select-match><ui-select-choices repeat=\"weakness.id as weakness in objCtrl.swotWeaknessFactory.collection | propsFilter: {description: $select.search}\"><div ng-bind-html=\"weakness.description | limitToEllipses:125 | highlight: $select.search\"></div><small>priority: {{weakness.priority}}</small></ui-select-choices></ui-select></div></div></form><form class=\"form-horizontal top-collapsible-form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Opportunities</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"categorizedSwotIds.opportunity\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'swots\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'swots\', objective)\"><ui-select-match placeholder=\"Select opportunity...\"><div uib-tooltip=\"{{$item.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.priority}}: {{$item.description | limitToEllipses:75}}</div></ui-select-match><ui-select-choices repeat=\"opportunity.id as opportunity in objCtrl.swotOpportunityFactory.collection | propsFilter: {description: $select.search}\"><div ng-bind-html=\"opportunity.description | limitToEllipses:125 | highlight: $select.search\"></div><small>priority: {{opportunity.priority}}</small></ui-select-choices></ui-select></div></div></form><form class=\"form-horizontal top-collapsible-form\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Threats</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"categorizedSwotIds.threat\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'swots\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'swots\', objective)\"><ui-select-match placeholder=\"Select threat...\"><div uib-tooltip=\"{{$item.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.priority}}: {{$item.description | limitToEllipses:75}}</div></ui-select-match><ui-select-choices repeat=\"threat.id as threat in objCtrl.swotThreatFactory.collection | propsFilter: {description: $select.search}\"><div ng-bind-html=\"threat.description | limitToEllipses:125 | highlight: $select.search\"></div><small>priority: {{threat.priority}}</small></ui-select-choices></ui-select></div></div></form><hr><div class=\"tactic-header\"><h4>Tactics</h4><a ng-disabled=\"!objCtrl.canAddTactic(objective)\" href=\"\" class=\"btn btn-primary btn-xs\" ng-click=\"objCtrl.addTactic(objective)\"><i class=\"glyphicon glyphicon-plus\"></i> Add</a></div><table class=\"table inner-table\"><thead><tr><th class=\"col-sm-4\">#</th><th class=\"col-sm-4\">Description</th><th class=\"col-sm-2\">Responsible</th><th class=\"col-sm-2\">Due</th><th class=\"col-sm-2\">Update</th><th class=\"col-sm-2\">Completed</th><th class=\"col-sm-2\">&nbsp;</th></tr></thead><tbody><tr ng-repeat=\"tactic in objCtrl.getTactics(objective) | orderBy:objCtrl.recordValForSort:false\"><td>{{ $index + 1 }}</td><td><div class=\"popover-wrapper\"><div class=\"truncate-line description\"><a href=\"#\" editable-textarea=\"tactic.description\" onbeforesave=\"objCtrl.saveXeditable(\'tactic\', tactic, \'description\', $data)\"><div uib-tooltip=\"{{tactic.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" class=\"truncate-line description\">{{ tactic.description || \'none\' }}</div></a></div></div></td><td><div class=\"popover-wrapper\"><a href=\"#\" editable-select=\"tactic.account_id\" onbeforesave=\"objCtrl.saveXeditable(\'tactic\', tactic, \'account_id\', $data)\" e-ng-options=\"account.id as account.name for account in objCtrl.accountFactory.collection\">{{objCtrl.accountFactory.getById(tactic.account_id).name || \'none\'}}</a></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-class=\"{\'editable-empty\': !tactic.due_date}\" ng-click=\"tactic.dueDateOpened=true\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"tactic.due_date\" ng-change=\"objCtrl.saveXeditable(\'tactic\', tactic, \'due_date\', tactic[\'due_date\'])\" is-open=\"tactic.dueDateOpened\" ng-required=\"true\" close-text=\"Close\">{{(tactic.due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-click=\"tactic.updateDueDateOpened=true\" ng-class=\"{\'editable-empty\': !tactic.update_due_date}\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"tactic.update_due_date\" ng-change=\"objCtrl.saveXeditable(\'tactic\', tactic, \'update_due_date\', tactic[\'update_due_date\'])\" is-open=\"tactic.updateDueDateOpened\" ng-required=\"true\" close-text=\"Close\">{{(tactic.update_due_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td><div class=\"popover-wrapper\"><span class=\"editable-click\" ng-click=\"tactic.completeDate=true\" ng-class=\"{\'editable-empty\': !tactic.complete_date}\" uib-datepicker-popup=\"MM/dd/yy\" ng-model=\"tactic.complete_date\" ng-change=\"objCtrl.saveXeditable(\'tactic\', tactic, \'complete_date\', tactic[\'complete_date\'])\" is-open=\"tactic.completeDate\" ng-required=\"true\" close-text=\"Close\">{{(tactic.complete_date | date:\'MM/dd/yy\') || \'none\'}}</span></div></td><td class=\"extra control\" print-remove=\"\"><div class=\"button-group comment-container\"><span uib-tooltip=\"Open comments box\" tooltip-placement=\"top\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" class=\"btn row-control\" role=\"button\" ng-init=\"commentParent = tactic; ctrl = objCtrl; parentType = \'tactic\'\" popover-is-open=\"commentParent.commentIsOpen\" popover-trigger=\"outsideClick\" uib-popover-template=\"\'app/templates/commentbox/commentbox.html\'\" popover-placement=\"left\">{{tactic.comments.length}} <span class=\"glyphicon glyphicon-comment\"></span></span> <button uib-tooltip=\"Promote this tactic to an objective\" tooltip-placement=\"top\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\" type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Promote to objective\" ng-click=\"ctrl.promoteTactic(objective, tactic)\"><span class=\"glyphicon glyphicon-arrow-up\"></span></button><button type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Delete Tactic\" ng-click=\"ctrl.confirmDeleteTactic(objective, tactic)\"><span class=\"glyphicon glyphicon-trash\"></span></button></div></td></tr></tbody></table><hr><h4>Details</h4><form class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Committee Members</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"objective.committee_members\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'committee_members\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'committee_members\', objective)\"><ui-select-match placeholder=\"Select user...\"><div uib-tooltip=\"{{$item.name}} {{$item.title}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.name + \': \' + $item.title | limitToEllipses:55}}</div></ui-select-match><ui-select-choices repeat=\"account.id as account in objCtrl.accountFactory.collection | propsFilter: {name: $select.search, email: $select.search, title: $select.title}\"><div ng-bind-html=\"account.name + \': \' + account.title | highlight: $select.search\"></div><small>email: {{account.email}}</small></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">Core Competencies</label><div class=\"col-sm-10\"><ui-select multiple=\"\" ng-model=\"objective.core_competencies\" on-select=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'add\', \'core_competencies\', objective)\" on-remove=\"objCtrl.saveUiSelect($item, $model, \'objective\', \'remove\', \'core_competencies\', objective)\"><ui-select-match placeholder=\"Select core competency...\"><div uib-tooltip=\"{{$item.priority}}: {{$item.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{$item.priority + \': \' + $item.description | limitToEllipses:30}}</div></ui-select-match><ui-select-choices repeat=\"cc.id as cc in objCtrl.ccFactory.collection | propsFilter: {description: $select.search }\"><div ng-bind-html=\"cc.priority + \': \' + cc.description | limitToEllipses: 180 | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></form></td></tr></tbody></table></div>");
$templateCache.put("app/components/orgchart/orgchart.html","<div ng-show=\"!orgChartCtrl.loaded\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div id=\"orgchart-container\"><script type=\"text/ng-template\" id=\"tree_item_renderer\"><div class=\"account-name\">{{account.name}}</div> <div class=\"account-title\">{{account.title}}</div> <div class=\"account-title\"><i>{{account.division}}</i></div> <ul> <li ng-repeat=\"account in account.direct_reports\" ng-include=\"\'tree_item_renderer\'\"></li> </ul></script><div ng-show=\"orgChartCtrl.loaded\"><div id=\"orgchart\"></div><ul id=\"chart-source\" ng-hide=\"true\"><li class=\"orgchart-org-node\">{{orgChartCtrl.currentOrg}}<ul><li class=\"orgchart-node\" ng-repeat=\"account in orgChartCtrl.accountTree\" ng-include=\"\'tree_item_renderer\'\"></li></ul></li></ul></div><div class=\"legend\"><div class=\"row\"><div class=\"col-sm-1\"><div class=\"legend-pill clickable align-orgchart\"></div></div><div class=\"col-sm-9\">Manager (click to expand)</div><div class=\"col-sm-2\"><a class=\"pull-right align-orgchart\" ui-sref=\"admin-settings.accounts\" ng-show=\"orgChartCtrl.is_admin\" aria-label=\"Edit Accounts\">Edit Accounts</a></div></div><div class=\"row\"><div class=\"col-sm-1\"><div class=\"legend-pill non-clickable align-orgchart\"></div></div><div class=\"col-sm-11\">Individual contributor</div></div></div></div>");
$templateCache.put("app/components/personal-dash/personal-dash.html","<div ng-if=\"!personalDash.loaded()\"><div class=\"spinner-container\"><div class=\"spinner\"></div></div></div><div id=\"personal-dash-container\" ng-if=\"personalDash.loaded()\"><div class=\"group-container\"><h3 class=\"title\">My Objectives</h3><hr><div class=\"row\"><div class=\"col-md-6\"><div ng-repeat=\"objective in personalDash.objectives | orderBy: \'resolved_due_date\'\"><div class=\"row\"><div class=\"col-sm-3\"><span class=\"label\" ng-class=\"{\'label-danger\': personalDash.isPast(objective.resolved_due_date) && objective.complete_date === null, \'label-default\': !personalDash.isPast(objective.resolved_due_date), \'label-success\': objective.complete_date !== null}\" am-time-ago=\"objective.resolved_due_date\"></span></div><div class=\"col-sm-9 objective-viewer\"><a href=\"\" ui-sref=\"objectives({objectiveId:objective.id})\" ng-init=\"objective = objective\" popover-trigger=\"mouseenter\" uib-popover-template=\"\'app/templates/objectiveViewer/objectiveViewer.html\'\" popover-placement=\"bottom-left\">{{(objective.division.name + \" \" + objective.priority + \': \' + objective.description) | ifEmpty:\'none\'}}</a></div></div></div></div><div class=\"col-md-6\"><div class=\"row text-center\"><div class=\"col-md-12\"><button ng-show=\"personalDash.selectedObjective\" ng-click=\"personalDash.selectedObjective = null\" class=\"glyphicon glyphicon-arrow-left\"></button><h4 ng-show=\"personalDash.objectives.length > 0\" class=\"objective-chart-title\">{{personalDash.selectedObjective.priority}} {{personalDash.selectedObjective.description | ifEmpty:\'My Objectives\'}}</h4></div></div><div class=\"row\"><div class=\"col-md-12\"><nvd3 ng-if=\"personalDash.objectives.length > 0 && !personalDash.selectedObjective\" class=\"objective-chart\" options=\"personalDash.objChartOptions\" data=\"personalDash.objChartData\"></nvd3><nvd3 ng-if=\"personalDash.selectedObjective\" class=\"tactic-chart\" options=\"personalDash.tacticChartOptions\" data=\"personalDash.selectedObjTactics\"></nvd3></div></div><div class=\"row legend\"><div class=\"col-sm-4\"><div class=\"legend-pill complete\"></div><div class=\"legend-label\">Complete</div></div><div class=\"col-sm-4\"><div class=\"legend-pill overdue\"></div><div class=\"legend-label\">Overdue</div></div><div class=\"col-sm-4\"><div class=\"legend-pill pending\"></div><div class=\"legend-label\">Pending</div></div></div></div></div></div><div class=\"group-container\"><h3 class=\"title\">My Tactics</h3><hr><div class=\"row\"><div class=\"col-md-6\"><div ng-repeat=\"tactic in personalDash.tactics\"><div class=\"row\"><div class=\"col-sm-3\"><span class=\"label\" ng-class=\"{\'label-danger\': personalDash.isPast(tactic.resolved_due_date) && tactic.complete_date === null, \'label-default\': !personalDash.isPast(tactic.resolved_due_date), \'label-success\': tactic.complete_date !== null}\" am-time-ago=\"tactic.resolved_due_date\"></span></div><div class=\"col-sm-9 objective-viewer\"><a href=\"\" ui-sref=\"objectives({objectiveId:objective.objective_id})\" ng-init=\"objective = tactic\" uib-popover-template=\"\'app/templates/objectiveViewer/objectiveViewer.html\'\" popover-trigger=\"mouseenter\" popover-placement=\"bottom-left\">{{tactic.objective.division.name + \" \" + tactic.objective.priority + \" - T\" + tactic.sort_order + \": \" + tactic.description | ifEmpty:\'none\'}}</a></div></div></div></div><div class=\"col-md-6\"><div class=\"row text-center\"><h4 ng-show=\"personalDash.tactics.length > 0\" class=\"objective-chart-title\">My Tactics</h4></div><nvd3 ng-if=\"personalDash.tactics.length > 0\" options=\"personalDash.tacticChartOptions\" data=\"personalDash.tactics\"></nvd3><div class=\"row legend\"><div class=\"col-sm-4\"><div class=\"legend-pill complete\"></div><div class=\"legend-label\">Complete</div></div><div class=\"col-sm-4\"><div class=\"legend-pill overdue\"></div><div class=\"legend-label\">Overdue</div></div><div class=\"col-sm-4\"><div class=\"legend-pill pending\"></div><div class=\"legend-label\">Pending</div></div></div></div></div></div><div class=\"group-container\"><h3 class=\"title\">My Committee Objectives</h3><hr><div class=\"row\"><div class=\"col-md-6\"><div ng-repeat=\"objective in personalDash.committee_objectives | orderBy: \'resolved_due_date\'\"><div class=\"row\"><div class=\"col-sm-3\"><span class=\"label\" ng-class=\"{\'label-danger\': personalDash.isPast(objective.resolved_due_date) && objective.complete_date === null, \'label-default\': !personalDash.isPast(objective.resolved_due_date), \'label-success\': objective.complete_date !== null}\" am-time-ago=\"objective.resolved_due_date\"></span></div><div class=\"col-sm-9 objective-viewer\"><a href=\"\" ui-sref=\"objectives({objectiveId:objective.id})\" ng-init=\"objective = objective\" popover-trigger=\"mouseenter\" uib-popover-template=\"\'app/templates/objectiveViewer/objectiveViewer.html\'\" popover-placement=\"bottom-left\">{{(objective.division.name + \" \" + objective.priority + \': \' + objective.description) | ifEmpty:\'none\'}}</a></div></div></div></div><div class=\"col-md-6\"><div class=\"row text-center\"><button ng-show=\"personalDash.selectedComObj\" ng-click=\"personalDash.selectedComObj = null\" class=\"glyphicon glyphicon-arrow-left\"></button><h4 ng-show=\"personalDash.committee_objectives.length > 0\" class=\"objective-chart-title\">{{personalDash.selectedComObj.priority}} {{personalDash.selectedComObj.description | ifEmpty:\'My Committee Objectives\'}}</h4></div><div class=\"row\"><nvd3 ng-if=\"personalDash.committee_objectives.length > 0 && !personalDash.selectedComObj\" class=\"objective-chart\" options=\"personalDash.comObjChartOptions\" data=\"personalDash.comObjChartData\"></nvd3><nvd3 ng-if=\"personalDash.selectedComObj\" class=\"tactic-chart\" options=\"personalDash.tacticChartOptions\" data=\"personalDash.selectedComObjTactics\"></nvd3></div><div class=\"row legend\"><div class=\"col-sm-4\"><div class=\"legend-pill complete\"></div><div class=\"legend-label\">Complete</div></div><div class=\"col-sm-4\"><div class=\"legend-pill overdue\"></div><div class=\"legend-label\">Overdue</div></div><div class=\"col-sm-4\"><div class=\"legend-pill pending\"></div><div class=\"legend-label\">Pending</div></div></div></div></div></div></div>");
$templateCache.put("app/components/swot/swot.html","<div id=\"swot-container\" class=\"container-fluid\" print-remove=\"\"><div class=\"filtration\"><div class=\"row\"><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-primary\" ng-click=\"swotCtrl.refresh()\"><i class=\"glyphicon glyphicon-refresh\"></i></a></div><div class=\"col-sm-1 col-filter\"><a href=\"\" class=\"btn btn-default\" print-btn=\"\"><i class=\"glyphicon glyphicon-print\"></i></a></div><div class=\"col-sm-3 col-filter\"><select name=\"selectDivision\" ng-model=\"swotCtrl.currentDivision.division_id\" class=\"form-control\"><option value=\"all\">All Divisions</option><option ng-repeat=\"option in swotCtrl.divisions\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"col-sm-3 col-filter\"><select name=\"selectbasic\" class=\"form-control\" ng-model=\"swotCtrl.selectedSwotType\"><option value=\"all\">All SWOT Types</option><option value=\"strength\">Strengths</option><option value=\"weakness\">Weaknesses</option><option value=\"opportunity\">Opportunities</option><option value=\"threat\">Threats</option></select></div><div class=\"col-sm-4 col-filter\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div></div></div></div><div class=\"swot container-fluid\"><div class=\"row\"><uib-accordion ng-hide=\"swotCtrl.loading\" close-others=\"false\"><uib-accordion-group ng-repeat=\"layout in swotCtrl.layouts\" is-open=\"swotCtrl.accordionOpen[layout.key]\" ng-show=\"swotCtrl.showSection(layout.key)\"><uib-accordion-heading print-remove=\"\"><div class=\"row\"><div class=\"col-sm-1\"><div class=\"pull-left glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': swotCtrl.accordionOpen[layout.key], \'glyphicon-chevron-right\': !swotCtrl.accordionOpen[layout.key]}\"></div></div><div class=\"col-sm-4\"><div class=\"row\"><div class=\"col-sm-5\">{{layout.title}}</div><div class=\"col-sm-7\"><span class=\"badge\">{{swotCtrl.collections[layout.key].length}}</span></div></div></div><div class=\"col-sm-7\">{{layout.description}}</div></div></uib-accordion-heading><a print-remove=\"\" href=\"\" class=\"btn btn-default btn-xs\" ng-click=\"swotCtrl.add(layout.key)\"><i class=\"glyphicon glyphicon-plus\">Add</i></a><table class=\"table scrolling-table\" id=\"swot_{{layout.key}}_table_id\" print-section=\"\"><thead><tr fsm-sticky-header=\"\" scroll-body=\"\'#swot_\' + layout.key + \'_table_id\'\" scroll-stop=\"swotCtrl.getScrollStop()\"><th>Priority</th><th>Element</th><th>Division</th><th print-remove=\"\">&nbsp;</th></tr></thead><tbody ui-sortable=\"swotCtrl.sortableOptions[layout.key]\" ng-model=\"swotCtrl.collections[layout.key]\"><tr ng-repeat=\"element in swotCtrl.collections[layout.key]\" id=\"{{element.id}}\"><td class=\"priority myHandle text-center\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\" ng-class=\"{ready_to_drag: hover}\"><span ng-switch=\"\" on=\"element.priority\"><i class=\"glyphicon glyphicon-move\" ng-switch-when=\"0\">&nbsp;</i> <span ng-switch-default=\"\">{{element.priority}}</span></span></td><td><div class=\"popover-wrapper\"><a href=\"#\" editable-textarea=\"element.description\" onbeforesave=\"swotCtrl.update(layout.key, element, \'description\', $data)\"><div uib-tooltip=\"{{element.description}}\" tooltip-placement=\"top-left\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"700\">{{ element.description | ifEmpty:\'none\' | limitToEllipses: 100 }}</div></a></div></td><td><div class=\"popover-wrapper pull-left\"><a href=\"#\" editable-select=\"element.division_id\" onbeforesave=\"swotCtrl.update(layout.key, element, \'division_id\', $data)\" e-ng-options=\"d.id as d.name for d in swotCtrl.divisions\">{{ swotCtrl.showDivision(element.division_id) }}</a></div></td><td class=\"extra control\" print-remove=\"\"><div class=\"button-group pull-right comment-container\"><span class=\"btn row-control\" role=\"button\" ng-init=\"commentParent = element; ctrl = swotCtrl; parentType = \'swot\'\" popover-is-open=\"commentParent.commentIsOpen\" uib-popover-template=\"\'app/templates/commentbox/commentbox.html\'\" popover-trigger=\"outsideClick\" popover-placement=\"left\">{{element.comments.length}} <span class=\"glyphicon glyphicon-comment\"></span></span> <a type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Add Objective\" ng-click=\"swotCtrl.newObjective(layout.key, element)\"><span class=\"glyphicon glyphicon-plus\" uib-tooltip=\"New objective\" tooltip-class=\"details-tooltip\" tooltip-popup-delay=\"100\"></span></a> <a type=\"button\" class=\"btn btn-default btn-xs\" aria-label=\"Delete Swot\" ng-click=\"swotCtrl.confirmRemove(layout.key, element)\"><span class=\"glyphicon glyphicon-trash\"></span></a></div></td></tr></tbody></table></uib-accordion-group></uib-accordion></div></div>");
$templateCache.put("app/components/textFilterBox/filter.html","<div class=\"input-group search-box\"><span class=\"input-group-addon\"><div class=\"glyphicon glyphicon-search\"></div></span> <input type=\"text\" class=\"form-control\" ng-model=\"ngModel\" placeholder=\"search\" autofocus=\"\"> <a class=\"clear-filter\" ng-click=\"ngModel = \'\'\"><span class=\"glyphicon glyphicon-remove\"></span></a></div>");
$templateCache.put("app/components/user-settings/user-settings.html","<div class=\"row\"><div class=\"col-sm-12\"><form class=\"form-horizontal\" id=\"user-settings-form\"><fieldset><legend>Edit User Info</legend><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"name\">Full Name</label><div class=\"col-md-4\"><input id=\"name\" name=\"name\" type=\"text\" ng-model=\"u_settings.user.name\" placeholder=\"Name\" class=\"form-control input-md\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"email\">Email</label><div class=\"col-md-4\"><input id=\"email\" name=\"email\" type=\"text\" ng-model=\"u_settings.user.email\" placeholder=\"Email Address\" class=\"form-control input-md\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"password\">Password</label><div class=\"col-md-4\"><input auto-select=\"\" id=\"password\" name=\"password\" type=\"password\" ng-model=\"u_settings.user.password\" placeholder=\"Password\" class=\"form-control input-md\" ng-class=\"{\'invalid\': u_settings.user.password != u_settings.user.password2}\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"password2\">Confirm Password</label><div class=\"col-md-4\"><input auto-select=\"\" id=\"password2\" name=\"password2\" type=\"password\" ng-model=\"u_settings.user.password2\" placeholder=\"Confirm Password\" class=\"form-control input-md\" ng-class=\"{\'invalid\': u_settings.user.password != u_settings.user.password2}\"></div></div><div ng-if=\"!u_settings.token_based_session_timeout\" class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"existing_password\">Existing Password</label><div class=\"col-md-4\"><input auto-select=\"\" id=\"existing_password\" name=\"existing_password\" type=\"password\" ng-model=\"u_settings.user.existing_password\" placeholder=\"Existing Password\" class=\"form-control input-md\" ng-class=\"{\'invalid\': !u_settings.isExistingValid()}\" ng-disabled=\"u_settings.user.password == u_settings.DEFAULT_PASS\" ng-required=\"u_settings.user.password != u_settings.DEFAULT_PASS\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"title\">Title</label><div class=\"col-md-4\"><input id=\"title\" name=\"title\" type=\"text\" ng-model=\"u_settings.user.title\" placeholder=\"\" disabled=\"\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"division\">Division</label><div class=\"col-md-4\"><input id=\"division\" name=\"division\" type=\"text\" ng-model=\"u_settings.user.division_name\" disabled=\"\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"reports_to\">Report To</label><div class=\"col-md-4\"><input id=\"reports_to\" name=\"reports_to\" type=\"text\" ng-model=\"u_settings.user.reports_to_account_name\" placeholder=\"\" disabled=\"\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"phone\">Phone</label><div class=\"col-md-2\"><input id=\"phone\" name=\"phone\" type=\"text\" ng-model=\"u_settings.user.phone\" placeholder=\"Phone Number\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"address1\">Address</label><div class=\"col-md-4\"><input id=\"address1\" name=\"address1\" type=\"text\" ng-model=\"u_settings.user.address1\" placeholder=\"Street Address\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"address2\">Address2</label><div class=\"col-md-4\"><input id=\"address2\" name=\"address2\" type=\"text\" ng-model=\"u_settings.user.address2\" placeholder=\"Suite\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"city\">City</label><div class=\"col-md-2\"><input id=\"city\" name=\"city\" type=\"text\" ng-model=\"u_settings.user.city\" placeholder=\"City\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"state\">State</label><div class=\"col-md-2\"><input id=\"state\" name=\"state\" type=\"text\" ng-model=\"u_settings.user.state\" placeholder=\"State\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"zip\">Zip</label><div class=\"col-md-1\"><input id=\"zip\" name=\"zip\" type=\"text\" ng-model=\"u_settings.user.zip\" placeholder=\"Zip\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"save\"></label><div class=\"col-md-8\"><button id=\"save\" name=\"save\" class=\"btn btn-success\" ng-disabled=\"!u_settings.canSave()\" ng-click=\"u_settings.save()\">Save</button> <button id=\"cancel\" name=\"cancel\" ng-disabled=\"!u_settings.canCancel()\" ng-click=\"u_settings.cancel()\" class=\"btn btn-warning\">Cancel</button></div></div></fieldset></form></div></div>");
$templateCache.put("app/templates/commentbox/commentbox.html","<div class=\"comment-box\"><ul><li ng-repeat=\"commentId in commentParent.comments\" ng-init=\"comment = ctrl.getComment(parentType, commentId)\" class=\"comment-row\"><div class=\"row\"><div class=\"col-sm-9\"><a href=\"#\" editable-textarea=\"comment.comment\" onbeforesave=\"ctrl.updateComment(parentType, commentParent, commentId, $data)\">{{comment.comment}}</a></div><div class=\"col-sm-3\"><div class=\"text-right\"><a type=\"button\" class=\"btn btn-default btn-xs btn-circle btn-comment-delete\" aria-label=\"Delete Comment\" ng-click=\"ctrl.deleteComment(parentType, commentParent, commentId)\"><span class=\"glyphicon glyphicon-trash\"></span></a></div><div class=\"comment-info\"><div>{{ctrl.getCommentAuthor(comment)}}</div><div>({{comment.created_date | date:\'MM/dd/yyyy\'}})</div></div></div></div></li><li><input type=\"text\" class=\"comment-input\" autofocus=\"\" placeholder=\"enter comment...\" ng-model=\"commentText\" on-escape=\"commentParent.commentIsOpen = false\" on-enter=\"ctrl.addComment(parentType, commentParent, commentText); commentText = \'\'\"></li></ul><script>\n    setTimeout(function() {$(\'.comment-input\').focus();}, 0);\n  </script></div>");
$templateCache.put("app/templates/objectiveViewer/objectiveViewer.html","<div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">Division:</label></div><div class=\"col-sm-8\"><div>{{objective.division.name || objective.objective.division.name}}</div></div></div><div class=\"row\" ng-if=\"objective.objective\"><div class=\"col-sm-4\"><label class=\"pull-right\">Objective:</label></div><div class=\"col-sm-8\"><div>{{objective.objective.priority + \" - \" + objective.objective.description}}</div></div></div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">#:</label></div><div class=\"col-sm-8\"><div>{{objective.priority}}</div></div></div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">Description:</label></div><div class=\"col-sm-8\"><div>{{objective.description}}</div></div></div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">Due date:</label></div><div class=\"col-sm-8\"><div>{{objective.due_date | date:\'MM/dd/yyyy\'}}</div></div></div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">Updated due date:</label></div><div class=\"col-sm-8\"><div>{{objective.update_due_date | date:\'MM/dd/yyyy\'}}</div></div></div><div class=\"row\"><div class=\"col-sm-4\"><label class=\"pull-right\">Completed date:</label></div><div class=\"col-sm-8\"><div>{{objective.complete_date | date:\'MM/dd/yyyy\'}}</div></div></div></div>");
$templateCache.put("app/components/admin-settings/accounts/orgAccounts.html","<div class=\"row\" id=\"org-accounts\"><div class=\"col-sm-4\"><div class=\"row create-new-buffer\"><div class=\"button-group\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"a_settings.createNewUser()\"><i class=\"glyphicon glyphicon-plus\"></i> New User</a> <a class=\"xbtn btn-sm xbtn-primary\" aria-label=\"Org Chart\" ui-sref=\"orgchart\">Org Chart</a></div></div><div class=\"row\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div><div class=\"row collection-holder\"><div class=\"scroll-list\" ng-style=\"{\'max-height\': a_settings.editorHeight }\"><div class=\"list-group\"><a class=\"list-group-item\" ng-click=\"a_settings.setActive(account)\" ng-class=\"{active: a_settings.isActive(account)}\" ng-repeat=\"account in a_settings.accounts | filter:filterText\">{{account.name}}</a></div></div></div></div><div class=\"col-sm-7\" ng-class=\"{\'disabled_block\': !a_settings.isEditorVisible()}\"><form class=\"form-horizontal\"><fieldset><legend>Edit User Info</legend><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"name\">Full Name</label><div class=\"col-md-6\"><input id=\"name\" name=\"name\" type=\"text\" ng-model=\"a_settings.currentAccount.name\" placeholder=\"Name\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"email\">Email</label><div class=\"col-md-6\"><input id=\"email\" name=\"email\" type=\"text\" ng-model=\"a_settings.currentAccount.email\" placeholder=\"Email\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"username\">Username</label><div class=\"col-md-6\"><input valid-username=\"\" id=\"username\" name=\"username\" type=\"text\" ng-model=\"a_settings.currentAccount.username\" placeholder=\"Username\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"title\">Title</label><div class=\"col-md-6\"><input id=\"title\" name=\"title\" type=\"text\" ng-model=\"a_settings.currentAccount.title\" placeholder=\"Title\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"phone\">Phone</label><div class=\"col-md-4\"><input id=\"phone\" name=\"phone\" type=\"text\" ng-model=\"a_settings.currentAccount.phone\" placeholder=\"Phone Number\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">Admin Access</label><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-danger\" ng-model=\"a_settings.currentAccount.is_admin\" uib-btn-checkbox=\"\" btn-checkbox-true=\"true\" btn-checkbox-false=\"false\">{{a_settings.isAdminButtonText()}}</button></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"division\">Division</label><div class=\"col-md-6\"><select id=\"division\" class=\"form-control\" ng-model=\"a_settings.selected_division\" ng-options=\"d.name for d in a_settings.divisions track by d.id\"></select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"status\">Status</label><div class=\"col-md-6\"><select id=\"status\" class=\"form-control\" ng-model=\"a_settings.selected_status\" ng-options=\"s.name for s in a_settings.statuses track by s.value\"></select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"reports_to\">Reports to</label><div class=\"col-md-6\"><select id=\"reports_to\" class=\"form-control\" ng-model=\"a_settings.selected_reports_to_account\" ng-options=\"s.name for s in a_settings.accounts track by s.id\"><option value=\"\">None</option></select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"description\">Description</label><div class=\"col-md-6\"><textarea class=\"form-control\" id=\"description\" ng-model=\"a_settings.currentAccount.description\" name=\"description\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"save_id\"></label><div class=\"col-md-8\"><button id=\"save_id\" name=\"save_id\" class=\"btn btn-success\" ng-click=\"a_settings.saveOrNewAction()\">{{a_settings.saveOrNewString()}}</button> <button id=\"cancel_id\" name=\"cancel_id\" class=\"btn btn-warning\" ng-click=\"a_settings.resetEditorFields()\">Cancel</button> <button ng-disabled=\"!a_settings.currentAccount\" ng-click=\"a_settings.confirmRemove(a_settings.currentAccount);\" class=\"btn btn-default\">Remove</button></div></div><div class=\"form-group\" ng-if=\"a_settings.currentAccount.email\"><label class=\"col-md-2 control-label\"></label><div class=\"col-md-8\">Send a {{a_settings.currentAccount.email}} <a href=\"\" ng-click=\"a_settings.sendPasswordReset(\'reset\')\">password reset</a> | <a href=\"\" ng-click=\"a_settings.sendPasswordReset(\'welcome\')\">welcome reset</a></div></div></fieldset></form></div></div>");
$templateCache.put("app/components/admin-settings/company/orgEdit.html","<div id=\"orgedit-container\"><form class=\"form-horizontal\"><fieldset><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"name\">Name</label><div class=\"col-md-4\"><input id=\"name\" name=\"name\" type=\"text\" ng-model=\"e_settings.organization.name\" placeholder=\"Company Name\" class=\"form-control input-md\" required=\"true\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"slug\">Domain</label><div class=\"col-md-4\"><input id=\"slug\" name=\"slug\" type=\"text\" ng-model=\"e_settings.organization.slug\" placeholder=\"\" ng-disabled=\"true\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"address1\">Phone</label><div class=\"col-md-4\"><input id=\"phone\" name=\"phone\" type=\"text\" ng-model=\"e_settings.organization.phone\" placeholder=\"Phone\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"address1\">Address</label><div class=\"col-md-4\"><input id=\"address1\" name=\"address1\" type=\"text\" ng-model=\"e_settings.organization.address1\" placeholder=\"Address\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"address2\">Address2</label><div class=\"col-md-4\"><input id=\"address2\" name=\"address2\" type=\"text\" ng-model=\"e_settings.organization.address2\" placeholder=\"Address2\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"city\">City</label><div class=\"col-md-4\"><input id=\"city\" name=\"city\" type=\"text\" ng-model=\"e_settings.organization.city\" placeholder=\"City\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"state\">State</label><div class=\"col-md-4\"><input id=\"state\" name=\"state\" type=\"text\" ng-model=\"e_settings.organization.state\" placeholder=\"State\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"zip\">Zip</label><div class=\"col-md-2\"><input id=\"zip\" name=\"zip\" type=\"text\" ng-model=\"e_settings.organization.zip\" placeholder=\"Zip\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"description\">Description</label><div class=\"col-md-4\"><textarea class=\"form-control\" id=\"description\" ng-model=\"e_settings.organization.description\" name=\"description\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"save\"></label><div class=\"col-md-8\"><button id=\"save\" name=\"save\" class=\"btn btn-success\" ng-click=\"e_settings.save()\">Save</button> <button id=\"cancel_id\" name=\"cancel_id\" class=\"btn btn-warning\" ng-click=\"e_settings.cancel()\">Cancel</button></div></div></fieldset></form></div>");
$templateCache.put("app/components/admin-settings/divisions/orgDivisions.html","<div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-sm-3\"><div class=\"row create-new-buffer\"><div class=\"button-group\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"d_settings.createDivision()\"><i class=\"glyphicon glyphicon-plus\"></i> New Division</a></div></div><div class=\"row\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div><div class=\"row collection-holder\"><div class=\"scroll-list\" ng-style=\"{\'max-height\': d_settings.editorHeight }\"><div class=\"list-group\"><a class=\"list-group-item\" ng-click=\"d_settings.setActive(division)\" ng-class=\"{active: d_settings.isActive(division)}\" ng-repeat=\"division in d_settings.divisions | filter:filterText\">{{division.name}}</a></div></div></div></div><div class=\"col-sm-8\" ng-class=\"{\'disabled_block\': !d_settings.isEditorVisible()}\"><form class=\"form-horizontal\"><fieldset><legend>{{d_settings.saveOrNewTitle()}} Division</legend><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"name\">Division Name</label><div class=\"col-md-4\"><input id=\"name\" name=\"name\" type=\"text\" placeholder=\"Name\" ng-model=\"d_settings.currentDivision.name\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"status\">Status</label><div class=\"col-md-4\"><select id=\"status\" class=\"form-control\" ng-model=\"d_settings.selected_status\" ng-options=\"d.name for d in d_settings.statuses track by d.value\"></select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"save_id\"></label><div class=\"col-md-8\"><button id=\"save_id\" name=\"save_id\" class=\"btn btn-success\" ng-click=\"d_settings.saveOrNewAction()\">{{d_settings.saveOrNewString()}}</button> <button id=\"cancel_id\" name=\"cancel_id\" class=\"btn btn-warning\" ng-click=\"d_settings.cancelAction()\">Cancel</button> <button ng-disabled=\"!d_settings.currentDivision\" ng-click=\"d_settings.confirmRemove(d_settings.currentDivision);\" class=\"btn btn-default\">Remove</button></div></div></fieldset></form></div></div>");
$templateCache.put("app/components/admin-settings/instance-settings/instanceSettings.html","<div class=\"row\" id=\"instance_settings\"><div class=\"col-sm-12\"><form class=\"form-horizontal\"><fieldset><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"name\">About Link</label><div class=\"col-md-8\"><input id=\"name\" name=\"name\" type=\"text\" placeholder=\"About URL\" ng-model=\"settings.settings.about_url\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"instance_logo_url\">Instance Logo</label><div class=\"col-md-8\"><input id=\"instance_logo_url\" name=\"instance_logo_url\" type=\"text\" placeholder=\"Instance Logo URL\" ng-model=\"settings.settings.instance_logo_url\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"email_sender\">Email Sender Address</label><div class=\"col-md-8\"><input id=\"email_sender\" name=\"email_sender\" type=\"text\" placeholder=\"Email Sender Address\" ng-model=\"settings.settings.email_sender_address\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"forgot_email_html\">Forgot Email (HTML)</label><div class=\"col-md-8\"><textarea id=\"forgot_email_html\" name=\"forgot_email_html\" placeholder=\"Type in the HTML you wish to send when a user forgets their email\" ng-model=\"settings.settings.forgot_template_html\" class=\"form-control input-md\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"forgot_email_text\">Forgot Email (Text)</label><div class=\"col-md-8\"><textarea id=\"forgot_email_text\" name=\"forgot_email_text\" placeholder=\"Type in the TEXT you wish to send when a user forgets their email\" ng-model=\"settings.settings.forgot_template_text\" class=\"form-control input-md\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"welcome_template_html\">Welcome Email (HTML)</label><div class=\"col-md-8\"><textarea id=\"welcome_template_html\" name=\"welcome_template_html\" placeholder=\"Type in the HTML you wish to send when an Admin User is sent their initial password reset\" ng-model=\"settings.settings.welcome_template_html\" class=\"form-control input-md\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"welcome_template_text\">Welcome Email (Text)</label><div class=\"col-md-8\"><textarea id=\"welcome_template_text\" name=\"welcome_template_text\" placeholder=\"Type in the TEXT you wish to send when an Admin User is sent their initial password reset\" ng-model=\"settings.settings.welcome_template_text\" class=\"form-control input-md\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"welcome_template_text\">Forgot Password Life</label><div class=\"col-md-4\"><select id=\"forgot_password_life\" class=\"form-control\" ng-model=\"settings.selected_forgot_password_life\" ng-options=\"d.name for d in settings.time_options track by d.value\"></select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"welcome_template_text\">Welcome Password Life</label><div class=\"col-md-4\"><select id=\"welcome_password_life\" class=\"form-control\" ng-model=\"settings.selected_welcome_password_life\" ng-options=\"d.name for d in settings.time_options track by d.value\"></select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\" for=\"save_id\"></label><div class=\"col-md-8\"><button id=\"save_id\" name=\"save_id\" class=\"btn btn-success\" ng-click=\"settings.save()\">Save</button> <button id=\"cancel_id\" name=\"cancel_id\" class=\"btn btn-warning\" ng-click=\"settings.cancel()\">Cancel</button></div></div></fieldset></form></div></div>");
$templateCache.put("app/components/admin-settings/tenants/tenants.html","<div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-sm-3\"><div class=\"row create-new-buffer\"><div class=\"button-group\"><a href=\"\" class=\"btn btn-sm btn-default\" ng-click=\"tenants.createTenant()\"><i class=\"glyphicon glyphicon-plus\"></i> New Organization</a></div></div><div class=\"row\"><text-filter-box ng-model=\"filterText\"></text-filter-box></div><div class=\"row collection-holder\"><div class=\"scroll-list\" ng-style=\"{\'max-height\': tenants.editorHeight }\"><div class=\"list-group\"><a class=\"list-group-item\" ng-click=\"tenants.selectTenant(t)\" ng-class=\"{active: tenants.isActive(t)}\" ng-repeat=\"t in tenants.tenants| filter:filterText\">{{t.organization_slug}}</a></div></div></div></div><div class=\"col-sm-8\" ng-class=\"{\'disabled_block\': !tenants.isEditorVisible()}\"><form class=\"form-horizontal\"><fieldset><legend>Edit Organization</legend><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"name\">Name</label><div class=\"col-md-5\"><input id=\"name\" name=\"schema\" type=\"text\" ng-model=\"tenants.currentCompany.name\" placeholder=\"Organization Name\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"organization_slug\">Domain</label><div class=\"col-md-5\"><input id=\"organization_slug\" name=\"organization_slug\" type=\"text\" ng-model=\"tenants.currentTenant.organization_slug\" ng-trim=\"false\" slugify=\"\" placeholder=\"Short name\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"status\">Status</label><div class=\"col-md-5\"><select id=\"status\" class=\"form-control\" ng-model=\"tenants.selected_status\" ng-options=\"d.name for d in tenants.statuses track by d.value\"></select></div></div><div ng-hide=\"tenants.currentTenant.id\" class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"email\">Email</label><div class=\"col-md-5\"><input id=\"email\" name=\"email\" type=\"text\" ng-model=\"tenants.currentAdmin.email\" placeholder=\"Admin Email\" class=\"form-control input-md\"></div></div><div ng-hide=\"tenants.currentTenant.id\" class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"username\">Username</label><div class=\"col-md-5\"><input valid-username=\"\" id=\"username\" name=\"username\" type=\"text\" ng-model=\"tenants.currentAdmin.username\" placeholder=\"Admin Username\" class=\"form-control input-md\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"save_id\"></label><div class=\"col-md-8\"><button ng-disabled=\"!tenants.canSaveOrNew()\" id=\"save_id\" name=\"save_id\" class=\"btn btn-success\" ng-click=\"tenants.saveOrNewAction()\">{{tenants.saveOrNewString()}}</button> <button ng-disabled=\"!tenants.canCancel()\" id=\"cancel_id\" name=\"cancel_id\" class=\"btn btn-warning\" ng-click=\"tenants.cancelAction()\">Cancel</button> <button ng-disabled=\"!tenants.canRemove()\" ng-click=\"tenants.confirmRemove();\" class=\"btn btn-default\">Remove</button></div></div><div ng-hide=\"!tenants.currentTenant.id\" class=\"form-group\"><label class=\"col-md-2 control-label\" for=\"switch\"></label><div class=\"col-md-5\"><a href=\"\" id=\"switch\" ng-click=\"tenants.switchToThisTenant()\">Switch to {{tenants.currentCompany.name}}</a></div></div></fieldset></form></div></div>");
$templateCache.put("app/components/admin-settings/uploads/orgUploads.html","<div id=\"logo-upload-container\"><form name=\"companyLogo\" class=\"form-horizontal\"><fieldset><div class=\"form-group\"><label for=\"logo-input\" class=\"control-label col-md-2\">Logo</label><div class=\"col-md-8\"><div class=\"thumb-container\"><div ng-hide=\"ul_settings.orgLogoFile.type === \'remove\'\"><img ng-show=\"ul_settings.orgLogoFile.type === \'\'\" ngf-thumbnail=\"ul_settings.orgLogo\" class=\"thumb\" onerror=\"this.onerror=null;this.src=\'/assets/images/default-company-logo.jpg\';\"> <img ng-show=\"ul_settings.orgLogoFile.type !== \'\'\" ngf-thumbnail=\"ul_settings.orgLogoFile\" class=\"thumb\"></div></div><input id=\"logo-input\" type=\"file\" ngf-select=\"\" ng-model=\"ul_settings.orgLogoFile\" name=\"file\" accept=\"image/*\" ngf-max-size=\"2MB\" ngf-model-invalid=\"errorFiles\"><div class=\"row logo-button-container\"><div class=\"col-md-8\"><button ng-click=\"ul_settings.uploadLogo(ul_settings.orgLogoFile)\" ng-disabled=\"ul_settings.orgLogoFile.type === \'\'\" class=\"btn btn-success\">Save Logo</button> <button ng-click=\"ul_settings.removeOrgLogo();\" class=\"btn btn-default\">Remove</button></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"progress\" ng-show=\"ul_settings.orgLogoFile.progress >= 0\"><div style=\"width:{{ul_settings.orgLogoFile.progress}}%\" ng-bind=\"ul_settings.orgLogoFile.progress + \'%\'\"></div></div><div ng-show=\"companyLogo.file.$error.required\">*required</div><div ng-show=\"companyLogo.file.$error.maxSize\">File too large {{errorFiles[0].size / 1000000|number:1}}MB: max 2M</div><span ng-show=\"!ul_settings.errorMsg && ul_settings.orgLogoFile.result\">Upload Successful</span> <span class=\"err\" ng-show=\"ul_settings.errorMsg\">{{ul_settings.errorMsg}}</span></div></div></div></div></fieldset></form></div>");
$templateCache.put("app/components/auth/forgot-password/forgot.html","<div id=\"forgot-password-page\" class=\"container-fluid\"><div class=\"omb_login\"><div class=\"row omb_row-sm-offset-3\"><div class=\"col-xs-12 col-sm-6\"><form class=\"omb_loginForm\" autocomplete=\"off\" method=\"POST\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-sitemap\"></i></span> <input type=\"text\" class=\"form-control\" ng-model=\"forgot.org\" name=\"org\" placeholder=\"Enter Your Organization\" required=\"\"></div><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-envelope\"></i></span> <input type=\"text\" class=\"form-control\" ng-model=\"forgot.email\" id=\"email\" name=\"email\" placeholder=\"Enter Your Email\" required=\"\"></div><button class=\"btn btn-lg btn-success btn-block\" ng-disabled=\"forgot.fieldsNotReady()\" ng-click=\"forgot.forgotAction()\">Send Reset</button></form></div></div><div ng-if=\"forgot.email_sent\" class=\"row omb_row-sm-offset-3\"><div class=\"col-xs-12 col-sm-6\"><div class=\"alert alert-info\">Your request has been sent! Please check your email for a reset link. If it doesn\'t show up soon, check your trash or spam.</div></div></div></div></div>");
$templateCache.put("app/components/auth/login/login.html","<div class=\"container-fluid\"><div class=\"omb_login\"><h3 class=\"omb_authTitle\">Login</h3><div class=\"row omb_row-sm-offset-3\"><div class=\"col-xs-12 col-sm-6\"><form class=\"omb_loginForm\" disabled_ng-submit=\"login.loginAction()\" autocomplete=\"off\" method=\"POST\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-sitemap\"></i></span> <input type=\"text\" class=\"form-control\" ng-model=\"login.organization_slug\" name=\"organization_slug\" placeholder=\"Enter Your Organization\" required=\"\"></div><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-user\"></i></span> <input type=\"text\" class=\"form-control\" ng-model=\"login.username\" name=\"username\" placeholder=\"Enter Your Username\" required=\"\"></div><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-lock\"></i></span> <input type=\"password\" class=\"form-control\" ng-model=\"login.password\" name=\"password\" placeholder=\"Password\"></div><span ng-show=\"login.loginError\" class=\"help-block\">{{login.loginError}}</span> <button class=\"btn btn-lg btn-success btn-block\" ng-disabled=\"login.fieldsNotReady()\" ng-click=\"login.loginAction()\">Login</button></form><a href=\"\" ui-sref=\"forgot-password\">Forgot Password?</a></div></div><div class=\"row omb_row-sm-offset-3\"></div></div></div>");
$templateCache.put("app/components/auth/login-with-token/token-login.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"row\"><h4 class=\"text-center\">{{token.title}}</h4></div><div class=\"row\"><div class=\"alert alert-danger\">{{token.error}}</div></div></div><div class=\"col-md-2\"></div></div></div>");}]);